var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-card",
    { class: _vm.embedded ? "" : "ma-5", attrs: { flat: "" } },
    [
      _c(
        "v-card-text",
        { class: _vm.embedded ? "pa-0" : "" },
        [
          _vm.loading
            ? _c(
                "div",
                { staticClass: "d-flex justify-center align-center py-12" },
                [
                  _c("v-progress-circular", {
                    attrs: { indeterminate: "", color: "primary" },
                  }),
                ],
                1
              )
            : [
                _c(
                  "div",
                  {
                    staticClass: "ticketing-toolbar mb-3",
                    class: { "ticketing-toolbar--desktop": !_vm.isMobile },
                  },
                  [
                    _c(
                      "div",
                      {
                        staticClass:
                          "ticketing-toolbar__row ticketing-toolbar__filters d-flex align-center flex-wrap",
                        staticStyle: { gap: "8px" },
                      },
                      [
                        _c(
                          "v-btn-toggle",
                          {
                            staticClass: "ticketing-filter-toggle",
                            attrs: {
                              mandatory: "",
                              dense: "",
                              color: "primary",
                              group: "",
                            },
                            model: {
                              value: _vm.filterTab,
                              callback: function ($$v) {
                                _vm.filterTab = $$v
                              },
                              expression: "filterTab",
                            },
                          },
                          [
                            _c(
                              "v-btn",
                              { attrs: { small: "", value: "active" } },
                              [
                                _vm._v(
                                  " " +
                                    _vm._s(_vm.$t("ticketing.active")) +
                                    " (" +
                                    _vm._s(_vm.counts.active) +
                                    ") "
                                ),
                                _vm.tabsWithUnseenMentions.active
                                  ? _c(
                                      "v-icon",
                                      {
                                        staticClass: "ml-1",
                                        attrs: {
                                          "x-small": "",
                                          color: "amber darken-2",
                                        },
                                      },
                                      [_vm._v("mdi-circle")]
                                    )
                                  : _vm._e(),
                              ],
                              1
                            ),
                            _c(
                              "v-btn",
                              { attrs: { small: "", value: "mine" } },
                              [
                                _vm._v(
                                  " " +
                                    _vm._s(_vm.$t("ticketing.mine")) +
                                    " (" +
                                    _vm._s(_vm.counts.mine) +
                                    ") "
                                ),
                                _vm.tabsWithUnseenMentions.mine
                                  ? _c(
                                      "v-icon",
                                      {
                                        staticClass: "ml-1",
                                        attrs: {
                                          "x-small": "",
                                          color: "amber darken-2",
                                        },
                                      },
                                      [_vm._v("mdi-circle")]
                                    )
                                  : _vm._e(),
                              ],
                              1
                            ),
                            _c(
                              "v-btn",
                              { attrs: { small: "", value: "mentioned" } },
                              [
                                _vm._v(
                                  " " +
                                    _vm._s(_vm.$t("ticketing.mentioned")) +
                                    " (" +
                                    _vm._s(_vm.counts.mentioned) +
                                    ") "
                                ),
                                _vm.mentionedHasUnseen
                                  ? _c(
                                      "v-icon",
                                      {
                                        staticClass: "ml-1",
                                        attrs: {
                                          "x-small": "",
                                          color: "amber darken-2",
                                        },
                                      },
                                      [_vm._v(" mdi-circle ")]
                                    )
                                  : _vm._e(),
                              ],
                              1
                            ),
                            _c(
                              "v-btn",
                              { attrs: { small: "", value: "watching" } },
                              [
                                _vm._v(
                                  " " +
                                    _vm._s(_vm.$t("ticketing.watching")) +
                                    " (" +
                                    _vm._s(_vm.counts.watching) +
                                    ") "
                                ),
                                _vm.tabsWithUnseenMentions.watching
                                  ? _c(
                                      "v-icon",
                                      {
                                        staticClass: "ml-1",
                                        attrs: {
                                          "x-small": "",
                                          color: "amber darken-2",
                                        },
                                      },
                                      [_vm._v("mdi-circle")]
                                    )
                                  : _vm._e(),
                              ],
                              1
                            ),
                            _c(
                              "v-btn",
                              { attrs: { small: "", value: "urgent" } },
                              [
                                _vm._v(
                                  " " +
                                    _vm._s(_vm.$t("ticketing.urgent")) +
                                    " (" +
                                    _vm._s(_vm.counts.urgent) +
                                    ") "
                                ),
                                _vm.tabsWithUnseenMentions.urgent
                                  ? _c(
                                      "v-icon",
                                      {
                                        staticClass: "ml-1",
                                        attrs: {
                                          "x-small": "",
                                          color: "amber darken-2",
                                        },
                                      },
                                      [_vm._v("mdi-circle")]
                                    )
                                  : _vm._e(),
                              ],
                              1
                            ),
                            _c(
                              "v-btn",
                              {
                                class: {
                                  "red--text": _vm.counts.unassigned > 0,
                                },
                                attrs: { small: "", value: "unassigned" },
                              },
                              [
                                _vm._v(
                                  " " +
                                    _vm._s(_vm.$t("ticketing.unassigned")) +
                                    " (" +
                                    _vm._s(_vm.counts.unassigned) +
                                    ") "
                                ),
                                _vm.tabsWithUnseenMentions.unassigned
                                  ? _c(
                                      "v-icon",
                                      {
                                        staticClass: "ml-1",
                                        attrs: {
                                          "x-small": "",
                                          color: "amber darken-2",
                                        },
                                      },
                                      [_vm._v("mdi-circle")]
                                    )
                                  : _vm._e(),
                              ],
                              1
                            ),
                            _c(
                              "v-btn",
                              {
                                class: {
                                  "red--text": _vm.counts.needsSupport > 0,
                                },
                                attrs: { small: "", value: "needs-support" },
                              },
                              [
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      _vm.$t(
                                        "ticketing.status.needs-support-action"
                                      )
                                    ) +
                                    " (" +
                                    _vm._s(_vm.counts.needsSupport) +
                                    ") "
                                ),
                                _vm.tabsWithUnseenMentions.needsSupport
                                  ? _c(
                                      "v-icon",
                                      {
                                        staticClass: "ml-1",
                                        attrs: {
                                          "x-small": "",
                                          color: "amber darken-2",
                                        },
                                      },
                                      [_vm._v("mdi-circle")]
                                    )
                                  : _vm._e(),
                              ],
                              1
                            ),
                            _c(
                              "v-btn",
                              { attrs: { small: "", value: "hardware" } },
                              [
                                _vm._v(
                                  " " +
                                    _vm._s(_vm.$t("ticketing.type.hardware")) +
                                    " (" +
                                    _vm._s(_vm.counts.hardware) +
                                    ") "
                                ),
                                _vm.tabsWithUnseenMentions.hardware
                                  ? _c(
                                      "v-icon",
                                      {
                                        staticClass: "ml-1",
                                        attrs: {
                                          "x-small": "",
                                          color: "amber darken-2",
                                        },
                                      },
                                      [_vm._v("mdi-circle")]
                                    )
                                  : _vm._e(),
                              ],
                              1
                            ),
                            _c(
                              "v-btn",
                              { attrs: { small: "", value: "porting" } },
                              [
                                _vm._v(
                                  " " +
                                    _vm._s(_vm.$t("ticketing.type.porting")) +
                                    " (" +
                                    _vm._s(_vm.counts.porting) +
                                    ") "
                                ),
                                _vm.tabsWithUnseenMentions.porting
                                  ? _c(
                                      "v-icon",
                                      {
                                        staticClass: "ml-1",
                                        attrs: {
                                          "x-small": "",
                                          color: "amber darken-2",
                                        },
                                      },
                                      [_vm._v("mdi-circle")]
                                    )
                                  : _vm._e(),
                              ],
                              1
                            ),
                            _c(
                              "v-btn",
                              { attrs: { small: "", value: "resolved" } },
                              [
                                _vm._v(
                                  " " +
                                    _vm._s(_vm.$t("ticketing.resolved")) +
                                    " (" +
                                    _vm._s(_vm.counts.resolved) +
                                    ") "
                                ),
                                _vm.tabsWithUnseenMentions.resolved
                                  ? _c(
                                      "v-icon",
                                      {
                                        staticClass: "ml-1",
                                        attrs: {
                                          "x-small": "",
                                          color: "amber darken-2",
                                        },
                                      },
                                      [_vm._v("mdi-circle")]
                                    )
                                  : _vm._e(),
                              ],
                              1
                            ),
                            _c(
                              "v-btn",
                              { attrs: { small: "", value: "all" } },
                              [
                                _vm._v(
                                  " " +
                                    _vm._s(_vm.$t("ticketing.all")) +
                                    " (" +
                                    _vm._s(_vm.tickets.length) +
                                    ") "
                                ),
                                _vm.tabsWithUnseenMentions.all
                                  ? _c(
                                      "v-icon",
                                      {
                                        staticClass: "ml-1",
                                        attrs: {
                                          "x-small": "",
                                          color: "amber darken-2",
                                        },
                                      },
                                      [_vm._v("mdi-circle")]
                                    )
                                  : _vm._e(),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "div",
                      {
                        staticClass:
                          "ticketing-toolbar__row ticketing-toolbar__row--secondary d-flex align-center flex-wrap",
                        staticStyle: { gap: "8px" },
                      },
                      [
                        _c("v-text-field", {
                          staticStyle: {
                            "max-width": "480px",
                            flex: "1 1 320px",
                          },
                          attrs: {
                            placeholder: _vm.$t("search") + "...",
                            "prepend-inner-icon": "mdi-magnify",
                            "hide-details": "",
                            dense: "",
                            outlined: "",
                            clearable: "",
                          },
                          model: {
                            value: _vm.search,
                            callback: function ($$v) {
                              _vm.search = $$v
                            },
                            expression: "search",
                          },
                        }),
                        _c("v-autocomplete", {
                          class: { "ml-3": !_vm.$vuetify.breakpoint.xs },
                          staticStyle: { "max-width": "280px" },
                          attrs: {
                            items: _vm.organizationItems,
                            "item-text": "text",
                            "item-value": "value",
                            filter: _vm.filterOrganization,
                            label: _vm.$t("ticketing.organization"),
                            "hide-details": "",
                            dense: "",
                            outlined: "",
                            clearable: "",
                          },
                          scopedSlots: _vm._u([
                            {
                              key: "item",
                              fn: function ({ item }) {
                                return [
                                  _c(
                                    "v-list-item-content",
                                    [
                                      _c("v-list-item-title", [
                                        _vm._v(_vm._s(item.text)),
                                      ]),
                                      _c(
                                        "v-list-item-subtitle",
                                        {
                                          staticClass:
                                            "text-caption grey--text",
                                        },
                                        [_vm._v(" " + _vm._s(item.value) + " ")]
                                      ),
                                    ],
                                    1
                                  ),
                                ]
                              },
                            },
                          ]),
                          model: {
                            value: _vm.orgFilter,
                            callback: function ($$v) {
                              _vm.orgFilter = $$v
                            },
                            expression: "orgFilter",
                          },
                        }),
                        _c("v-spacer"),
                        !_vm.$vuetify.breakpoint.xs
                          ? _c(
                              "v-menu",
                              {
                                attrs: {
                                  "offset-y": "",
                                  "close-on-content-click": false,
                                  "max-height": "500",
                                },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "activator",
                                      fn: function ({ on, attrs }) {
                                        return [
                                          _c(
                                            "v-btn",
                                            _vm._g(
                                              _vm._b(
                                                { attrs: { icon: "" } },
                                                "v-btn",
                                                attrs,
                                                false
                                              ),
                                              on
                                            ),
                                            [
                                              _c(
                                                "v-badge",
                                                {
                                                  attrs: {
                                                    value: _vm.unreadCount > 0,
                                                    content: _vm.unreadCount,
                                                    color: "red",
                                                    overlap: "",
                                                  },
                                                },
                                                [
                                                  _c("v-icon", [
                                                    _vm._v("mdi-bell-outline"),
                                                  ]),
                                                ],
                                                1
                                              ),
                                            ],
                                            1
                                          ),
                                        ]
                                      },
                                    },
                                  ],
                                  null,
                                  false,
                                  350006704
                                ),
                                model: {
                                  value: _vm.notifMenuOpen,
                                  callback: function ($$v) {
                                    _vm.notifMenuOpen = $$v
                                  },
                                  expression: "notifMenuOpen",
                                },
                              },
                              [
                                _c("ticketing-notifications-panel", {
                                  attrs: {
                                    notifications: _vm.notifications,
                                    "unread-count": _vm.unreadCount,
                                  },
                                  on: {
                                    "notification-click":
                                      _vm.handleNotificationClick,
                                    "mark-all-read": _vm.markAllRead,
                                    "clear-all": function ($event) {
                                      _vm.clearAllConfirmOpen = true
                                    },
                                    remove: _vm.removeNotification,
                                  },
                                }),
                              ],
                              1
                            )
                          : [
                              _c(
                                "v-btn",
                                {
                                  attrs: { icon: "" },
                                  on: {
                                    click: function ($event) {
                                      _vm.notifMenuOpen = true
                                    },
                                  },
                                },
                                [
                                  _c(
                                    "v-badge",
                                    {
                                      attrs: {
                                        value: _vm.unreadCount > 0,
                                        content: _vm.unreadCount,
                                        color: "red",
                                        overlap: "",
                                      },
                                    },
                                    [
                                      _c("v-icon", [
                                        _vm._v("mdi-bell-outline"),
                                      ]),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                              _c(
                                "v-dialog",
                                {
                                  attrs: {
                                    fullscreen: "",
                                    scrollable: "",
                                    transition: "dialog-bottom-transition",
                                  },
                                  model: {
                                    value: _vm.notifMenuOpen,
                                    callback: function ($$v) {
                                      _vm.notifMenuOpen = $$v
                                    },
                                    expression: "notifMenuOpen",
                                  },
                                },
                                [
                                  _c("ticketing-notifications-panel", {
                                    attrs: {
                                      notifications: _vm.notifications,
                                      "unread-count": _vm.unreadCount,
                                      mobile: "",
                                    },
                                    on: {
                                      "notification-click":
                                        _vm.handleNotificationClick,
                                      "mark-all-read": _vm.markAllRead,
                                      "clear-all": function ($event) {
                                        _vm.clearAllConfirmOpen = true
                                      },
                                      remove: _vm.removeNotification,
                                      close: function ($event) {
                                        _vm.notifMenuOpen = false
                                      },
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                        _c(
                          "v-btn",
                          {
                            staticClass: "ml-3",
                            attrs: { color: "primary", small: "" },
                            on: {
                              click: function ($event) {
                                return _vm.openQuickAdd()
                              },
                            },
                          },
                          [
                            _c("v-icon", { attrs: { left: "", small: "" } }, [
                              _vm._v("mdi-plus"),
                            ]),
                            _vm._v(
                              " " + _vm._s(_vm.$t("ticketing.new-ticket")) + " "
                            ),
                          ],
                          1
                        ),
                      ],
                      2
                    ),
                  ]
                ),
                _c(
                  "div",
                  { class: { "ticketing-table-wrap": !_vm.isMobile } },
                  [
                    !_vm.isMobile
                      ? _c("v-data-table", {
                          staticClass: "ticketing-table",
                          attrs: {
                            headers: _vm.headers,
                            items: _vm.filteredTickets,
                            "items-per-page": -1,
                            "footer-props": {
                              "items-per-page-options": [10, 15, 25, 50, -1],
                            },
                            "sort-by": _vm.sortBy,
                            "sort-desc": _vm.sortDesc,
                            "item-class": _vm.rowClass,
                            dense: "",
                          },
                          on: {
                            "update:sortBy": function ($event) {
                              _vm.sortBy = $event
                            },
                            "update:sort-by": function ($event) {
                              _vm.sortBy = $event
                            },
                            "update:sortDesc": function ($event) {
                              _vm.sortDesc = $event
                            },
                            "update:sort-desc": function ($event) {
                              _vm.sortDesc = $event
                            },
                            "click:row": _vm.openTicket,
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "item.__indicators",
                                fn: function ({ item }) {
                                  return [
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "d-flex align-center indicators-cell",
                                      },
                                      [
                                        _vm.hasUnseenMentions(item)
                                          ? _c(
                                              "v-tooltip",
                                              {
                                                attrs: { bottom: "" },
                                                scopedSlots: _vm._u(
                                                  [
                                                    {
                                                      key: "activator",
                                                      fn: function ({
                                                        on,
                                                        attrs,
                                                      }) {
                                                        return [
                                                          _c(
                                                            "v-icon",
                                                            _vm._g(
                                                              _vm._b(
                                                                {
                                                                  staticClass:
                                                                    "unread-dot flex-shrink-0",
                                                                  attrs: {
                                                                    "x-small":
                                                                      "",
                                                                    color:
                                                                      "amber darken-2",
                                                                  },
                                                                },
                                                                "v-icon",
                                                                attrs,
                                                                false
                                                              ),
                                                              on
                                                            ),
                                                            [
                                                              _vm._v(
                                                                " mdi-circle "
                                                              ),
                                                            ]
                                                          ),
                                                        ]
                                                      },
                                                    },
                                                  ],
                                                  null,
                                                  true
                                                ),
                                              },
                                              [
                                                _c("span", [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.$t(
                                                        "ticketing.unseen-mention"
                                                      )
                                                    )
                                                  ),
                                                ]),
                                              ]
                                            )
                                          : _vm._e(),
                                        _vm.hasUnseenMessages(item)
                                          ? _c(
                                              "v-tooltip",
                                              {
                                                attrs: { bottom: "" },
                                                scopedSlots: _vm._u(
                                                  [
                                                    {
                                                      key: "activator",
                                                      fn: function ({
                                                        on,
                                                        attrs,
                                                      }) {
                                                        return [
                                                          _c(
                                                            "v-icon",
                                                            _vm._g(
                                                              _vm._b(
                                                                {
                                                                  staticClass:
                                                                    "unread-dot flex-shrink-0",
                                                                  attrs: {
                                                                    "x-small":
                                                                      "",
                                                                    color:
                                                                      "primary",
                                                                  },
                                                                },
                                                                "v-icon",
                                                                attrs,
                                                                false
                                                              ),
                                                              on
                                                            ),
                                                            [
                                                              _vm._v(
                                                                " mdi-circle "
                                                              ),
                                                            ]
                                                          ),
                                                        ]
                                                      },
                                                    },
                                                  ],
                                                  null,
                                                  true
                                                ),
                                              },
                                              [
                                                _c("span", [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.$t(
                                                        "ticketing.unseen-messages"
                                                      )
                                                    )
                                                  ),
                                                ]),
                                              ]
                                            )
                                          : _vm._e(),
                                        _vm.hasUnreadFor(item.id)
                                          ? _c(
                                              "v-icon",
                                              {
                                                staticClass:
                                                  "unread-dot unread-dot--unread flex-shrink-0",
                                                attrs: {
                                                  "x-small": "",
                                                  color: "red",
                                                },
                                              },
                                              [_vm._v(" mdi-circle ")]
                                            )
                                          : _vm._e(),
                                      ],
                                      1
                                    ),
                                  ]
                                },
                              },
                              {
                                key: "item.title",
                                fn: function ({ item }) {
                                  return [
                                    _c(
                                      "div",
                                      { staticClass: "d-flex align-center" },
                                      [
                                        _c(
                                          "span",
                                          {
                                            staticClass: "text-caption",
                                            attrs: { title: item.title },
                                          },
                                          [_vm._v(_vm._s(item.title))]
                                        ),
                                        _vm._l(
                                          _vm.liveViewersForTicket(item),
                                          function (v, vIdx) {
                                            return _c(
                                              "v-tooltip",
                                              {
                                                key: `live-${item.id}-${v.userId}`,
                                                attrs: { bottom: "" },
                                                scopedSlots: _vm._u(
                                                  [
                                                    {
                                                      key: "activator",
                                                      fn: function ({
                                                        on,
                                                        attrs,
                                                      }) {
                                                        return [
                                                          _c(
                                                            "v-avatar",
                                                            _vm._g(
                                                              _vm._b(
                                                                {
                                                                  staticClass:
                                                                    "live-viewer-avatar flex-shrink-0",
                                                                  class:
                                                                    vIdx === 0
                                                                      ? "ml-3"
                                                                      : "ml-1",
                                                                  style: {
                                                                    "--live-color":
                                                                      _vm.userColor(
                                                                        v.userId
                                                                      ),
                                                                  },
                                                                  attrs: {
                                                                    size: "16",
                                                                    color:
                                                                      _vm.userColor(
                                                                        v.userId
                                                                      ),
                                                                  },
                                                                },
                                                                "v-avatar",
                                                                attrs,
                                                                false
                                                              ),
                                                              on
                                                            ),
                                                            [
                                                              _c(
                                                                "span",
                                                                {
                                                                  staticClass:
                                                                    "white--text live-viewer-avatar__initials",
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    _vm._s(
                                                                      _vm.viewerInitials(
                                                                        v.name
                                                                      )
                                                                    )
                                                                  ),
                                                                ]
                                                              ),
                                                            ]
                                                          ),
                                                        ]
                                                      },
                                                    },
                                                  ],
                                                  null,
                                                  true
                                                ),
                                              },
                                              [
                                                _c("span", [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.$t(
                                                        "ticketing.viewing-now",
                                                        {
                                                          name:
                                                            v.name || v.userId,
                                                        }
                                                      )
                                                    )
                                                  ),
                                                ]),
                                              ]
                                            )
                                          }
                                        ),
                                      ],
                                      2
                                    ),
                                  ]
                                },
                              },
                              {
                                key: "item.status",
                                fn: function ({ item }) {
                                  return [
                                    _c(
                                      "span",
                                      { staticClass: "text-caption" },
                                      [
                                        _vm._v(
                                          " " +
                                            _vm._s(
                                              _vm.$t(
                                                `ticketing.status.${item.status}`
                                              )
                                            ) +
                                            " "
                                        ),
                                      ]
                                    ),
                                  ]
                                },
                              },
                              {
                                key: "item.priority",
                                fn: function ({ item }) {
                                  return [
                                    _c(
                                      "span",
                                      {
                                        staticClass:
                                          "text-caption font-weight-medium",
                                        style: {
                                          color: _vm.priorityHex(item.priority),
                                        },
                                      },
                                      [
                                        _vm._v(
                                          " " +
                                            _vm._s(
                                              _vm.priorityEmoji(item.priority)
                                            ) +
                                            "  " +
                                            _vm._s(
                                              _vm.$t(
                                                `ticketing.priority.${item.priority}`
                                              )
                                            ) +
                                            " "
                                        ),
                                      ]
                                    ),
                                  ]
                                },
                              },
                              {
                                key: "item.type",
                                fn: function ({ item }) {
                                  return [
                                    _c(
                                      "span",
                                      { staticClass: "text-caption" },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t(
                                              `ticketing.type.${item.type}`
                                            )
                                          )
                                        ),
                                      ]
                                    ),
                                  ]
                                },
                              },
                              {
                                key: "item.organizationName",
                                fn: function ({ item }) {
                                  return [
                                    _c(
                                      "div",
                                      {
                                        staticClass: "d-flex align-center",
                                        attrs: {
                                          title:
                                            _vm.organizationCellTooltip(item),
                                        },
                                      },
                                      [
                                        _c(
                                          "v-avatar",
                                          {
                                            staticClass: "mr-2 org-logo-avatar",
                                            attrs: { size: "20" },
                                          },
                                          [
                                            _vm.organizationLogo(
                                              item.organizationId
                                            )
                                              ? _c("v-img", {
                                                  attrs: {
                                                    src: _vm.organizationLogo(
                                                      item.organizationId
                                                    ),
                                                  },
                                                })
                                              : _c(
                                                  "v-icon",
                                                  {
                                                    attrs: {
                                                      "x-small": "",
                                                      color: "grey",
                                                    },
                                                  },
                                                  [_vm._v("mdi-domain")]
                                                ),
                                          ],
                                          1
                                        ),
                                        _c(
                                          "span",
                                          {
                                            staticClass:
                                              "text-caption text-truncate",
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(item.organizationName)
                                            ),
                                          ]
                                        ),
                                        _vm.extraOrgCount(item) > 0
                                          ? _c(
                                              "v-tooltip",
                                              {
                                                attrs: { bottom: "" },
                                                scopedSlots: _vm._u(
                                                  [
                                                    {
                                                      key: "activator",
                                                      fn: function ({
                                                        on,
                                                        attrs,
                                                      }) {
                                                        return [
                                                          _c(
                                                            "v-chip",
                                                            _vm._g(
                                                              _vm._b(
                                                                {
                                                                  staticClass:
                                                                    "ml-2 extra-orgs-chip",
                                                                  attrs: {
                                                                    "x-small":
                                                                      "",
                                                                    color:
                                                                      "primary",
                                                                    outlined:
                                                                      "",
                                                                  },
                                                                },
                                                                "v-chip",
                                                                attrs,
                                                                false
                                                              ),
                                                              on
                                                            ),
                                                            [
                                                              _vm._v(
                                                                " +" +
                                                                  _vm._s(
                                                                    _vm.extraOrgCount(
                                                                      item
                                                                    )
                                                                  ) +
                                                                  " "
                                                              ),
                                                            ]
                                                          ),
                                                        ]
                                                      },
                                                    },
                                                  ],
                                                  null,
                                                  true
                                                ),
                                              },
                                              [
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass: "text-caption",
                                                  },
                                                  [
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "font-weight-medium mb-1",
                                                      },
                                                      [
                                                        _vm._v(
                                                          " " +
                                                            _vm._s(
                                                              _vm.$t(
                                                                "ticketing.also-affected",
                                                                {
                                                                  count:
                                                                    _vm.extraOrgCount(
                                                                      item
                                                                    ),
                                                                }
                                                              )
                                                            ) +
                                                            " "
                                                        ),
                                                      ]
                                                    ),
                                                    _vm._l(
                                                      _vm.extraOrgNames(item),
                                                      function (o) {
                                                        return _c(
                                                          "div",
                                                          { key: o },
                                                          [
                                                            _vm._v(
                                                              " • " +
                                                                _vm._s(o) +
                                                                " "
                                                            ),
                                                          ]
                                                        )
                                                      }
                                                    ),
                                                  ],
                                                  2
                                                ),
                                              ]
                                            )
                                          : _vm._e(),
                                      ],
                                      1
                                    ),
                                  ]
                                },
                              },
                              {
                                key: "item.assignedUserName",
                                fn: function ({ item }) {
                                  return [
                                    item.assignedUserName
                                      ? _c(
                                          "div",
                                          {
                                            staticClass: "d-flex align-center",
                                            attrs: {
                                              title: item.assignedUserName,
                                            },
                                          },
                                          [
                                            _c(
                                              "v-avatar",
                                              {
                                                staticClass:
                                                  "mr-2 white--text text-caption",
                                                attrs: {
                                                  size: "20",
                                                  color: _vm.userColor(
                                                    item.assignedUserId
                                                  ),
                                                },
                                              },
                                              [
                                                _vm._v(
                                                  " " +
                                                    _vm._s(
                                                      _vm.viewerInitials(
                                                        item.assignedUserName
                                                      )
                                                    ) +
                                                    " "
                                                ),
                                              ]
                                            ),
                                            _c(
                                              "span",
                                              {
                                                staticClass:
                                                  "text-caption text-truncate",
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(item.assignedUserName)
                                                ),
                                              ]
                                            ),
                                          ],
                                          1
                                        )
                                      : _c(
                                          "span",
                                          { staticClass: "text-caption" },
                                          [_vm._v("-")]
                                        ),
                                  ]
                                },
                              },
                              {
                                key: "item.assignedDevopsNames",
                                fn: function ({ item }) {
                                  return [
                                    _c(
                                      "div",
                                      {
                                        staticClass: "d-flex align-center",
                                        staticStyle: { overflow: "hidden" },
                                      },
                                      [
                                        _vm._l(
                                          (item.assignedDevopsIds || []).slice(
                                            0,
                                            3
                                          ),
                                          function (uid, idx) {
                                            return _c(
                                              "v-tooltip",
                                              {
                                                key: idx,
                                                attrs: { bottom: "" },
                                                scopedSlots: _vm._u(
                                                  [
                                                    {
                                                      key: "activator",
                                                      fn: function ({
                                                        on,
                                                        attrs,
                                                      }) {
                                                        return [
                                                          _c(
                                                            "v-avatar",
                                                            _vm._g(
                                                              _vm._b(
                                                                {
                                                                  staticClass:
                                                                    "mr-1 flex-shrink-0",
                                                                  attrs: {
                                                                    size: "22",
                                                                    color:
                                                                      _vm.userColor(
                                                                        uid
                                                                      ),
                                                                  },
                                                                },
                                                                "v-avatar",
                                                                attrs,
                                                                false
                                                              ),
                                                              on
                                                            ),
                                                            [
                                                              _c(
                                                                "span",
                                                                {
                                                                  staticClass:
                                                                    "white--text text-caption",
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    _vm._s(
                                                                      _vm.initials(
                                                                        _vm.devopsName(
                                                                          uid
                                                                        )
                                                                      )
                                                                    )
                                                                  ),
                                                                ]
                                                              ),
                                                            ]
                                                          ),
                                                        ]
                                                      },
                                                    },
                                                  ],
                                                  null,
                                                  true
                                                ),
                                              },
                                              [
                                                _c("span", [
                                                  _vm._v(
                                                    _vm._s(_vm.devopsName(uid))
                                                  ),
                                                ]),
                                              ]
                                            )
                                          }
                                        ),
                                        (item.assignedDevopsIds || []).length >
                                        3
                                          ? _c(
                                              "v-tooltip",
                                              {
                                                attrs: { bottom: "" },
                                                scopedSlots: _vm._u(
                                                  [
                                                    {
                                                      key: "activator",
                                                      fn: function ({
                                                        on,
                                                        attrs,
                                                      }) {
                                                        return [
                                                          _c(
                                                            "span",
                                                            _vm._g(
                                                              _vm._b(
                                                                {
                                                                  staticClass:
                                                                    "text-caption grey--text",
                                                                },
                                                                "span",
                                                                attrs,
                                                                false
                                                              ),
                                                              on
                                                            ),
                                                            [
                                                              _vm._v(
                                                                "+" +
                                                                  _vm._s(
                                                                    item
                                                                      .assignedDevopsIds
                                                                      .length -
                                                                      3
                                                                  )
                                                              ),
                                                            ]
                                                          ),
                                                        ]
                                                      },
                                                    },
                                                  ],
                                                  null,
                                                  true
                                                ),
                                              },
                                              [
                                                _c("span", [
                                                  _vm._v(
                                                    _vm._s(
                                                      item.assignedDevopsIds
                                                        .slice(3)
                                                        .map(_vm.devopsName)
                                                        .join(", ")
                                                    )
                                                  ),
                                                ]),
                                              ]
                                            )
                                          : _vm._e(),
                                        !item.assignedDevopsIds?.length
                                          ? _c(
                                              "span",
                                              {
                                                staticClass:
                                                  "text-caption grey--text",
                                              },
                                              [_vm._v("-")]
                                            )
                                          : _vm._e(),
                                      ],
                                      2
                                    ),
                                  ]
                                },
                              },
                              {
                                key: "item.watcherIds",
                                fn: function ({ item }) {
                                  return [
                                    _c(
                                      "div",
                                      {
                                        staticClass: "d-flex align-center",
                                        staticStyle: { overflow: "hidden" },
                                      },
                                      [
                                        _vm._l(
                                          (item.watcherIds || []).slice(0, 3),
                                          function (uid, idx) {
                                            return _c(
                                              "v-tooltip",
                                              {
                                                key: idx,
                                                attrs: { bottom: "" },
                                                scopedSlots: _vm._u(
                                                  [
                                                    {
                                                      key: "activator",
                                                      fn: function ({
                                                        on,
                                                        attrs,
                                                      }) {
                                                        return [
                                                          _c(
                                                            "v-avatar",
                                                            _vm._g(
                                                              _vm._b(
                                                                {
                                                                  staticClass:
                                                                    "mr-1 flex-shrink-0",
                                                                  attrs: {
                                                                    size: "22",
                                                                    color:
                                                                      _vm.userColor(
                                                                        uid
                                                                      ),
                                                                  },
                                                                },
                                                                "v-avatar",
                                                                attrs,
                                                                false
                                                              ),
                                                              on
                                                            ),
                                                            [
                                                              _c(
                                                                "span",
                                                                {
                                                                  staticClass:
                                                                    "white--text text-caption",
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    _vm._s(
                                                                      _vm.initials(
                                                                        _vm.devopsName(
                                                                          uid
                                                                        )
                                                                      )
                                                                    )
                                                                  ),
                                                                ]
                                                              ),
                                                            ]
                                                          ),
                                                        ]
                                                      },
                                                    },
                                                  ],
                                                  null,
                                                  true
                                                ),
                                              },
                                              [
                                                _c("span", [
                                                  _vm._v(
                                                    _vm._s(_vm.devopsName(uid))
                                                  ),
                                                ]),
                                              ]
                                            )
                                          }
                                        ),
                                        (item.watcherIds || []).length > 3
                                          ? _c(
                                              "v-tooltip",
                                              {
                                                attrs: { bottom: "" },
                                                scopedSlots: _vm._u(
                                                  [
                                                    {
                                                      key: "activator",
                                                      fn: function ({
                                                        on,
                                                        attrs,
                                                      }) {
                                                        return [
                                                          _c(
                                                            "span",
                                                            _vm._g(
                                                              _vm._b(
                                                                {
                                                                  staticClass:
                                                                    "text-caption grey--text",
                                                                },
                                                                "span",
                                                                attrs,
                                                                false
                                                              ),
                                                              on
                                                            ),
                                                            [
                                                              _vm._v(
                                                                "+" +
                                                                  _vm._s(
                                                                    item
                                                                      .watcherIds
                                                                      .length -
                                                                      3
                                                                  )
                                                              ),
                                                            ]
                                                          ),
                                                        ]
                                                      },
                                                    },
                                                  ],
                                                  null,
                                                  true
                                                ),
                                              },
                                              [
                                                _c("span", [
                                                  _vm._v(
                                                    _vm._s(
                                                      item.watcherIds
                                                        .slice(3)
                                                        .map(_vm.devopsName)
                                                        .join(", ")
                                                    )
                                                  ),
                                                ]),
                                              ]
                                            )
                                          : _vm._e(),
                                        !item.watcherIds?.length
                                          ? _c(
                                              "span",
                                              {
                                                staticClass:
                                                  "text-caption grey--text",
                                              },
                                              [_vm._v("-")]
                                            )
                                          : _vm._e(),
                                      ],
                                      2
                                    ),
                                  ]
                                },
                              },
                              {
                                key: "item.lastFollowUp",
                                fn: function ({ item }) {
                                  return [
                                    _c(
                                      "v-tooltip",
                                      {
                                        attrs: {
                                          bottom: "",
                                          "open-delay": "0",
                                          "content-class":
                                            "follow-up-tooltip-dark",
                                        },
                                        scopedSlots: _vm._u(
                                          [
                                            {
                                              key: "activator",
                                              fn: function ({ on, attrs }) {
                                                return [
                                                  _c(
                                                    "div",
                                                    _vm._g(
                                                      _vm._b(
                                                        {
                                                          staticClass:
                                                            "d-flex align-center text-no-wrap",
                                                          staticStyle: {
                                                            gap: "4px",
                                                          },
                                                        },
                                                        "div",
                                                        attrs,
                                                        false
                                                      ),
                                                      on
                                                    ),
                                                    [
                                                      _vm.ticketFollowUpDisplay(
                                                        item
                                                      ).lastFollowUp
                                                        ? [
                                                            _c(
                                                              "v-icon",
                                                              {
                                                                attrs: {
                                                                  "x-small": "",
                                                                  color:
                                                                    _vm.ticketFollowUpDisplay(
                                                                      item
                                                                    ).isStale
                                                                      ? "red"
                                                                      : undefined,
                                                                },
                                                              },
                                                              [
                                                                _vm._v(
                                                                  _vm._s(
                                                                    _vm.followUpIcon(
                                                                      _vm.ticketFollowUpDisplay(
                                                                        item
                                                                      )
                                                                        .lastFollowUp
                                                                        .method
                                                                    )
                                                                  )
                                                                ),
                                                              ]
                                                            ),
                                                            _c(
                                                              "span",
                                                              {
                                                                staticClass:
                                                                  "text-caption font-weight-medium",
                                                                class: {
                                                                  "red--text":
                                                                    _vm.ticketFollowUpDisplay(
                                                                      item
                                                                    ).isStale,
                                                                },
                                                              },
                                                              [
                                                                _vm._v(
                                                                  " " +
                                                                    _vm._s(
                                                                      _vm.formatTime(
                                                                        _vm.ticketFollowUpDisplay(
                                                                          item
                                                                        )
                                                                          .lastFollowUp
                                                                          .at
                                                                      )
                                                                    ) +
                                                                    " "
                                                                ),
                                                              ]
                                                            ),
                                                          ]
                                                        : _c(
                                                            "span",
                                                            {
                                                              staticClass:
                                                                "text-caption red--text font-weight-medium",
                                                            },
                                                            [
                                                              _vm._v(
                                                                _vm._s(
                                                                  _vm.$t(
                                                                    "ticketing.never-follow-up"
                                                                  )
                                                                )
                                                              ),
                                                            ]
                                                          ),
                                                      _vm.ticketFollowUpEntries(
                                                        item
                                                      ).length > 1
                                                        ? _c(
                                                            "span",
                                                            {
                                                              staticClass:
                                                                "text-caption grey--text",
                                                            },
                                                            [
                                                              _vm._v(
                                                                " (" +
                                                                  _vm._s(
                                                                    _vm.ticketFollowUpFollowedCount(
                                                                      item
                                                                    )
                                                                  ) +
                                                                  "/" +
                                                                  _vm._s(
                                                                    _vm.ticketFollowUpEntries(
                                                                      item
                                                                    ).length
                                                                  ) +
                                                                  ") "
                                                              ),
                                                            ]
                                                          )
                                                        : _vm._e(),
                                                    ],
                                                    2
                                                  ),
                                                ]
                                              },
                                            },
                                          ],
                                          null,
                                          true
                                        ),
                                      },
                                      [
                                        _c(
                                          "div",
                                          _vm._l(
                                            _vm.ticketFollowUpEntries(item),
                                            function (entry) {
                                              return _c(
                                                "div",
                                                {
                                                  key: entry.org.id || "_",
                                                  staticClass: "mb-1",
                                                },
                                                [
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "font-weight-medium",
                                                    },
                                                    [
                                                      _vm._v(
                                                        " " +
                                                          _vm._s(
                                                            entry.org.name ||
                                                              "—"
                                                          ) +
                                                          " "
                                                      ),
                                                    ]
                                                  ),
                                                  entry.lastFollowUp
                                                    ? _c(
                                                        "div",
                                                        {
                                                          class: {
                                                            "red--text":
                                                              _vm.isFollowUpStale(
                                                                entry
                                                                  .lastFollowUp
                                                                  .at
                                                              ),
                                                          },
                                                        },
                                                        [
                                                          _vm._v(
                                                            " " +
                                                              _vm._s(
                                                                _vm.followUpTooltip(
                                                                  entry.lastFollowUp
                                                                )
                                                              ) +
                                                              " "
                                                          ),
                                                        ]
                                                      )
                                                    : _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "red--text",
                                                        },
                                                        [
                                                          _vm._v(
                                                            " " +
                                                              _vm._s(
                                                                _vm.$t(
                                                                  "ticketing.never-follow-up"
                                                                )
                                                              ) +
                                                              " "
                                                          ),
                                                        ]
                                                      ),
                                                ]
                                              )
                                            }
                                          ),
                                          0
                                        ),
                                      ]
                                    ),
                                  ]
                                },
                              },
                              {
                                key: "item.createdAt",
                                fn: function ({ item }) {
                                  return [
                                    _c(
                                      "span",
                                      {
                                        directives: [
                                          {
                                            name: "cursor-tip",
                                            rawName: "v-cursor-tip",
                                            value: _vm.formatTimeAbsolute(
                                              item.createdAt
                                            ),
                                            expression:
                                              "formatTimeAbsolute(item.createdAt)",
                                          },
                                        ],
                                        staticClass: "text-caption",
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(_vm.formatTime(item.createdAt))
                                        ),
                                      ]
                                    ),
                                  ]
                                },
                              },
                              {
                                key: "item.updatedAt",
                                fn: function ({ item }) {
                                  return [
                                    _c(
                                      "span",
                                      {
                                        directives: [
                                          {
                                            name: "cursor-tip",
                                            rawName: "v-cursor-tip",
                                            value: _vm.formatTimeAbsolute(
                                              item.updatedAt
                                            ),
                                            expression:
                                              "formatTimeAbsolute(item.updatedAt)",
                                          },
                                        ],
                                        staticClass: "text-caption",
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(_vm.formatTime(item.updatedAt))
                                        ),
                                      ]
                                    ),
                                  ]
                                },
                              },
                              {
                                key: "item.resolvedOrClosedAt",
                                fn: function ({ item }) {
                                  return [
                                    _vm.resolvedOrClosedAt(item)
                                      ? _c(
                                          "span",
                                          {
                                            directives: [
                                              {
                                                name: "cursor-tip",
                                                rawName: "v-cursor-tip",
                                                value:
                                                  _vm.resolvedOrClosedTooltip(
                                                    item
                                                  ),
                                                expression:
                                                  "resolvedOrClosedTooltip(item)",
                                              },
                                            ],
                                            staticClass: "text-caption",
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.formatTime(
                                                  _vm.resolvedOrClosedAt(item)
                                                )
                                              )
                                            ),
                                          ]
                                        )
                                      : _c(
                                          "span",
                                          {
                                            staticClass:
                                              "text-caption grey--text",
                                          },
                                          [_vm._v("—")]
                                        ),
                                  ]
                                },
                              },
                            ],
                            null,
                            false,
                            3092672009
                          ),
                        })
                      : _vm._e(),
                  ],
                  1
                ),
                _vm.isMobile
                  ? _c(
                      "div",
                      { staticClass: "mobile-ticket-list" },
                      [
                        _vm._l(_vm.filteredTickets, function (item) {
                          return _c(
                            "div",
                            {
                              key: item.id,
                              staticClass: "mobile-ticket-row",
                              class: {
                                "ticket-row--mention":
                                  _vm.hasUnseenMentions(item),
                              },
                              on: {
                                click: function ($event) {
                                  return _vm.openTicket(item)
                                },
                              },
                            },
                            [
                              _c("div", {
                                staticClass: "mobile-ticket-priority",
                                style: {
                                  backgroundColor: _vm.priorityHex(
                                    item.priority
                                  ),
                                },
                              }),
                              _c("div", { staticClass: "mobile-ticket-body" }, [
                                _c(
                                  "div",
                                  { staticClass: "d-flex align-center" },
                                  [
                                    _vm.hasUnseenMentions(item)
                                      ? _c(
                                          "v-icon",
                                          {
                                            staticClass: "unread-dot",
                                            attrs: {
                                              "x-small": "",
                                              color: "amber darken-2",
                                            },
                                          },
                                          [_vm._v(" mdi-circle ")]
                                        )
                                      : _vm._e(),
                                    _vm.hasUnseenMessages(item)
                                      ? _c(
                                          "v-icon",
                                          {
                                            staticClass: "unread-dot",
                                            attrs: {
                                              "x-small": "",
                                              color: "primary",
                                            },
                                          },
                                          [_vm._v(" mdi-circle ")]
                                        )
                                      : _vm._e(),
                                    _vm.hasUnreadFor(item.id)
                                      ? _c(
                                          "v-icon",
                                          {
                                            staticClass:
                                              "unread-dot unread-dot--unread",
                                            attrs: {
                                              "x-small": "",
                                              color: "red",
                                            },
                                          },
                                          [_vm._v(" mdi-circle ")]
                                        )
                                      : _vm._e(),
                                    _c(
                                      "span",
                                      {
                                        staticClass:
                                          "mobile-ticket-title text-truncate",
                                      },
                                      [_vm._v(_vm._s(item.title))]
                                    ),
                                    _vm._l(
                                      _vm.liveViewersForTicket(item),
                                      function (v, vIdx) {
                                        return _c(
                                          "v-avatar",
                                          {
                                            key: `mlive-${item.id}-${v.userId}`,
                                            staticClass:
                                              "live-viewer-avatar flex-shrink-0",
                                            class: vIdx === 0 ? "ml-3" : "ml-1",
                                            style: {
                                              "--live-color": _vm.userColor(
                                                v.userId
                                              ),
                                            },
                                            attrs: {
                                              size: "16",
                                              color: _vm.userColor(v.userId),
                                              title: _vm.$t(
                                                "ticketing.viewing-now",
                                                { name: v.name || v.userId }
                                              ),
                                            },
                                          },
                                          [
                                            _c(
                                              "span",
                                              {
                                                staticClass:
                                                  "white--text live-viewer-avatar__initials",
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.viewerInitials(v.name)
                                                  )
                                                ),
                                              ]
                                            ),
                                          ]
                                        )
                                      }
                                    ),
                                    _c(
                                      "span",
                                      {
                                        staticClass:
                                          "text-caption ml-2 flex-shrink-0 mobile-ticket-status",
                                      },
                                      [
                                        _vm._v(
                                          " " +
                                            _vm._s(
                                              _vm.$t(
                                                `ticketing.status.${item.status}`
                                              )
                                            ) +
                                            " "
                                        ),
                                      ]
                                    ),
                                  ],
                                  2
                                ),
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "mobile-ticket-meta text-caption grey--text text--darken-1 d-flex align-center",
                                  },
                                  [
                                    _c(
                                      "span",
                                      { staticClass: "text-truncate" },
                                      [
                                        _c("span", [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t(
                                                `ticketing.type.${item.type}`
                                              )
                                            )
                                          ),
                                        ]),
                                        item.organizationName
                                          ? _c("span", [
                                              _vm._v(
                                                " · " +
                                                  _vm._s(item.organizationName)
                                              ),
                                            ])
                                          : _vm._e(),
                                        _vm.extraOrgCount(item) > 0
                                          ? _c(
                                              "span",
                                              {
                                                staticClass:
                                                  "primary--text font-weight-medium ml-1",
                                                attrs: {
                                                  title: _vm
                                                    .extraOrgNames(item)
                                                    .join(", "),
                                                },
                                              },
                                              [
                                                _vm._v(
                                                  " +" +
                                                    _vm._s(
                                                      _vm.extraOrgCount(item)
                                                    )
                                                ),
                                              ]
                                            )
                                          : _vm._e(),
                                      ]
                                    ),
                                    _c("v-spacer"),
                                    _c(
                                      "span",
                                      {
                                        directives: [
                                          {
                                            name: "cursor-tip",
                                            rawName: "v-cursor-tip",
                                            value: _vm.formatTimeAbsolute(
                                              item.updatedAt
                                            ),
                                            expression:
                                              "formatTimeAbsolute(item.updatedAt)",
                                          },
                                        ],
                                        staticClass: "flex-shrink-0 ml-2",
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(_vm.formatTime(item.updatedAt))
                                        ),
                                      ]
                                    ),
                                  ],
                                  1
                                ),
                              ]),
                            ]
                          )
                        }),
                        !_vm.filteredTickets.length
                          ? _c(
                              "div",
                              {
                                staticClass:
                                  "text-caption grey--text text-center pa-4",
                              },
                              [
                                _vm._v(
                                  " " +
                                    _vm._s(_vm.$t("ticketing.no-tickets")) +
                                    " "
                                ),
                              ]
                            )
                          : _vm._e(),
                      ],
                      2
                    )
                  : _vm._e(),
              ],
          _c(
            "v-dialog",
            {
              attrs: {
                "max-width": _vm.isMobile ? undefined : 640,
                fullscreen: _vm.isMobile,
                persistent: "",
              },
              model: {
                value: _vm.formDialog,
                callback: function ($$v) {
                  _vm.formDialog = $$v
                },
                expression: "formDialog",
              },
            },
            [
              _c(
                "v-card",
                [
                  _c(
                    "v-card-title",
                    [
                      _vm._v(
                        " " +
                          _vm._s(
                            _vm.editingId
                              ? _vm.$t("ticketing.edit-ticket")
                              : _vm.$t("ticketing.new-ticket")
                          ) +
                          " "
                      ),
                      _c("v-spacer"),
                      _c(
                        "v-btn",
                        { attrs: { icon: "" }, on: { click: _vm.closeForm } },
                        [_c("v-icon", [_vm._v("mdi-close")])],
                        1
                      ),
                    ],
                    1
                  ),
                  _c("v-divider"),
                  _c(
                    "v-card-text",
                    { staticClass: "pt-4" },
                    [
                      _c(
                        "v-form",
                        {
                          ref: "form",
                          model: {
                            value: _vm.formValid,
                            callback: function ($$v) {
                              _vm.formValid = $$v
                            },
                            expression: "formValid",
                          },
                        },
                        [
                          _c("v-text-field", {
                            attrs: {
                              label: _vm.$t("ticketing.title"),
                              outlined: "",
                              dense: "",
                              rules: [(v) => !!v || _vm.$t("required")],
                            },
                            model: {
                              value: _vm.form.title,
                              callback: function ($$v) {
                                _vm.$set(_vm.form, "title", $$v)
                              },
                              expression: "form.title",
                            },
                          }),
                          _c("v-textarea", {
                            attrs: {
                              label: _vm.$t("ticketing.description"),
                              rows: "3",
                              outlined: "",
                              dense: "",
                            },
                            model: {
                              value: _vm.form.description,
                              callback: function ($$v) {
                                _vm.$set(_vm.form, "description", $$v)
                              },
                              expression: "form.description",
                            },
                          }),
                          _c(
                            "div",
                            { staticClass: "mb-3" },
                            [
                              _c("input", {
                                ref: "formFileInput",
                                staticStyle: { display: "none" },
                                attrs: { type: "file", multiple: "" },
                                on: { change: _vm.onFormFilesPicked },
                              }),
                              _c(
                                "v-btn",
                                {
                                  attrs: {
                                    small: "",
                                    outlined: "",
                                    loading: _vm.formAttachmentsUploading,
                                  },
                                  on: {
                                    click: function ($event) {
                                      return _vm.$refs.formFileInput.click()
                                    },
                                  },
                                },
                                [
                                  _c(
                                    "v-icon",
                                    { attrs: { left: "", small: "" } },
                                    [_vm._v("mdi-paperclip")]
                                  ),
                                  _vm._v(
                                    " " +
                                      _vm._s(_vm.$t("ticketing.attach")) +
                                      " "
                                  ),
                                ],
                                1
                              ),
                              _vm.form.attachments &&
                              _vm.form.attachments.length
                                ? _c(
                                    "div",
                                    {
                                      staticClass: "mt-2 d-flex flex-wrap",
                                      staticStyle: { gap: "6px" },
                                    },
                                    _vm._l(
                                      _vm.form.attachments,
                                      function (att, idx) {
                                        return _c(
                                          "v-chip",
                                          {
                                            key: att.path || idx,
                                            attrs: { small: "", close: "" },
                                            on: {
                                              "click:close": function ($event) {
                                                return _vm.removeFormAttachment(
                                                  idx
                                                )
                                              },
                                            },
                                          },
                                          [
                                            _c(
                                              "v-icon",
                                              {
                                                attrs: { left: "", small: "" },
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.attachmentIcon(att)
                                                  )
                                                ),
                                              ]
                                            ),
                                            _c(
                                              "span",
                                              {
                                                staticClass: "text-truncate",
                                                staticStyle: {
                                                  "max-width": "200px",
                                                },
                                              },
                                              [_vm._v(_vm._s(att.name))]
                                            ),
                                          ],
                                          1
                                        )
                                      }
                                    ),
                                    1
                                  )
                                : _vm._e(),
                            ],
                            1
                          ),
                          _c(
                            "v-row",
                            { attrs: { dense: "" } },
                            [
                              _c(
                                "v-col",
                                { attrs: { cols: "12", sm: "6" } },
                                [
                                  _c("v-autocomplete", {
                                    attrs: {
                                      items: _vm.organizationItems,
                                      "item-text": "text",
                                      "item-value": "value",
                                      filter: _vm.filterOrganization,
                                      label: _vm.$t("ticketing.organization"),
                                      outlined: "",
                                      dense: "",
                                      rules: [(v) => !!v || _vm.$t("required")],
                                    },
                                    on: { change: _vm.onOrgChange },
                                    scopedSlots: _vm._u([
                                      {
                                        key: "item",
                                        fn: function ({ item }) {
                                          return [
                                            _c(
                                              "v-list-item-content",
                                              [
                                                _c("v-list-item-title", [
                                                  _vm._v(_vm._s(item.text)),
                                                ]),
                                                _c(
                                                  "v-list-item-subtitle",
                                                  {
                                                    staticClass:
                                                      "text-caption grey--text",
                                                  },
                                                  [
                                                    _vm._v(
                                                      " " +
                                                        _vm._s(item.value) +
                                                        " "
                                                    ),
                                                  ]
                                                ),
                                              ],
                                              1
                                            ),
                                          ]
                                        },
                                      },
                                    ]),
                                    model: {
                                      value: _vm.form.organizationId,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.form,
                                          "organizationId",
                                          $$v
                                        )
                                      },
                                      expression: "form.organizationId",
                                    },
                                  }),
                                ],
                                1
                              ),
                              _c(
                                "v-col",
                                { attrs: { cols: "12", sm: "6" } },
                                [
                                  _c("v-autocomplete", {
                                    attrs: {
                                      items: _vm.orgUsers,
                                      "item-text": "fullName",
                                      "item-value": "id",
                                      filter: _vm.filterUser,
                                      label: _vm.$t("ticketing.assigned-user"),
                                      outlined: "",
                                      dense: "",
                                      loading: _vm.orgUsersLoading,
                                      "no-data-text": _vm.form.organizationId
                                        ? _vm.$t("ticketing.no-users")
                                        : _vm.$t("ticketing.pick-org-first"),
                                      clearable: "",
                                    },
                                    scopedSlots: _vm._u([
                                      {
                                        key: "item",
                                        fn: function ({ item }) {
                                          return [
                                            _c(
                                              "v-list-item-content",
                                              [
                                                _c("v-list-item-title", [
                                                  _vm._v(_vm._s(item.fullName)),
                                                ]),
                                                item.email
                                                  ? _c(
                                                      "v-list-item-subtitle",
                                                      {
                                                        staticClass:
                                                          "text-caption grey--text",
                                                      },
                                                      [
                                                        _vm._v(
                                                          " " +
                                                            _vm._s(item.email) +
                                                            " "
                                                        ),
                                                      ]
                                                    )
                                                  : _vm._e(),
                                              ],
                                              1
                                            ),
                                          ]
                                        },
                                      },
                                    ]),
                                    model: {
                                      value: _vm.form.assignedUserId,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.form,
                                          "assignedUserId",
                                          $$v
                                        )
                                      },
                                      expression: "form.assignedUserId",
                                    },
                                  }),
                                ],
                                1
                              ),
                              _c("v-col", { attrs: { cols: "12" } }, [
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "additional-orgs-section pa-3 mb-2",
                                  },
                                  [
                                    _c(
                                      "div",
                                      {
                                        staticClass: "d-flex align-center mb-2",
                                      },
                                      [
                                        _c(
                                          "v-icon",
                                          {
                                            staticClass: "mr-2",
                                            attrs: {
                                              small: "",
                                              color: "primary",
                                            },
                                          },
                                          [
                                            _vm._v(
                                              " mdi-account-group-outline "
                                            ),
                                          ]
                                        ),
                                        _c(
                                          "span",
                                          {
                                            staticClass:
                                              "text-caption font-weight-medium primary--text",
                                          },
                                          [
                                            _vm._v(
                                              " " +
                                                _vm._s(
                                                  _vm.$t(
                                                    "ticketing.also-affected-organizations"
                                                  )
                                                ) +
                                                " "
                                            ),
                                          ]
                                        ),
                                        _vm.form.additionalOrgs.length
                                          ? _c(
                                              "v-chip",
                                              {
                                                staticClass: "ml-2",
                                                attrs: {
                                                  "x-small": "",
                                                  color: "primary",
                                                  outlined: "",
                                                },
                                              },
                                              [
                                                _vm._v(
                                                  " +" +
                                                    _vm._s(
                                                      _vm.form.additionalOrgs
                                                        .length
                                                    ) +
                                                    " "
                                                ),
                                              ]
                                            )
                                          : _vm._e(),
                                        _c("v-spacer"),
                                      ],
                                      1
                                    ),
                                    _vm._l(
                                      _vm.form.additionalOrgs,
                                      function (entry) {
                                        return _c(
                                          "div",
                                          {
                                            key: entry.id,
                                            staticClass:
                                              "additional-org-row d-flex align-center mb-2",
                                          },
                                          [
                                            _c(
                                              "v-avatar",
                                              {
                                                staticClass: "mr-2",
                                                attrs: { size: "24" },
                                              },
                                              [
                                                _vm.organizationLogo(entry.id)
                                                  ? _c("v-img", {
                                                      attrs: {
                                                        src: _vm.organizationLogo(
                                                          entry.id
                                                        ),
                                                      },
                                                    })
                                                  : _c(
                                                      "v-icon",
                                                      { attrs: { small: "" } },
                                                      [_vm._v(" mdi-domain ")]
                                                    ),
                                              ],
                                              1
                                            ),
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "mr-3 text-truncate",
                                                staticStyle: {
                                                  "min-width": "140px",
                                                  "max-width": "220px",
                                                },
                                              },
                                              [
                                                _c(
                                                  "span",
                                                  {
                                                    staticClass:
                                                      "text-body-2 font-weight-medium",
                                                  },
                                                  [_vm._v(_vm._s(entry.name))]
                                                ),
                                              ]
                                            ),
                                            _c("v-autocomplete", {
                                              staticClass: "flex-grow-1",
                                              attrs: {
                                                value: entry.assignedUserId,
                                                items: entry.users || [],
                                                "item-text": "fullName",
                                                "item-value": "id",
                                                filter: _vm.filterUser,
                                                label:
                                                  _vm.$t("ticketing.contact"),
                                                outlined: "",
                                                dense: "",
                                                "hide-details": "",
                                                loading: entry.usersLoading,
                                                "no-data-text":
                                                  _vm.$t("ticketing.no-users"),
                                                clearable: "",
                                              },
                                              on: {
                                                change: (uid) =>
                                                  _vm.onAdditionalOrgUserChange(
                                                    entry,
                                                    uid
                                                  ),
                                              },
                                              scopedSlots: _vm._u(
                                                [
                                                  {
                                                    key: "item",
                                                    fn: function ({ item }) {
                                                      return [
                                                        _c(
                                                          "v-list-item-content",
                                                          [
                                                            _c(
                                                              "v-list-item-title",
                                                              [
                                                                _vm._v(
                                                                  _vm._s(
                                                                    item.fullName
                                                                  )
                                                                ),
                                                              ]
                                                            ),
                                                            item.email
                                                              ? _c(
                                                                  "v-list-item-subtitle",
                                                                  {
                                                                    staticClass:
                                                                      "text-caption grey--text",
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      " " +
                                                                        _vm._s(
                                                                          item.email
                                                                        ) +
                                                                        " "
                                                                    ),
                                                                  ]
                                                                )
                                                              : _vm._e(),
                                                          ],
                                                          1
                                                        ),
                                                      ]
                                                    },
                                                  },
                                                ],
                                                null,
                                                true
                                              ),
                                            }),
                                            _c(
                                              "v-btn",
                                              {
                                                staticClass: "ml-1",
                                                attrs: {
                                                  icon: "",
                                                  small: "",
                                                  title: _vm.$t(
                                                    "ticketing.remove-organization"
                                                  ),
                                                },
                                                on: {
                                                  click: function ($event) {
                                                    return _vm.removeAdditionalOrg(
                                                      entry.id
                                                    )
                                                  },
                                                },
                                              },
                                              [
                                                _c(
                                                  "v-icon",
                                                  { attrs: { small: "" } },
                                                  [_vm._v(" mdi-close ")]
                                                ),
                                              ],
                                              1
                                            ),
                                          ],
                                          1
                                        )
                                      }
                                    ),
                                    _c("v-autocomplete", {
                                      attrs: {
                                        items: _vm.additionalOrgPickerItems,
                                        "item-text": "text",
                                        "item-value": "value",
                                        filter: _vm.filterOrganization,
                                        label: _vm.$t(
                                          "ticketing.add-organization"
                                        ),
                                        "prepend-inner-icon": "mdi-plus",
                                        outlined: "",
                                        dense: "",
                                        "hide-details": "",
                                        clearable: "",
                                      },
                                      on: {
                                        change: _vm.addAdditionalOrgFromPicker,
                                      },
                                      scopedSlots: _vm._u([
                                        {
                                          key: "item",
                                          fn: function ({ item }) {
                                            return [
                                              _c(
                                                "v-list-item-content",
                                                [
                                                  _c("v-list-item-title", [
                                                    _vm._v(_vm._s(item.text)),
                                                  ]),
                                                  _c(
                                                    "v-list-item-subtitle",
                                                    {
                                                      staticClass:
                                                        "text-caption grey--text",
                                                    },
                                                    [
                                                      _vm._v(
                                                        " " +
                                                          _vm._s(item.value) +
                                                          " "
                                                      ),
                                                    ]
                                                  ),
                                                ],
                                                1
                                              ),
                                            ]
                                          },
                                        },
                                      ]),
                                      model: {
                                        value: _vm.additionalOrgPick,
                                        callback: function ($$v) {
                                          _vm.additionalOrgPick = $$v
                                        },
                                        expression: "additionalOrgPick",
                                      },
                                    }),
                                  ],
                                  2
                                ),
                              ]),
                              _c(
                                "v-col",
                                { attrs: { cols: "12", sm: "6" } },
                                [
                                  _c("v-select", {
                                    attrs: {
                                      items: _vm.typeOptions,
                                      label: _vm.$t("ticketing.type-label"),
                                      outlined: "",
                                      dense: "",
                                      rules: [(v) => !!v || _vm.$t("required")],
                                    },
                                    model: {
                                      value: _vm.form.type,
                                      callback: function ($$v) {
                                        _vm.$set(_vm.form, "type", $$v)
                                      },
                                      expression: "form.type",
                                    },
                                  }),
                                ],
                                1
                              ),
                              _c(
                                "v-col",
                                { attrs: { cols: "12", sm: "6" } },
                                [
                                  _c("v-select", {
                                    attrs: {
                                      items: _vm.priorityOptions,
                                      label: _vm.$t("ticketing.priority-label"),
                                      outlined: "",
                                      dense: "",
                                      rules: [(v) => !!v || _vm.$t("required")],
                                    },
                                    model: {
                                      value: _vm.form.priority,
                                      callback: function ($$v) {
                                        _vm.$set(_vm.form, "priority", $$v)
                                      },
                                      expression: "form.priority",
                                    },
                                  }),
                                ],
                                1
                              ),
                              _c(
                                "v-col",
                                { attrs: { cols: "12", sm: "6" } },
                                [
                                  _c("v-select", {
                                    attrs: {
                                      items: _vm.statusOptions,
                                      label: _vm.$t("ticketing.status-label"),
                                      outlined: "",
                                      dense: "",
                                      rules: [(v) => !!v || _vm.$t("required")],
                                    },
                                    model: {
                                      value: _vm.form.status,
                                      callback: function ($$v) {
                                        _vm.$set(_vm.form, "status", $$v)
                                      },
                                      expression: "form.status",
                                    },
                                  }),
                                ],
                                1
                              ),
                              _c(
                                "v-col",
                                { attrs: { cols: "12", sm: "6" } },
                                [
                                  _c("v-autocomplete", {
                                    attrs: {
                                      items: _vm.devopsUsers,
                                      "item-text": "fullName",
                                      "item-value": "id",
                                      label: _vm.$t(
                                        "ticketing.assigned-devops"
                                      ),
                                      outlined: "",
                                      dense: "",
                                      multiple: "",
                                      "small-chips": "",
                                      "deletable-chips": "",
                                    },
                                    model: {
                                      value: _vm.form.assignedDevopsIds,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.form,
                                          "assignedDevopsIds",
                                          $$v
                                        )
                                      },
                                      expression: "form.assignedDevopsIds",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c("v-divider"),
                  _c(
                    "v-card-actions",
                    [
                      _c("v-spacer"),
                      _c(
                        "v-btn",
                        { attrs: { text: "" }, on: { click: _vm.closeForm } },
                        [_vm._v(" " + _vm._s(_vm.$t("cancel")) + " ")]
                      ),
                      _c(
                        "v-btn",
                        {
                          attrs: {
                            color: "primary",
                            loading: _vm.formSaving,
                            disabled: !_vm.formValid,
                          },
                          on: { click: _vm.submitForm },
                        },
                        [
                          _vm._v(
                            " " +
                              _vm._s(
                                _vm.editingId
                                  ? _vm.$t("save")
                                  : _vm.$t("create")
                              ) +
                              " "
                          ),
                        ]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "v-dialog",
            {
              attrs: {
                fullscreen: "",
                scrollable: "",
                persistent: "",
                "no-click-animation": "",
                transition: "dialog-bottom-transition",
                "content-class": "dialog-ticket-detail",
              },
              on: { input: _vm.onDetailDialogInput },
              model: {
                value: _vm.detailDialog,
                callback: function ($$v) {
                  _vm.detailDialog = $$v
                },
                expression: "detailDialog",
              },
            },
            [
              _vm.activeTicket
                ? _c(
                    "v-card",
                    {
                      staticClass: "d-flex flex-column ticket-detail-card",
                      staticStyle: { height: "100vh" },
                    },
                    [
                      _c(
                        "v-btn",
                        {
                          staticClass: "ticket-detail-close",
                          attrs: { icon: "" },
                          on: { click: _vm.closeDetail },
                        },
                        [_c("v-icon", [_vm._v("mdi-close")])],
                        1
                      ),
                      _c(
                        "v-card-title",
                        {
                          staticClass:
                            "d-flex align-center flex-shrink-0 flex-wrap ticket-detail-title",
                          staticStyle: { gap: "6px" },
                        },
                        [
                          _c("span", { staticClass: "text-truncate" }, [
                            _vm._v(_vm._s(_vm.activeTicket.title)),
                          ]),
                          _c("div", { staticClass: "ticket-detail-nav-break" }),
                          _c(
                            "v-chip",
                            {
                              staticClass: "ticket-detail-type-chip",
                              attrs: { "x-small": "" },
                            },
                            [
                              _vm._v(
                                " " +
                                  _vm._s(
                                    _vm.$t(
                                      `ticketing.type.${_vm.activeTicket.type}`
                                    )
                                  ) +
                                  " "
                              ),
                            ]
                          ),
                          _c("v-spacer"),
                          _vm.navTicketIds.length
                            ? _c(
                                "div",
                                {
                                  staticClass:
                                    "d-flex align-center ticket-detail-nav flex-shrink-0",
                                  staticStyle: { gap: "2px" },
                                },
                                [
                                  _vm.currentNavFilterLabel
                                    ? _c(
                                        "v-chip",
                                        {
                                          staticClass: "mr-1",
                                          attrs: {
                                            "x-small": "",
                                            outlined: "",
                                            title: _vm.$t(
                                              "ticketing.iterating-filter",
                                              {
                                                filter:
                                                  _vm.currentNavFilterLabel,
                                              }
                                            ),
                                          },
                                        },
                                        [
                                          _vm._v(
                                            " " +
                                              _vm._s(
                                                _vm.currentNavFilterLabel
                                              ) +
                                              " "
                                          ),
                                        ]
                                      )
                                    : _vm._e(),
                                  _c(
                                    "v-tooltip",
                                    {
                                      attrs: { bottom: "" },
                                      scopedSlots: _vm._u(
                                        [
                                          {
                                            key: "activator",
                                            fn: function ({ on, attrs }) {
                                              return [
                                                _c(
                                                  "v-btn",
                                                  _vm._g(
                                                    _vm._b(
                                                      {
                                                        attrs: {
                                                          icon: "",
                                                          small: "",
                                                          disabled:
                                                            !_vm.hasPrevTicket,
                                                        },
                                                        on: {
                                                          click: function (
                                                            $event
                                                          ) {
                                                            return _vm.goToTicketDelta(
                                                              -1
                                                            )
                                                          },
                                                        },
                                                      },
                                                      "v-btn",
                                                      attrs,
                                                      false
                                                    ),
                                                    on
                                                  ),
                                                  [
                                                    _c("v-icon", [
                                                      _vm._v(
                                                        "mdi-chevron-left"
                                                      ),
                                                    ]),
                                                  ],
                                                  1
                                                ),
                                              ]
                                            },
                                          },
                                        ],
                                        null,
                                        false,
                                        2979509609
                                      ),
                                    },
                                    [
                                      _c("span", [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t("ticketing.prev-ticket")
                                          )
                                        ),
                                      ]),
                                    ]
                                  ),
                                  _c(
                                    "span",
                                    {
                                      staticClass:
                                        "text-caption grey--text text--darken-1 ticket-detail-nav__count",
                                    },
                                    [
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            _vm.navIndex >= 0
                                              ? _vm.navIndex + 1
                                              : "–"
                                          ) +
                                          " / " +
                                          _vm._s(_vm.navTicketIds.length) +
                                          " "
                                      ),
                                    ]
                                  ),
                                  _c(
                                    "v-tooltip",
                                    {
                                      attrs: { bottom: "" },
                                      scopedSlots: _vm._u(
                                        [
                                          {
                                            key: "activator",
                                            fn: function ({ on, attrs }) {
                                              return [
                                                _c(
                                                  "v-btn",
                                                  _vm._g(
                                                    _vm._b(
                                                      {
                                                        attrs: {
                                                          icon: "",
                                                          small: "",
                                                          disabled:
                                                            !_vm.hasNextTicket,
                                                        },
                                                        on: {
                                                          click: function (
                                                            $event
                                                          ) {
                                                            return _vm.goToTicketDelta(
                                                              1
                                                            )
                                                          },
                                                        },
                                                      },
                                                      "v-btn",
                                                      attrs,
                                                      false
                                                    ),
                                                    on
                                                  ),
                                                  [
                                                    _c("v-icon", [
                                                      _vm._v(
                                                        "mdi-chevron-right"
                                                      ),
                                                    ]),
                                                  ],
                                                  1
                                                ),
                                              ]
                                            },
                                          },
                                        ],
                                        null,
                                        false,
                                        430522185
                                      ),
                                    },
                                    [
                                      _c("span", [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t("ticketing.next-ticket")
                                          )
                                        ),
                                      ]),
                                    ]
                                  ),
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm._l(_vm.activeViewers, function (v, vIdx) {
                            return _c(
                              "v-tooltip",
                              {
                                key: `headlive-${v.userId}`,
                                attrs: { bottom: "" },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "activator",
                                      fn: function ({ on, attrs }) {
                                        return [
                                          _c(
                                            "v-avatar",
                                            _vm._g(
                                              _vm._b(
                                                {
                                                  staticClass:
                                                    "live-viewer-avatar live-viewer-avatar--lg flex-shrink-0",
                                                  class:
                                                    vIdx === 0
                                                      ? "ml-2"
                                                      : "ml-1",
                                                  style: {
                                                    "--live-color":
                                                      _vm.userColor(v.userId),
                                                  },
                                                  attrs: {
                                                    size: "24",
                                                    color: _vm.userColor(
                                                      v.userId
                                                    ),
                                                  },
                                                },
                                                "v-avatar",
                                                attrs,
                                                false
                                              ),
                                              on
                                            ),
                                            [
                                              _c(
                                                "span",
                                                {
                                                  staticClass:
                                                    "white--text text-caption",
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.viewerInitials(v.name)
                                                    )
                                                  ),
                                                ]
                                              ),
                                            ]
                                          ),
                                        ]
                                      },
                                    },
                                  ],
                                  null,
                                  true
                                ),
                              },
                              [
                                _c("span", [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t("ticketing.viewing-now", {
                                        name: v.name || v.userId,
                                      })
                                    )
                                  ),
                                ]),
                              ]
                            )
                          }),
                          _c("div", { staticClass: "ticket-status-break" }),
                          _c(
                            "div",
                            {
                              staticClass:
                                "ticket-status-actions d-flex align-center",
                              staticStyle: { gap: "6px" },
                            },
                            [
                              _vm.isTicketClosed
                                ? _c(
                                    "v-btn",
                                    {
                                      staticClass: "ticket-close-btn",
                                      attrs: {
                                        small: "",
                                        outlined: "",
                                        loading: _vm.closeBtnLoading,
                                        color: "success",
                                      },
                                      on: {
                                        click: function ($event) {
                                          return _vm.setTicketStatus("open")
                                        },
                                      },
                                    },
                                    [
                                      _c(
                                        "v-icon",
                                        { attrs: { small: "", left: "" } },
                                        [_vm._v("mdi-restore")]
                                      ),
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            _vm.$t("ticketing.reopen-ticket")
                                          ) +
                                          " "
                                      ),
                                    ],
                                    1
                                  )
                                : [
                                    _c(
                                      "v-btn",
                                      {
                                        staticClass: "ticket-close-btn",
                                        attrs: {
                                          small: "",
                                          outlined: "",
                                          loading:
                                            _vm.closeBtnLoading === "resolved",
                                          disabled: !!_vm.closeBtnLoading,
                                          color: "green darken-2",
                                        },
                                        on: {
                                          click: function ($event) {
                                            return _vm.setTicketStatus(
                                              "resolved"
                                            )
                                          },
                                        },
                                      },
                                      [
                                        _c(
                                          "v-icon",
                                          { attrs: { small: "", left: "" } },
                                          [_vm._v("mdi-check-circle-outline")]
                                        ),
                                        _vm._v(
                                          " " +
                                            _vm._s(
                                              _vm.$t("ticketing.resolve-ticket")
                                            ) +
                                            " "
                                        ),
                                      ],
                                      1
                                    ),
                                    _c(
                                      "v-btn",
                                      {
                                        staticClass: "ticket-close-btn",
                                        attrs: {
                                          small: "",
                                          outlined: "",
                                          loading:
                                            _vm.closeBtnLoading === "closed",
                                          disabled: !!_vm.closeBtnLoading,
                                          color: "grey darken-2",
                                        },
                                        on: {
                                          click: function ($event) {
                                            return _vm.setTicketStatus("closed")
                                          },
                                        },
                                      },
                                      [
                                        _c(
                                          "v-icon",
                                          { attrs: { small: "", left: "" } },
                                          [_vm._v("mdi-close-circle-outline")]
                                        ),
                                        _vm._v(
                                          " " +
                                            _vm._s(
                                              _vm.$t("ticketing.close-ticket")
                                            ) +
                                            " "
                                        ),
                                      ],
                                      1
                                    ),
                                  ],
                              _c(
                                "v-tooltip",
                                {
                                  attrs: { bottom: "" },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "activator",
                                        fn: function ({ on, attrs }) {
                                          return [
                                            _c(
                                              "v-btn",
                                              _vm._g(
                                                _vm._b(
                                                  {
                                                    attrs: { icon: "" },
                                                    on: {
                                                      click: function ($event) {
                                                        return _vm.shareTicket(
                                                          _vm.activeTicket
                                                        )
                                                      },
                                                    },
                                                  },
                                                  "v-btn",
                                                  attrs,
                                                  false
                                                ),
                                                on
                                              ),
                                              [
                                                _c(
                                                  "v-icon",
                                                  { attrs: { small: "" } },
                                                  [_vm._v("mdi-share-variant")]
                                                ),
                                              ],
                                              1
                                            ),
                                          ]
                                        },
                                      },
                                    ],
                                    null,
                                    false,
                                    2281125923
                                  ),
                                },
                                [
                                  _c("span", [
                                    _vm._v(
                                      _vm._s(_vm.$t("ticketing.share-ticket"))
                                    ),
                                  ]),
                                ]
                              ),
                              _c(
                                "v-btn",
                                {
                                  attrs: { icon: "" },
                                  on: {
                                    click: function ($event) {
                                      return _vm.openQuickAdd(_vm.activeTicket)
                                    },
                                  },
                                },
                                [
                                  _c("v-icon", { attrs: { small: "" } }, [
                                    _vm._v("mdi-pencil"),
                                  ]),
                                ],
                                1
                              ),
                            ],
                            2
                          ),
                        ],
                        2
                      ),
                      _c("v-divider"),
                      _c(
                        "v-card-text",
                        {
                          staticClass: "px-3 ticket-detail-card-text",
                          staticStyle: {
                            flex: "1 1 auto",
                            "min-height": "0",
                            "overflow-y": "auto",
                            "-webkit-overflow-scrolling": "touch",
                          },
                        },
                        [
                          _c("div", { staticClass: "ticket-detail-grid" }, [
                            _c("div", { staticClass: "td-left" }, [
                              _c(
                                "div",
                                { staticClass: "td-tabs" },
                                [
                                  _c(
                                    "v-tabs",
                                    {
                                      staticClass: "ticket-tabs mb-2",
                                      attrs: { grow: "", "show-arrows": "" },
                                      model: {
                                        value: _vm.detailTab,
                                        callback: function ($$v) {
                                          _vm.detailTab = $$v
                                        },
                                        expression: "detailTab",
                                      },
                                    },
                                    [
                                      _c(
                                        "v-tab",
                                        { attrs: { href: "#description" } },
                                        [
                                          _c(
                                            "v-icon",
                                            { attrs: { small: "", left: "" } },
                                            [_vm._v("mdi-text-box-outline")]
                                          ),
                                          _vm._v(
                                            " " +
                                              _vm._s(
                                                _vm.$t("ticketing.description")
                                              ) +
                                              " "
                                          ),
                                          _vm.activeTicket.attachments &&
                                          _vm.activeTicket.attachments.length
                                            ? _c(
                                                "span",
                                                {
                                                  staticClass:
                                                    "text-caption ml-1",
                                                },
                                                [
                                                  _vm._v(
                                                    "(" +
                                                      _vm._s(
                                                        _vm.activeTicket
                                                          .attachments.length
                                                      ) +
                                                      ")"
                                                  ),
                                                ]
                                              )
                                            : _vm._e(),
                                        ],
                                        1
                                      ),
                                      _c(
                                        "v-tab",
                                        { attrs: { href: "#conversation" } },
                                        [
                                          _c(
                                            "v-icon",
                                            { attrs: { small: "", left: "" } },
                                            [_vm._v("mdi-message-text-outline")]
                                          ),
                                          _vm._v(
                                            " " +
                                              _vm._s(
                                                _vm.$t("ticketing.conversation")
                                              ) +
                                              " "
                                          ),
                                          _vm.messages.length
                                            ? _c(
                                                "span",
                                                {
                                                  staticClass:
                                                    "text-caption ml-1",
                                                },
                                                [
                                                  _vm._v(
                                                    "(" +
                                                      _vm._s(
                                                        _vm.messages.length
                                                      ) +
                                                      ")"
                                                  ),
                                                ]
                                              )
                                            : _vm._e(),
                                          _vm.hasUnseenMentions(
                                            _vm.activeTicket
                                          )
                                            ? _c(
                                                "v-icon",
                                                {
                                                  staticClass:
                                                    "unread-dot ml-1",
                                                  attrs: {
                                                    "x-small": "",
                                                    color: "amber darken-2",
                                                  },
                                                },
                                                [_vm._v(" mdi-circle ")]
                                              )
                                            : _vm._e(),
                                          _vm.hasUnseenMessages(
                                            _vm.activeTicket
                                          )
                                            ? _c(
                                                "v-icon",
                                                {
                                                  staticClass: "unread-dot",
                                                  attrs: {
                                                    "x-small": "",
                                                    color: "primary",
                                                  },
                                                },
                                                [_vm._v(" mdi-circle ")]
                                              )
                                            : _vm._e(),
                                        ],
                                        1
                                      ),
                                      _c(
                                        "v-tab",
                                        { attrs: { href: "#activity" } },
                                        [
                                          _c(
                                            "v-icon",
                                            { attrs: { small: "", left: "" } },
                                            [_vm._v("mdi-history")]
                                          ),
                                          _vm._v(
                                            " " +
                                              _vm._s(
                                                _vm.$t("ticketing.activity")
                                              ) +
                                              " "
                                          ),
                                          _vm.activity.length
                                            ? _c(
                                                "span",
                                                {
                                                  staticClass:
                                                    "text-caption ml-1",
                                                },
                                                [
                                                  _vm._v(
                                                    "(" +
                                                      _vm._s(
                                                        _vm.activity.length
                                                      ) +
                                                      ")"
                                                  ),
                                                ]
                                              )
                                            : _vm._e(),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                  _c(
                                    "v-tabs-items",
                                    {
                                      staticClass: "ticket-tabs-items",
                                      model: {
                                        value: _vm.detailTab,
                                        callback: function ($$v) {
                                          _vm.detailTab = $$v
                                        },
                                        expression: "detailTab",
                                      },
                                    },
                                    [
                                      _c(
                                        "v-tab-item",
                                        { attrs: { value: "description" } },
                                        [
                                          _c(
                                            "div",
                                            { staticClass: "field-block" },
                                            [
                                              _vm.activeTicket.description
                                                ? _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "field-value text-body-2",
                                                      staticStyle: {
                                                        "white-space":
                                                          "pre-wrap",
                                                      },
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.activeTicket
                                                            .description
                                                        )
                                                      ),
                                                    ]
                                                  )
                                                : _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "field-value field-value--empty text-body-2",
                                                    },
                                                    [
                                                      _vm._v(
                                                        " " +
                                                          _vm._s(
                                                            _vm.$t(
                                                              "ticketing.no-description"
                                                            )
                                                          ) +
                                                          " "
                                                      ),
                                                    ]
                                                  ),
                                            ]
                                          ),
                                          _vm.activeTicket.attachments &&
                                          _vm.activeTicket.attachments.length
                                            ? _c(
                                                "div",
                                                { staticClass: "field-block" },
                                                [
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "field-label",
                                                    },
                                                    [
                                                      _vm._v(
                                                        " " +
                                                          _vm._s(
                                                            _vm.$t(
                                                              "ticketing.attachments"
                                                            )
                                                          ) +
                                                          " "
                                                      ),
                                                    ]
                                                  ),
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "attachment-grid",
                                                    },
                                                    [
                                                      _vm._l(
                                                        _vm.activeTicket
                                                          .attachments,
                                                        function (att, idx) {
                                                          return [
                                                            _vm.isImage(att)
                                                              ? _c(
                                                                  "a",
                                                                  {
                                                                    key:
                                                                      "timg-" +
                                                                      idx,
                                                                    staticClass:
                                                                      "attachment-image-link",
                                                                    attrs: {
                                                                      href: "#",
                                                                    },
                                                                    on: {
                                                                      click:
                                                                        function (
                                                                          $event
                                                                        ) {
                                                                          $event.preventDefault()
                                                                          return _vm.openImagePreview(
                                                                            _vm
                                                                              .activeTicket
                                                                              .attachments,
                                                                            idx
                                                                          )
                                                                        },
                                                                    },
                                                                  },
                                                                  [
                                                                    _c("img", {
                                                                      staticClass:
                                                                        "attachment-image",
                                                                      attrs: {
                                                                        src: att.url,
                                                                        alt: att.name,
                                                                      },
                                                                    }),
                                                                  ]
                                                                )
                                                              : _c(
                                                                  "a",
                                                                  {
                                                                    key:
                                                                      "tfile-" +
                                                                      idx,
                                                                    staticClass:
                                                                      "attachment-file attachment-file--tile",
                                                                    attrs: {
                                                                      href: att.url,
                                                                      target:
                                                                        "_blank",
                                                                      rel: "noopener",
                                                                    },
                                                                  },
                                                                  [
                                                                    _c(
                                                                      "v-icon",
                                                                      {
                                                                        staticClass:
                                                                          "attachment-file__icon-large mb-2",
                                                                      },
                                                                      [
                                                                        _vm._v(
                                                                          _vm._s(
                                                                            _vm.attachmentIcon(
                                                                              att
                                                                            )
                                                                          )
                                                                        ),
                                                                      ]
                                                                    ),
                                                                    _c(
                                                                      "span",
                                                                      {
                                                                        staticClass:
                                                                          "attachment-file__name",
                                                                        attrs: {
                                                                          title:
                                                                            att.name,
                                                                        },
                                                                      },
                                                                      [
                                                                        _c(
                                                                          "span",
                                                                          {
                                                                            staticClass:
                                                                              "attachment-file__name-base",
                                                                          },
                                                                          [
                                                                            _vm._v(
                                                                              _vm._s(
                                                                                _vm.attachmentBaseName(
                                                                                  att.name
                                                                                )
                                                                              )
                                                                            ),
                                                                          ]
                                                                        ),
                                                                        _c(
                                                                          "span",
                                                                          {
                                                                            staticClass:
                                                                              "attachment-file__name-ext",
                                                                          },
                                                                          [
                                                                            _vm._v(
                                                                              _vm._s(
                                                                                _vm.attachmentExtension(
                                                                                  att.name
                                                                                )
                                                                              )
                                                                            ),
                                                                          ]
                                                                        ),
                                                                      ]
                                                                    ),
                                                                    att.size
                                                                      ? _c(
                                                                          "span",
                                                                          {
                                                                            staticClass:
                                                                              "attachment-file__size text-caption grey--text",
                                                                          },
                                                                          [
                                                                            _vm._v(
                                                                              "(" +
                                                                                _vm._s(
                                                                                  _vm.formatSize(
                                                                                    att.size
                                                                                  )
                                                                                ) +
                                                                                ")"
                                                                            ),
                                                                          ]
                                                                        )
                                                                      : _vm._e(),
                                                                  ],
                                                                  1
                                                                ),
                                                          ]
                                                        }
                                                      ),
                                                    ],
                                                    2
                                                  ),
                                                ]
                                              )
                                            : _vm._e(),
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "field-block todos-block",
                                            },
                                            [
                                              _c(
                                                "div",
                                                { staticClass: "field-label" },
                                                [
                                                  _vm._v(
                                                    " " +
                                                      _vm._s(
                                                        _vm.$t(
                                                          "ticketing.todos"
                                                        )
                                                      ) +
                                                      " "
                                                  ),
                                                ]
                                              ),
                                              !_vm.todos.length
                                                ? _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "text-caption grey--text mb-2",
                                                    },
                                                    [
                                                      _vm._v(
                                                        " " +
                                                          _vm._s(
                                                            _vm.$t(
                                                              "ticketing.no-todos"
                                                            )
                                                          ) +
                                                          " "
                                                      ),
                                                    ]
                                                  )
                                                : _vm._e(),
                                              _vm._l(
                                                _vm.todos,
                                                function (todo) {
                                                  return _c(
                                                    "div",
                                                    {
                                                      key: todo.id,
                                                      staticClass: "todo-item",
                                                      class: {
                                                        "todo-item--completed":
                                                          todo.completed,
                                                      },
                                                    },
                                                    [
                                                      _c("v-checkbox", {
                                                        staticClass:
                                                          "todo-item__check ma-0 pa-0",
                                                        attrs: {
                                                          "input-value":
                                                            !!todo.completed,
                                                          "hide-details": "",
                                                          dense: "",
                                                        },
                                                        on: {
                                                          change: function (
                                                            $event
                                                          ) {
                                                            return _vm.toggleTodo(
                                                              todo
                                                            )
                                                          },
                                                        },
                                                      }),
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "todo-item__body",
                                                        },
                                                        [
                                                          _vm.editingTodoId ===
                                                          todo.id
                                                            ? [
                                                                _c(
                                                                  "v-text-field",
                                                                  {
                                                                    staticClass:
                                                                      "todo-item__edit",
                                                                    attrs: {
                                                                      dense: "",
                                                                      "hide-details":
                                                                        "",
                                                                      autofocus:
                                                                        "",
                                                                    },
                                                                    on: {
                                                                      keydown: [
                                                                        function (
                                                                          $event
                                                                        ) {
                                                                          if (
                                                                            !$event.type.indexOf(
                                                                              "key"
                                                                            ) &&
                                                                            _vm._k(
                                                                              $event.keyCode,
                                                                              "enter",
                                                                              13,
                                                                              $event.key,
                                                                              "Enter"
                                                                            )
                                                                          )
                                                                            return null
                                                                          $event.preventDefault()
                                                                          return _vm.saveEditTodo(
                                                                            todo
                                                                          )
                                                                        },
                                                                        function (
                                                                          $event
                                                                        ) {
                                                                          if (
                                                                            !$event.type.indexOf(
                                                                              "key"
                                                                            ) &&
                                                                            _vm._k(
                                                                              $event.keyCode,
                                                                              "esc",
                                                                              27,
                                                                              $event.key,
                                                                              [
                                                                                "Esc",
                                                                                "Escape",
                                                                              ]
                                                                            )
                                                                          )
                                                                            return null
                                                                          $event.preventDefault()
                                                                          return _vm.cancelEditTodo.apply(
                                                                            null,
                                                                            arguments
                                                                          )
                                                                        },
                                                                      ],
                                                                      blur: function (
                                                                        $event
                                                                      ) {
                                                                        return _vm.saveEditTodo(
                                                                          todo
                                                                        )
                                                                      },
                                                                    },
                                                                    model: {
                                                                      value:
                                                                        _vm.editingTodoText,
                                                                      callback:
                                                                        function (
                                                                          $$v
                                                                        ) {
                                                                          _vm.editingTodoText =
                                                                            $$v
                                                                        },
                                                                      expression:
                                                                        "editingTodoText",
                                                                    },
                                                                  }
                                                                ),
                                                              ]
                                                            : [
                                                                _c(
                                                                  "div",
                                                                  {
                                                                    staticClass:
                                                                      "todo-item__text text-body-2",
                                                                    on: {
                                                                      dblclick:
                                                                        function (
                                                                          $event
                                                                        ) {
                                                                          return _vm.startEditTodo(
                                                                            todo
                                                                          )
                                                                        },
                                                                    },
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      " " +
                                                                        _vm._s(
                                                                          todo.text
                                                                        ) +
                                                                        " "
                                                                    ),
                                                                  ]
                                                                ),
                                                              ],
                                                          _c(
                                                            "div",
                                                            {
                                                              staticClass:
                                                                "todo-item__meta text-caption grey--text",
                                                            },
                                                            [
                                                              _c(
                                                                "div",
                                                                {
                                                                  directives: [
                                                                    {
                                                                      name: "cursor-tip",
                                                                      rawName:
                                                                        "v-cursor-tip",
                                                                      value:
                                                                        _vm.formatTimeAbsolute(
                                                                          todo.createdAt
                                                                        ),
                                                                      expression:
                                                                        "formatTimeAbsolute(todo.createdAt)",
                                                                    },
                                                                  ],
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    " " +
                                                                      _vm._s(
                                                                        _vm.$t(
                                                                          "ticketing.todo-added-by",
                                                                          {
                                                                            name:
                                                                              todo.createdByName ||
                                                                              _vm.$t(
                                                                                "ticketing.someone"
                                                                              ),
                                                                            time: _vm.formatTime(
                                                                              todo.createdAt
                                                                            ),
                                                                          }
                                                                        )
                                                                      ) +
                                                                      " "
                                                                  ),
                                                                ]
                                                              ),
                                                              todo.completed
                                                                ? _c(
                                                                    "div",
                                                                    {
                                                                      directives:
                                                                        [
                                                                          {
                                                                            name: "cursor-tip",
                                                                            rawName:
                                                                              "v-cursor-tip",
                                                                            value:
                                                                              _vm.formatTimeAbsolute(
                                                                                todo.completedAt
                                                                              ),
                                                                            expression:
                                                                              "formatTimeAbsolute(todo.completedAt)",
                                                                          },
                                                                        ],
                                                                    },
                                                                    [
                                                                      _vm._v(
                                                                        " " +
                                                                          _vm._s(
                                                                            _vm.$t(
                                                                              "ticketing.todo-completed-by",
                                                                              {
                                                                                name:
                                                                                  todo.completedByName ||
                                                                                  _vm.$t(
                                                                                    "ticketing.someone"
                                                                                  ),
                                                                                time: _vm.formatTime(
                                                                                  todo.completedAt
                                                                                ),
                                                                              }
                                                                            )
                                                                          ) +
                                                                          " "
                                                                      ),
                                                                    ]
                                                                  )
                                                                : _vm._e(),
                                                            ]
                                                          ),
                                                        ],
                                                        2
                                                      ),
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "todo-item__actions",
                                                        },
                                                        [
                                                          !todo.completed &&
                                                          _vm.editingTodoId !==
                                                            todo.id
                                                            ? _c(
                                                                "v-tooltip",
                                                                {
                                                                  attrs: {
                                                                    bottom: "",
                                                                  },
                                                                  scopedSlots:
                                                                    _vm._u(
                                                                      [
                                                                        {
                                                                          key: "activator",
                                                                          fn: function ({
                                                                            on,
                                                                            attrs,
                                                                          }) {
                                                                            return [
                                                                              _c(
                                                                                "v-btn",
                                                                                _vm._g(
                                                                                  _vm._b(
                                                                                    {
                                                                                      attrs:
                                                                                        {
                                                                                          icon: "",
                                                                                          "x-small":
                                                                                            "",
                                                                                        },
                                                                                      on: {
                                                                                        click:
                                                                                          function (
                                                                                            $event
                                                                                          ) {
                                                                                            return _vm.startEditTodo(
                                                                                              todo
                                                                                            )
                                                                                          },
                                                                                      },
                                                                                    },
                                                                                    "v-btn",
                                                                                    attrs,
                                                                                    false
                                                                                  ),
                                                                                  on
                                                                                ),
                                                                                [
                                                                                  _c(
                                                                                    "v-icon",
                                                                                    {
                                                                                      attrs:
                                                                                        {
                                                                                          "x-small":
                                                                                            "",
                                                                                        },
                                                                                    },
                                                                                    [
                                                                                      _vm._v(
                                                                                        "mdi-pencil"
                                                                                      ),
                                                                                    ]
                                                                                  ),
                                                                                ],
                                                                                1
                                                                              ),
                                                                            ]
                                                                          },
                                                                        },
                                                                      ],
                                                                      null,
                                                                      true
                                                                    ),
                                                                },
                                                                [
                                                                  _c("span", [
                                                                    _vm._v(
                                                                      _vm._s(
                                                                        _vm.$t(
                                                                          "ticketing.todo-edit"
                                                                        )
                                                                      )
                                                                    ),
                                                                  ]),
                                                                ]
                                                              )
                                                            : _vm._e(),
                                                          !todo.completed
                                                            ? _c(
                                                                "v-tooltip",
                                                                {
                                                                  attrs: {
                                                                    bottom: "",
                                                                  },
                                                                  scopedSlots:
                                                                    _vm._u(
                                                                      [
                                                                        {
                                                                          key: "activator",
                                                                          fn: function ({
                                                                            on,
                                                                            attrs,
                                                                          }) {
                                                                            return [
                                                                              _c(
                                                                                "v-btn",
                                                                                _vm._g(
                                                                                  _vm._b(
                                                                                    {
                                                                                      attrs:
                                                                                        {
                                                                                          icon: "",
                                                                                          "x-small":
                                                                                            "",
                                                                                        },
                                                                                      on: {
                                                                                        click:
                                                                                          function (
                                                                                            $event
                                                                                          ) {
                                                                                            return _vm.removeTodo(
                                                                                              todo
                                                                                            )
                                                                                          },
                                                                                      },
                                                                                    },
                                                                                    "v-btn",
                                                                                    attrs,
                                                                                    false
                                                                                  ),
                                                                                  on
                                                                                ),
                                                                                [
                                                                                  _c(
                                                                                    "v-icon",
                                                                                    {
                                                                                      attrs:
                                                                                        {
                                                                                          "x-small":
                                                                                            "",
                                                                                        },
                                                                                    },
                                                                                    [
                                                                                      _vm._v(
                                                                                        "mdi-close"
                                                                                      ),
                                                                                    ]
                                                                                  ),
                                                                                ],
                                                                                1
                                                                              ),
                                                                            ]
                                                                          },
                                                                        },
                                                                      ],
                                                                      null,
                                                                      true
                                                                    ),
                                                                },
                                                                [
                                                                  _c("span", [
                                                                    _vm._v(
                                                                      _vm._s(
                                                                        _vm.$t(
                                                                          "ticketing.todo-delete"
                                                                        )
                                                                      )
                                                                    ),
                                                                  ]),
                                                                ]
                                                              )
                                                            : _vm._e(),
                                                        ],
                                                        1
                                                      ),
                                                    ],
                                                    1
                                                  )
                                                }
                                              ),
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "todo-add d-flex align-center mt-2",
                                                },
                                                [
                                                  _c("v-text-field", {
                                                    staticClass:
                                                      "todo-add__input",
                                                    attrs: {
                                                      dense: "",
                                                      "hide-details": "",
                                                      placeholder: _vm.$t(
                                                        "ticketing.todo-placeholder"
                                                      ),
                                                    },
                                                    on: {
                                                      keydown: function (
                                                        $event
                                                      ) {
                                                        if (
                                                          !$event.type.indexOf(
                                                            "key"
                                                          ) &&
                                                          _vm._k(
                                                            $event.keyCode,
                                                            "enter",
                                                            13,
                                                            $event.key,
                                                            "Enter"
                                                          )
                                                        )
                                                          return null
                                                        $event.preventDefault()
                                                        return _vm.submitNewTodo.apply(
                                                          null,
                                                          arguments
                                                        )
                                                      },
                                                    },
                                                    model: {
                                                      value: _vm.newTodoText,
                                                      callback: function ($$v) {
                                                        _vm.newTodoText = $$v
                                                      },
                                                      expression: "newTodoText",
                                                    },
                                                  }),
                                                  _c(
                                                    "v-btn",
                                                    {
                                                      staticClass: "ml-2",
                                                      attrs: {
                                                        icon: "",
                                                        small: "",
                                                        disabled:
                                                          !_vm.newTodoText.trim(),
                                                      },
                                                      on: {
                                                        click:
                                                          _vm.submitNewTodo,
                                                      },
                                                    },
                                                    [
                                                      _c(
                                                        "v-icon",
                                                        {
                                                          attrs: { small: "" },
                                                        },
                                                        [_vm._v("mdi-plus")]
                                                      ),
                                                    ],
                                                    1
                                                  ),
                                                ],
                                                1
                                              ),
                                            ],
                                            2
                                          ),
                                        ]
                                      ),
                                      _c(
                                        "v-tab-item",
                                        { attrs: { value: "conversation" } },
                                        [
                                          _c(
                                            "div",
                                            {
                                              staticClass: "messages-list-wrap",
                                            },
                                            [
                                              _c(
                                                "div",
                                                {
                                                  ref: "messagesList",
                                                  staticClass:
                                                    "messages-list mb-3",
                                                  on: {
                                                    scroll:
                                                      _vm.onMessagesScroll,
                                                    "&wheel": function (
                                                      $event
                                                    ) {
                                                      return _vm.releaseUnreadPin.apply(
                                                        null,
                                                        arguments
                                                      )
                                                    },
                                                    "&touchmove": function (
                                                      $event
                                                    ) {
                                                      return _vm.releaseUnreadPin.apply(
                                                        null,
                                                        arguments
                                                      )
                                                    },
                                                    click: _vm.onMessagesClick,
                                                  },
                                                },
                                                [
                                                  !_vm.conversationItems.length
                                                    ? _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "text-caption grey--text text-center pa-4",
                                                        },
                                                        [
                                                          _vm._v(
                                                            " " +
                                                              _vm._s(
                                                                _vm.$t(
                                                                  "ticketing.no-messages"
                                                                )
                                                              ) +
                                                              " "
                                                          ),
                                                        ]
                                                      )
                                                    : _vm._e(),
                                                  _vm._l(
                                                    _vm.conversationItems,
                                                    function (m) {
                                                      return [
                                                        m.kind === "message" &&
                                                        m.id ===
                                                          _vm.firstUnreadMessageId
                                                          ? _c(
                                                              "div",
                                                              {
                                                                key: `unread-divider-${m.id}`,
                                                                staticClass:
                                                                  "unread-divider",
                                                              },
                                                              [
                                                                _c(
                                                                  "span",
                                                                  {
                                                                    staticClass:
                                                                      "unread-divider__label",
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      _vm._s(
                                                                        _vm.$t(
                                                                          "ticketing.unread-below"
                                                                        )
                                                                      )
                                                                    ),
                                                                  ]
                                                                ),
                                                              ]
                                                            )
                                                          : _vm._e(),
                                                        m.kind === "follow-up"
                                                          ? _c(
                                                              "div",
                                                              {
                                                                key: `fu-${m.id}`,
                                                                staticClass:
                                                                  "message-row message-row--follow-up mb-2",
                                                              },
                                                              [
                                                                _c(
                                                                  "div",
                                                                  {
                                                                    staticClass:
                                                                      "follow-up-bubble",
                                                                  },
                                                                  [
                                                                    _c(
                                                                      "div",
                                                                      {
                                                                        staticClass:
                                                                          "follow-up-bubble__icon",
                                                                      },
                                                                      [
                                                                        _c(
                                                                          "v-icon",
                                                                          {
                                                                            attrs:
                                                                              {
                                                                                small:
                                                                                  "",
                                                                                color:
                                                                                  "white",
                                                                              },
                                                                          },
                                                                          [
                                                                            _vm._v(
                                                                              _vm._s(
                                                                                _vm.followUpIcon(
                                                                                  m.toValue
                                                                                )
                                                                              )
                                                                            ),
                                                                          ]
                                                                        ),
                                                                      ],
                                                                      1
                                                                    ),
                                                                    _c(
                                                                      "div",
                                                                      {
                                                                        staticClass:
                                                                          "follow-up-bubble__content",
                                                                      },
                                                                      [
                                                                        _c(
                                                                          "div",
                                                                          {
                                                                            staticClass:
                                                                              "follow-up-bubble__line",
                                                                          },
                                                                          [
                                                                            _c(
                                                                              "span",
                                                                              {
                                                                                staticClass:
                                                                                  "font-weight-medium",
                                                                              },
                                                                              [
                                                                                _vm._v(
                                                                                  _vm._s(
                                                                                    m.actorName ||
                                                                                      _vm.$t(
                                                                                        "ticketing.someone"
                                                                                      )
                                                                                  )
                                                                                ),
                                                                              ]
                                                                            ),
                                                                            _c(
                                                                              "span",
                                                                              {
                                                                                staticClass:
                                                                                  "follow-up-bubble__verb",
                                                                              },
                                                                              [
                                                                                _vm._v(
                                                                                  _vm._s(
                                                                                    " " +
                                                                                      _vm.$t(
                                                                                        "ticketing.activity-follow-up"
                                                                                      ) +
                                                                                      " "
                                                                                  )
                                                                                ),
                                                                              ]
                                                                            ),
                                                                            _c(
                                                                              "span",
                                                                              {
                                                                                staticClass:
                                                                                  "follow-up-bubble__method",
                                                                              },
                                                                              [
                                                                                _vm._v(
                                                                                  _vm._s(
                                                                                    _vm.$t(
                                                                                      "ticketing.follow-up-method." +
                                                                                        m.toValue
                                                                                    )
                                                                                  )
                                                                                ),
                                                                              ]
                                                                            ),
                                                                          ]
                                                                        ),
                                                                        _vm.followUpItemContactLabel(
                                                                          m
                                                                        ) ||
                                                                        m.organizationName
                                                                          ? _c(
                                                                              "div",
                                                                              {
                                                                                staticClass:
                                                                                  "follow-up-bubble__meta",
                                                                              },
                                                                              [
                                                                                _c(
                                                                                  "v-icon",
                                                                                  {
                                                                                    staticClass:
                                                                                      "mr-1",
                                                                                    attrs:
                                                                                      {
                                                                                        "x-small":
                                                                                          "",
                                                                                      },
                                                                                  },
                                                                                  [
                                                                                    _vm._v(
                                                                                      "mdi-account-outline"
                                                                                    ),
                                                                                  ]
                                                                                ),
                                                                                _vm.followUpItemContactLabel(
                                                                                  m
                                                                                )
                                                                                  ? _c(
                                                                                      "span",
                                                                                      {
                                                                                        staticClass:
                                                                                          "text-truncate",
                                                                                      },
                                                                                      [
                                                                                        _vm._v(
                                                                                          _vm._s(
                                                                                            _vm.followUpItemContactLabel(
                                                                                              m
                                                                                            )
                                                                                          )
                                                                                        ),
                                                                                      ]
                                                                                    )
                                                                                  : _vm._e(),
                                                                                m.organizationName
                                                                                  ? [
                                                                                      _c(
                                                                                        "v-icon",
                                                                                        {
                                                                                          staticClass:
                                                                                            "mx-1",
                                                                                          attrs:
                                                                                            {
                                                                                              "x-small":
                                                                                                "",
                                                                                            },
                                                                                        },
                                                                                        [
                                                                                          _vm._v(
                                                                                            "mdi-domain"
                                                                                          ),
                                                                                        ]
                                                                                      ),
                                                                                      _c(
                                                                                        "span",
                                                                                        {
                                                                                          staticClass:
                                                                                            "text-truncate",
                                                                                        },
                                                                                        [
                                                                                          _vm._v(
                                                                                            _vm._s(
                                                                                              m.organizationName
                                                                                            )
                                                                                          ),
                                                                                        ]
                                                                                      ),
                                                                                    ]
                                                                                  : _vm._e(),
                                                                              ],
                                                                              2
                                                                            )
                                                                          : _vm._e(),
                                                                      ]
                                                                    ),
                                                                    _c(
                                                                      "span",
                                                                      {
                                                                        directives:
                                                                          [
                                                                            {
                                                                              name: "cursor-tip",
                                                                              rawName:
                                                                                "v-cursor-tip",
                                                                              value:
                                                                                _vm.formatTimeAbsolute(
                                                                                  m.createdAt
                                                                                ),
                                                                              expression:
                                                                                "formatTimeAbsolute(m.createdAt)",
                                                                            },
                                                                          ],
                                                                        staticClass:
                                                                          "follow-up-bubble__time text-caption",
                                                                      },
                                                                      [
                                                                        _vm._v(
                                                                          _vm._s(
                                                                            _vm.formatTime(
                                                                              m.createdAt
                                                                            )
                                                                          )
                                                                        ),
                                                                      ]
                                                                    ),
                                                                  ]
                                                                ),
                                                                _c(
                                                                  "div",
                                                                  {
                                                                    key: `furx-${
                                                                      m.id
                                                                    }-${
                                                                      _vm.reactionList(
                                                                        m
                                                                      ).length
                                                                    }`,
                                                                    staticClass:
                                                                      "reactions-row reactions-row--center",
                                                                  },
                                                                  [
                                                                    _vm._l(
                                                                      _vm.reactionList(
                                                                        m
                                                                      ),
                                                                      function (
                                                                        r
                                                                      ) {
                                                                        return _c(
                                                                          "v-tooltip",
                                                                          {
                                                                            key: `fur-${r.emoji}`,
                                                                            attrs:
                                                                              {
                                                                                top: "",
                                                                              },
                                                                            scopedSlots:
                                                                              _vm._u(
                                                                                [
                                                                                  {
                                                                                    key: "activator",
                                                                                    fn: function ({
                                                                                      on,
                                                                                      attrs,
                                                                                    }) {
                                                                                      return [
                                                                                        _c(
                                                                                          "button",
                                                                                          _vm._g(
                                                                                            _vm._b(
                                                                                              {
                                                                                                staticClass:
                                                                                                  "reaction-chip",
                                                                                                class:
                                                                                                  {
                                                                                                    "reaction-chip--mine":
                                                                                                      r.mine,
                                                                                                  },
                                                                                                attrs:
                                                                                                  {
                                                                                                    type: "button",
                                                                                                  },
                                                                                                on: {
                                                                                                  click:
                                                                                                    function (
                                                                                                      $event
                                                                                                    ) {
                                                                                                      return _vm.onToggleReaction(
                                                                                                        m,
                                                                                                        r.emoji
                                                                                                      )
                                                                                                    },
                                                                                                },
                                                                                              },
                                                                                              "button",
                                                                                              attrs,
                                                                                              false
                                                                                            ),
                                                                                            on
                                                                                          ),
                                                                                          [
                                                                                            _c(
                                                                                              "span",
                                                                                              {
                                                                                                staticClass:
                                                                                                  "reaction-chip__emoji",
                                                                                              },
                                                                                              [
                                                                                                _vm._v(
                                                                                                  _vm._s(
                                                                                                    r.emoji
                                                                                                  )
                                                                                                ),
                                                                                              ]
                                                                                            ),
                                                                                            _c(
                                                                                              "span",
                                                                                              {
                                                                                                staticClass:
                                                                                                  "reaction-chip__count",
                                                                                              },
                                                                                              [
                                                                                                _vm._v(
                                                                                                  _vm._s(
                                                                                                    r.count
                                                                                                  )
                                                                                                ),
                                                                                              ]
                                                                                            ),
                                                                                          ]
                                                                                        ),
                                                                                      ]
                                                                                    },
                                                                                  },
                                                                                ],
                                                                                null,
                                                                                true
                                                                              ),
                                                                          },
                                                                          [
                                                                            _c(
                                                                              "span",
                                                                              {
                                                                                staticStyle:
                                                                                  {
                                                                                    "white-space":
                                                                                      "pre-line",
                                                                                  },
                                                                              },
                                                                              [
                                                                                _vm._v(
                                                                                  _vm._s(
                                                                                    r.names.join(
                                                                                      "\n"
                                                                                    )
                                                                                  )
                                                                                ),
                                                                              ]
                                                                            ),
                                                                          ]
                                                                        )
                                                                      }
                                                                    ),
                                                                    _c(
                                                                      "v-menu",
                                                                      {
                                                                        key: `fu-add-${m.id}`,
                                                                        attrs: {
                                                                          "offset-y":
                                                                            "",
                                                                          "close-on-content-click": true,
                                                                        },
                                                                        scopedSlots:
                                                                          _vm._u(
                                                                            [
                                                                              {
                                                                                key: "activator",
                                                                                fn: function ({
                                                                                  on,
                                                                                  attrs,
                                                                                }) {
                                                                                  return [
                                                                                    _c(
                                                                                      "button",
                                                                                      _vm._g(
                                                                                        _vm._b(
                                                                                          {
                                                                                            staticClass:
                                                                                              "reaction-chip reaction-chip--add reaction-chip--picker",
                                                                                            attrs:
                                                                                              {
                                                                                                type: "button",
                                                                                              },
                                                                                          },
                                                                                          "button",
                                                                                          attrs,
                                                                                          false
                                                                                        ),
                                                                                        on
                                                                                      ),
                                                                                      [
                                                                                        _c(
                                                                                          "v-icon",
                                                                                          [
                                                                                            _vm._v(
                                                                                              "mdi-emoticon-plus-outline"
                                                                                            ),
                                                                                          ]
                                                                                        ),
                                                                                      ],
                                                                                      1
                                                                                    ),
                                                                                  ]
                                                                                },
                                                                              },
                                                                            ],
                                                                            null,
                                                                            true
                                                                          ),
                                                                      },
                                                                      [
                                                                        _c(
                                                                          "div",
                                                                          {
                                                                            staticClass:
                                                                              "emoji-picker",
                                                                          },
                                                                          _vm._l(
                                                                            _vm.emojiPalette,
                                                                            function (
                                                                              e
                                                                            ) {
                                                                              return _c(
                                                                                "button",
                                                                                {
                                                                                  key: e,
                                                                                  staticClass:
                                                                                    "emoji-picker__item",
                                                                                  attrs:
                                                                                    {
                                                                                      type: "button",
                                                                                    },
                                                                                  on: {
                                                                                    click:
                                                                                      function (
                                                                                        $event
                                                                                      ) {
                                                                                        return _vm.onToggleReaction(
                                                                                          m,
                                                                                          e
                                                                                        )
                                                                                      },
                                                                                  },
                                                                                },
                                                                                [
                                                                                  _vm._v(
                                                                                    " " +
                                                                                      _vm._s(
                                                                                        e
                                                                                      ) +
                                                                                      " "
                                                                                  ),
                                                                                ]
                                                                              )
                                                                            }
                                                                          ),
                                                                          0
                                                                        ),
                                                                      ]
                                                                    ),
                                                                  ],
                                                                  2
                                                                ),
                                                              ]
                                                            )
                                                          : _c(
                                                              "div",
                                                              {
                                                                key: `msg-${m.id}`,
                                                                staticClass:
                                                                  "message-row mb-2",
                                                                class: {
                                                                  "message-row--mine":
                                                                    m.authorId ===
                                                                    _vm
                                                                      .currentUser
                                                                      .id,
                                                                },
                                                              },
                                                              [
                                                                m.authorId !==
                                                                _vm.currentUser
                                                                  .id
                                                                  ? _c(
                                                                      "div",
                                                                      {
                                                                        staticClass:
                                                                          "message-meta-other",
                                                                      },
                                                                      [
                                                                        _c(
                                                                          "span",
                                                                          {
                                                                            staticClass:
                                                                              "font-weight-medium text-body-2",
                                                                          },
                                                                          [
                                                                            _vm._v(
                                                                              _vm._s(
                                                                                m.authorName
                                                                              )
                                                                            ),
                                                                          ]
                                                                        ),
                                                                        _c(
                                                                          "span",
                                                                          {
                                                                            directives:
                                                                              [
                                                                                {
                                                                                  name: "cursor-tip",
                                                                                  rawName:
                                                                                    "v-cursor-tip",
                                                                                  value:
                                                                                    _vm.formatTimeAbsolute(
                                                                                      m.createdAt
                                                                                    ),
                                                                                  expression:
                                                                                    "formatTimeAbsolute(m.createdAt)",
                                                                                },
                                                                              ],
                                                                            staticClass:
                                                                              "text-caption grey--text ml-2",
                                                                          },
                                                                          [
                                                                            _vm._v(
                                                                              _vm._s(
                                                                                _vm.formatTime(
                                                                                  m.createdAt
                                                                                )
                                                                              )
                                                                            ),
                                                                          ]
                                                                        ),
                                                                      ]
                                                                    )
                                                                  : _vm._e(),
                                                                m.authorId !==
                                                                _vm.currentUser
                                                                  .id
                                                                  ? _c(
                                                                      "v-avatar",
                                                                      {
                                                                        staticClass:
                                                                          "message-avatar",
                                                                        attrs: {
                                                                          size: "32",
                                                                          color:
                                                                            _vm.userColor(
                                                                              m.authorId
                                                                            ),
                                                                        },
                                                                      },
                                                                      [
                                                                        _c(
                                                                          "span",
                                                                          {
                                                                            staticClass:
                                                                              "white--text text-caption",
                                                                          },
                                                                          [
                                                                            _vm._v(
                                                                              _vm._s(
                                                                                _vm.initials(
                                                                                  m.authorName
                                                                                )
                                                                              )
                                                                            ),
                                                                          ]
                                                                        ),
                                                                      ]
                                                                    )
                                                                  : _vm._e(),
                                                                _c(
                                                                  "div",
                                                                  {
                                                                    staticClass:
                                                                      "message-column",
                                                                  },
                                                                  [
                                                                    m.authorId ===
                                                                    _vm
                                                                      .currentUser
                                                                      .id
                                                                      ? _c(
                                                                          "div",
                                                                          {
                                                                            staticClass:
                                                                              "message-meta-mine",
                                                                          },
                                                                          [
                                                                            _c(
                                                                              "span",
                                                                              {
                                                                                directives:
                                                                                  [
                                                                                    {
                                                                                      name: "cursor-tip",
                                                                                      rawName:
                                                                                        "v-cursor-tip",
                                                                                      value:
                                                                                        _vm.formatTimeAbsolute(
                                                                                          m.createdAt
                                                                                        ),
                                                                                      expression:
                                                                                        "formatTimeAbsolute(m.createdAt)",
                                                                                    },
                                                                                  ],
                                                                                staticClass:
                                                                                  "text-caption grey--text",
                                                                              },
                                                                              [
                                                                                _vm._v(
                                                                                  _vm._s(
                                                                                    _vm.formatTime(
                                                                                      m.createdAt
                                                                                    )
                                                                                  )
                                                                                ),
                                                                              ]
                                                                            ),
                                                                          ]
                                                                        )
                                                                      : _vm._e(),
                                                                    _c(
                                                                      "div",
                                                                      {
                                                                        staticClass:
                                                                          "bubble-row",
                                                                      },
                                                                      [
                                                                        _c(
                                                                          "div",
                                                                          {
                                                                            staticClass:
                                                                              "message-item",
                                                                            class:
                                                                              {
                                                                                "message-item--mine":
                                                                                  m.authorId ===
                                                                                  _vm
                                                                                    .currentUser
                                                                                    .id,
                                                                              },
                                                                          },
                                                                          [
                                                                            _c(
                                                                              "div",
                                                                              {
                                                                                staticClass:
                                                                                  "text-body-2 message-body",
                                                                                domProps:
                                                                                  {
                                                                                    innerHTML:
                                                                                      _vm._s(
                                                                                        _vm.renderMessage(
                                                                                          m.body
                                                                                        )
                                                                                      ),
                                                                                  },
                                                                              }
                                                                            ),
                                                                            m.attachments &&
                                                                            m
                                                                              .attachments
                                                                              .length
                                                                              ? _c(
                                                                                  "div",
                                                                                  {
                                                                                    staticClass:
                                                                                      "attachment-grid mt-2",
                                                                                  },
                                                                                  [
                                                                                    _vm._l(
                                                                                      m.attachments,
                                                                                      function (
                                                                                        att,
                                                                                        idx
                                                                                      ) {
                                                                                        return [
                                                                                          _vm.isImage(
                                                                                            att
                                                                                          )
                                                                                            ? _c(
                                                                                                "a",
                                                                                                {
                                                                                                  key:
                                                                                                    "img-" +
                                                                                                    idx,
                                                                                                  staticClass:
                                                                                                    "attachment-image-link",
                                                                                                  attrs:
                                                                                                    {
                                                                                                      href: "#",
                                                                                                    },
                                                                                                  on: {
                                                                                                    click:
                                                                                                      function (
                                                                                                        $event
                                                                                                      ) {
                                                                                                        $event.preventDefault()
                                                                                                        return _vm.openImagePreview(
                                                                                                          m.attachments,
                                                                                                          idx
                                                                                                        )
                                                                                                      },
                                                                                                  },
                                                                                                },
                                                                                                [
                                                                                                  _c(
                                                                                                    "img",
                                                                                                    {
                                                                                                      staticClass:
                                                                                                        "attachment-image",
                                                                                                      attrs:
                                                                                                        {
                                                                                                          src: att.url,
                                                                                                          alt: att.name,
                                                                                                        },
                                                                                                      on: {
                                                                                                        load: _vm.onMessageImageLoad,
                                                                                                      },
                                                                                                    }
                                                                                                  ),
                                                                                                ]
                                                                                              )
                                                                                            : _c(
                                                                                                "a",
                                                                                                {
                                                                                                  key:
                                                                                                    "file-" +
                                                                                                    idx,
                                                                                                  staticClass:
                                                                                                    "attachment-file",
                                                                                                  attrs:
                                                                                                    {
                                                                                                      href: att.url,
                                                                                                      target:
                                                                                                        "_blank",
                                                                                                      rel: "noopener",
                                                                                                    },
                                                                                                },
                                                                                                [
                                                                                                  _c(
                                                                                                    "v-icon",
                                                                                                    {
                                                                                                      staticClass:
                                                                                                        "attachment-file__icon mr-1",
                                                                                                      attrs:
                                                                                                        {
                                                                                                          small:
                                                                                                            "",
                                                                                                        },
                                                                                                    },
                                                                                                    [
                                                                                                      _vm._v(
                                                                                                        _vm._s(
                                                                                                          _vm.attachmentIcon(
                                                                                                            att
                                                                                                          )
                                                                                                        )
                                                                                                      ),
                                                                                                    ]
                                                                                                  ),
                                                                                                  _c(
                                                                                                    "span",
                                                                                                    {
                                                                                                      staticClass:
                                                                                                        "attachment-file__name",
                                                                                                    },
                                                                                                    [
                                                                                                      _vm._v(
                                                                                                        _vm._s(
                                                                                                          att.name
                                                                                                        )
                                                                                                      ),
                                                                                                    ]
                                                                                                  ),
                                                                                                  att.size
                                                                                                    ? _c(
                                                                                                        "span",
                                                                                                        {
                                                                                                          staticClass:
                                                                                                            "attachment-file__size text-caption grey--text ml-1",
                                                                                                        },
                                                                                                        [
                                                                                                          _vm._v(
                                                                                                            "(" +
                                                                                                              _vm._s(
                                                                                                                _vm.formatSize(
                                                                                                                  att.size
                                                                                                                )
                                                                                                              ) +
                                                                                                              ")"
                                                                                                          ),
                                                                                                        ]
                                                                                                      )
                                                                                                    : _vm._e(),
                                                                                                ],
                                                                                                1
                                                                                              ),
                                                                                        ]
                                                                                      }
                                                                                    ),
                                                                                  ],
                                                                                  2
                                                                                )
                                                                              : _vm._e(),
                                                                          ]
                                                                        ),
                                                                        _vm
                                                                          .readersByMessageId[
                                                                          m.id
                                                                        ] &&
                                                                        _vm
                                                                          .readersByMessageId[
                                                                          m.id
                                                                        ].length
                                                                          ? _c(
                                                                              "div",
                                                                              {
                                                                                staticClass:
                                                                                  "read-receipts",
                                                                              },
                                                                              _vm._l(
                                                                                _vm
                                                                                  .readersByMessageId[
                                                                                  m
                                                                                    .id
                                                                                ],
                                                                                function (
                                                                                  r
                                                                                ) {
                                                                                  return _c(
                                                                                    "v-tooltip",
                                                                                    {
                                                                                      key: `rd-${m.id}-${r.userId}`,
                                                                                      attrs:
                                                                                        {
                                                                                          top: "",
                                                                                        },
                                                                                      scopedSlots:
                                                                                        _vm._u(
                                                                                          [
                                                                                            {
                                                                                              key: "activator",
                                                                                              fn: function ({
                                                                                                on,
                                                                                                attrs,
                                                                                              }) {
                                                                                                return [
                                                                                                  _c(
                                                                                                    "v-avatar",
                                                                                                    _vm._g(
                                                                                                      _vm._b(
                                                                                                        {
                                                                                                          staticClass:
                                                                                                            "read-receipt-avatar",
                                                                                                          attrs:
                                                                                                            {
                                                                                                              size: "16",
                                                                                                              color:
                                                                                                                _vm.userColor(
                                                                                                                  r.userId
                                                                                                                ),
                                                                                                            },
                                                                                                        },
                                                                                                        "v-avatar",
                                                                                                        attrs,
                                                                                                        false
                                                                                                      ),
                                                                                                      on
                                                                                                    ),
                                                                                                    [
                                                                                                      _c(
                                                                                                        "span",
                                                                                                        {
                                                                                                          staticClass:
                                                                                                            "white--text read-receipt-avatar__initials",
                                                                                                        },
                                                                                                        [
                                                                                                          _vm._v(
                                                                                                            _vm._s(
                                                                                                              _vm.viewerInitials(
                                                                                                                r.name
                                                                                                              )
                                                                                                            )
                                                                                                          ),
                                                                                                        ]
                                                                                                      ),
                                                                                                    ]
                                                                                                  ),
                                                                                                ]
                                                                                              },
                                                                                            },
                                                                                          ],
                                                                                          null,
                                                                                          true
                                                                                        ),
                                                                                    },
                                                                                    [
                                                                                      _c(
                                                                                        "span",
                                                                                        [
                                                                                          _vm._v(
                                                                                            _vm._s(
                                                                                              _vm.$t(
                                                                                                "ticketing.read-by",
                                                                                                {
                                                                                                  name: r.name,
                                                                                                  time: _vm.formatTimeAbsolute(
                                                                                                    r.seenMs
                                                                                                  ),
                                                                                                }
                                                                                              )
                                                                                            )
                                                                                          ),
                                                                                        ]
                                                                                      ),
                                                                                    ]
                                                                                  )
                                                                                }
                                                                              ),
                                                                              1
                                                                            )
                                                                          : _vm._e(),
                                                                      ]
                                                                    ),
                                                                    _vm._v(" "),
                                                                    _c(
                                                                      "div",
                                                                      {
                                                                        key: `rx-${
                                                                          m.id
                                                                        }-${
                                                                          _vm.reactionList(
                                                                            m
                                                                          )
                                                                            .length
                                                                        }`,
                                                                        staticClass:
                                                                          "reactions-row",
                                                                      },
                                                                      [
                                                                        _vm._l(
                                                                          _vm.reactionList(
                                                                            m
                                                                          ),
                                                                          function (
                                                                            r
                                                                          ) {
                                                                            return [
                                                                              _c(
                                                                                "v-tooltip",
                                                                                {
                                                                                  key: `r-${r.emoji}`,
                                                                                  attrs:
                                                                                    {
                                                                                      top: "",
                                                                                    },
                                                                                  scopedSlots:
                                                                                    _vm._u(
                                                                                      [
                                                                                        {
                                                                                          key: "activator",
                                                                                          fn: function ({
                                                                                            on,
                                                                                            attrs,
                                                                                          }) {
                                                                                            return [
                                                                                              _c(
                                                                                                "button",
                                                                                                _vm._g(
                                                                                                  _vm._b(
                                                                                                    {
                                                                                                      staticClass:
                                                                                                        "reaction-chip",
                                                                                                      class:
                                                                                                        {
                                                                                                          "reaction-chip--mine":
                                                                                                            r.mine,
                                                                                                        },
                                                                                                      attrs:
                                                                                                        {
                                                                                                          type: "button",
                                                                                                        },
                                                                                                      on: {
                                                                                                        click:
                                                                                                          function (
                                                                                                            $event
                                                                                                          ) {
                                                                                                            return _vm.onToggleReaction(
                                                                                                              m,
                                                                                                              r.emoji
                                                                                                            )
                                                                                                          },
                                                                                                      },
                                                                                                    },
                                                                                                    "button",
                                                                                                    attrs,
                                                                                                    false
                                                                                                  ),
                                                                                                  on
                                                                                                ),
                                                                                                [
                                                                                                  _c(
                                                                                                    "span",
                                                                                                    {
                                                                                                      staticClass:
                                                                                                        "reaction-chip__emoji",
                                                                                                    },
                                                                                                    [
                                                                                                      _vm._v(
                                                                                                        _vm._s(
                                                                                                          r.emoji
                                                                                                        )
                                                                                                      ),
                                                                                                    ]
                                                                                                  ),
                                                                                                  _c(
                                                                                                    "span",
                                                                                                    {
                                                                                                      staticClass:
                                                                                                        "reaction-chip__count",
                                                                                                    },
                                                                                                    [
                                                                                                      _vm._v(
                                                                                                        _vm._s(
                                                                                                          r.count
                                                                                                        )
                                                                                                      ),
                                                                                                    ]
                                                                                                  ),
                                                                                                ]
                                                                                              ),
                                                                                            ]
                                                                                          },
                                                                                        },
                                                                                      ],
                                                                                      null,
                                                                                      true
                                                                                    ),
                                                                                },
                                                                                [
                                                                                  _c(
                                                                                    "span",
                                                                                    {
                                                                                      staticStyle:
                                                                                        {
                                                                                          "white-space":
                                                                                            "pre-line",
                                                                                        },
                                                                                    },
                                                                                    [
                                                                                      _vm._v(
                                                                                        _vm._s(
                                                                                          r.names.join(
                                                                                            "\n"
                                                                                          )
                                                                                        )
                                                                                      ),
                                                                                    ]
                                                                                  ),
                                                                                ]
                                                                              ),
                                                                            ]
                                                                          }
                                                                        ),
                                                                        _c(
                                                                          "v-menu",
                                                                          {
                                                                            key: "reaction-add",
                                                                            attrs:
                                                                              {
                                                                                "offset-y":
                                                                                  "",
                                                                                "close-on-content-click": true,
                                                                              },
                                                                            scopedSlots:
                                                                              _vm._u(
                                                                                [
                                                                                  {
                                                                                    key: "activator",
                                                                                    fn: function ({
                                                                                      on,
                                                                                      attrs,
                                                                                    }) {
                                                                                      return [
                                                                                        _c(
                                                                                          "button",
                                                                                          _vm._g(
                                                                                            _vm._b(
                                                                                              {
                                                                                                staticClass:
                                                                                                  "reaction-chip reaction-chip--add reaction-chip--picker",
                                                                                                attrs:
                                                                                                  {
                                                                                                    type: "button",
                                                                                                  },
                                                                                              },
                                                                                              "button",
                                                                                              attrs,
                                                                                              false
                                                                                            ),
                                                                                            on
                                                                                          ),
                                                                                          [
                                                                                            _c(
                                                                                              "v-icon",
                                                                                              [
                                                                                                _vm._v(
                                                                                                  "mdi-emoticon-plus-outline"
                                                                                                ),
                                                                                              ]
                                                                                            ),
                                                                                          ],
                                                                                          1
                                                                                        ),
                                                                                      ]
                                                                                    },
                                                                                  },
                                                                                ],
                                                                                null,
                                                                                true
                                                                              ),
                                                                          },
                                                                          [
                                                                            _c(
                                                                              "div",
                                                                              {
                                                                                staticClass:
                                                                                  "emoji-picker",
                                                                              },
                                                                              _vm._l(
                                                                                _vm.emojiPalette,
                                                                                function (
                                                                                  e
                                                                                ) {
                                                                                  return _c(
                                                                                    "button",
                                                                                    {
                                                                                      key: e,
                                                                                      staticClass:
                                                                                        "emoji-picker__item",
                                                                                      attrs:
                                                                                        {
                                                                                          type: "button",
                                                                                        },
                                                                                      on: {
                                                                                        click:
                                                                                          function (
                                                                                            $event
                                                                                          ) {
                                                                                            return _vm.onToggleReaction(
                                                                                              m,
                                                                                              e
                                                                                            )
                                                                                          },
                                                                                      },
                                                                                    },
                                                                                    [
                                                                                      _vm._v(
                                                                                        " " +
                                                                                          _vm._s(
                                                                                            e
                                                                                          ) +
                                                                                          " "
                                                                                      ),
                                                                                    ]
                                                                                  )
                                                                                }
                                                                              ),
                                                                              0
                                                                            ),
                                                                          ]
                                                                        ),
                                                                      ],
                                                                      2
                                                                    ),
                                                                  ]
                                                                ),
                                                              ],
                                                              1
                                                            ),
                                                      ]
                                                    }
                                                  ),
                                                ],
                                                2
                                              ),
                                              _vm.unreadMessageCount > 0
                                                ? _c(
                                                    "v-btn",
                                                    {
                                                      staticClass:
                                                        "unread-banner elevation-3",
                                                      attrs: {
                                                        small: "",
                                                        rounded: "",
                                                        color: "primary",
                                                      },
                                                      on: {
                                                        click:
                                                          _vm.onUnreadBannerClick,
                                                      },
                                                    },
                                                    [
                                                      _c(
                                                        "v-icon",
                                                        {
                                                          attrs: {
                                                            left: "",
                                                            small: "",
                                                          },
                                                        },
                                                        [
                                                          _vm._v(
                                                            "mdi-arrow-down"
                                                          ),
                                                        ]
                                                      ),
                                                      _vm._v(
                                                        " " +
                                                          _vm._s(
                                                            _vm.$tc(
                                                              "ticketing.new-messages-banner",
                                                              _vm.unreadMessageCount,
                                                              {
                                                                count:
                                                                  _vm.unreadMessageCount,
                                                              }
                                                            )
                                                          ) +
                                                          " "
                                                      ),
                                                    ],
                                                    1
                                                  )
                                                : _vm._e(),
                                            ],
                                            1
                                          ),
                                          _vm.typingLabel
                                            ? _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "typing-indicator text-caption grey--text",
                                                },
                                                [
                                                  _c(
                                                    "v-icon",
                                                    {
                                                      staticClass: "mr-1",
                                                      attrs: { "x-small": "" },
                                                    },
                                                    [
                                                      _vm._v(
                                                        "mdi-pencil-outline"
                                                      ),
                                                    ]
                                                  ),
                                                  _vm._v(
                                                    " " +
                                                      _vm._s(_vm.typingLabel) +
                                                      " "
                                                  ),
                                                ],
                                                1
                                              )
                                            : _vm._e(),
                                          _c(
                                            "div",
                                            { staticClass: "message-composer" },
                                            [
                                              _c("v-textarea", {
                                                ref: "messageInput",
                                                attrs: {
                                                  placeholder: _vm.$t(
                                                    "ticketing.message-placeholder"
                                                  ),
                                                  rows: "2",
                                                  "auto-grow": "",
                                                  outlined: "",
                                                  dense: "",
                                                  "hide-details": "",
                                                },
                                                on: {
                                                  keyup: _vm.onMessageKeyup,
                                                  keydown: _vm.onMessageKeydown,
                                                },
                                                model: {
                                                  value: _vm.newMessage,
                                                  callback: function ($$v) {
                                                    _vm.newMessage = $$v
                                                  },
                                                  expression: "newMessage",
                                                },
                                              }),
                                              _c(
                                                "v-menu",
                                                {
                                                  attrs: {
                                                    "position-x":
                                                      _vm.mentionMenuX,
                                                    "position-y":
                                                      _vm.mentionMenuY,
                                                    absolute: "",
                                                    "offset-y": "",
                                                    "close-on-content-click": false,
                                                    "close-on-click": false,
                                                  },
                                                  model: {
                                                    value: _vm.mentionMenuOpen,
                                                    callback: function ($$v) {
                                                      _vm.mentionMenuOpen = $$v
                                                    },
                                                    expression:
                                                      "mentionMenuOpen",
                                                  },
                                                },
                                                [
                                                  _c(
                                                    "v-list",
                                                    {
                                                      attrs: {
                                                        dense: "",
                                                        "max-height": "240",
                                                        "min-width": "220",
                                                      },
                                                    },
                                                    [
                                                      _vm._l(
                                                        _vm.filteredMentionCandidates,
                                                        function (u, idx) {
                                                          return _c(
                                                            "v-list-item",
                                                            {
                                                              key: u.id,
                                                              attrs: {
                                                                "input-value":
                                                                  idx ===
                                                                  _vm.mentionIndex,
                                                              },
                                                              on: {
                                                                click:
                                                                  function (
                                                                    $event
                                                                  ) {
                                                                    return _vm.insertMention(
                                                                      u
                                                                    )
                                                                  },
                                                              },
                                                            },
                                                            [
                                                              _c(
                                                                "v-list-item-avatar",
                                                                {
                                                                  attrs: {
                                                                    size: "22",
                                                                    color:
                                                                      _vm.userColor(
                                                                        u.id
                                                                      ),
                                                                  },
                                                                },
                                                                [
                                                                  _c(
                                                                    "span",
                                                                    {
                                                                      staticClass:
                                                                        "white--text text-caption",
                                                                    },
                                                                    [
                                                                      _vm._v(
                                                                        _vm._s(
                                                                          _vm.initials(
                                                                            u.fullName
                                                                          )
                                                                        )
                                                                      ),
                                                                    ]
                                                                  ),
                                                                ]
                                                              ),
                                                              _c(
                                                                "v-list-item-title",
                                                                [
                                                                  _vm._v(
                                                                    _vm._s(
                                                                      u.fullName
                                                                    )
                                                                  ),
                                                                ]
                                                              ),
                                                            ],
                                                            1
                                                          )
                                                        }
                                                      ),
                                                      !_vm
                                                        .filteredMentionCandidates
                                                        .length
                                                        ? _c(
                                                            "v-list-item",
                                                            [
                                                              _c(
                                                                "v-list-item-title",
                                                                {
                                                                  staticClass:
                                                                    "text-caption grey--text",
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    " " +
                                                                      _vm._s(
                                                                        _vm.$t(
                                                                          "ticketing.no-users"
                                                                        )
                                                                      ) +
                                                                      " "
                                                                  ),
                                                                ]
                                                              ),
                                                            ],
                                                            1
                                                          )
                                                        : _vm._e(),
                                                    ],
                                                    2
                                                  ),
                                                ],
                                                1
                                              ),
                                              _vm.messageAttachments.length
                                                ? _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "mt-2 d-flex flex-wrap",
                                                      staticStyle: {
                                                        gap: "6px",
                                                      },
                                                    },
                                                    _vm._l(
                                                      _vm.messageAttachments,
                                                      function (att, idx) {
                                                        return _c(
                                                          "v-chip",
                                                          {
                                                            key:
                                                              att.path || idx,
                                                            attrs: {
                                                              small: "",
                                                              close: "",
                                                            },
                                                            on: {
                                                              "click:close":
                                                                function (
                                                                  $event
                                                                ) {
                                                                  return _vm.removeMessageAttachment(
                                                                    idx
                                                                  )
                                                                },
                                                            },
                                                          },
                                                          [
                                                            _c(
                                                              "v-icon",
                                                              {
                                                                attrs: {
                                                                  left: "",
                                                                  small: "",
                                                                },
                                                              },
                                                              [
                                                                _vm._v(
                                                                  _vm._s(
                                                                    _vm.attachmentIcon(
                                                                      att
                                                                    )
                                                                  )
                                                                ),
                                                              ]
                                                            ),
                                                            _c(
                                                              "span",
                                                              {
                                                                staticClass:
                                                                  "text-truncate",
                                                                staticStyle: {
                                                                  "max-width":
                                                                    "200px",
                                                                },
                                                              },
                                                              [
                                                                _vm._v(
                                                                  _vm._s(
                                                                    att.name
                                                                  )
                                                                ),
                                                              ]
                                                            ),
                                                          ],
                                                          1
                                                        )
                                                      }
                                                    ),
                                                    1
                                                  )
                                                : _vm._e(),
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "d-flex align-center mt-2",
                                                },
                                                [
                                                  _c("input", {
                                                    ref: "messageFileInput",
                                                    staticStyle: {
                                                      display: "none",
                                                    },
                                                    attrs: {
                                                      type: "file",
                                                      multiple: "",
                                                    },
                                                    on: {
                                                      change:
                                                        _vm.onMessageFilesPicked,
                                                    },
                                                  }),
                                                  _c(
                                                    "v-btn",
                                                    {
                                                      attrs: {
                                                        icon: "",
                                                        small: "",
                                                        loading:
                                                          _vm.messageAttachmentsUploading,
                                                        title:
                                                          _vm.$t(
                                                            "ticketing.attach"
                                                          ),
                                                      },
                                                      on: {
                                                        click: function (
                                                          $event
                                                        ) {
                                                          return _vm.$refs.messageFileInput.click()
                                                        },
                                                      },
                                                    },
                                                    [
                                                      _c(
                                                        "v-icon",
                                                        {
                                                          attrs: { small: "" },
                                                        },
                                                        [
                                                          _vm._v(
                                                            "mdi-paperclip"
                                                          ),
                                                        ]
                                                      ),
                                                    ],
                                                    1
                                                  ),
                                                  _c(
                                                    "span",
                                                    {
                                                      staticClass:
                                                        "text-caption grey--text ml-2",
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.$t(
                                                            "ticketing.mention-hint"
                                                          )
                                                        )
                                                      ),
                                                    ]
                                                  ),
                                                  _c("v-spacer"),
                                                  _c(
                                                    "v-btn",
                                                    {
                                                      attrs: {
                                                        small: "",
                                                        color: "primary",
                                                        loading:
                                                          _vm.sendingMessage,
                                                        disabled:
                                                          !_vm.newMessage.trim() &&
                                                          !_vm
                                                            .messageAttachments
                                                            .length,
                                                      },
                                                      on: {
                                                        click: _vm.sendMessage,
                                                      },
                                                    },
                                                    [
                                                      _c(
                                                        "v-icon",
                                                        {
                                                          attrs: {
                                                            left: "",
                                                            small: "",
                                                          },
                                                        },
                                                        [_vm._v("mdi-send")]
                                                      ),
                                                      _vm._v(
                                                        " " +
                                                          _vm._s(
                                                            _vm.$t(
                                                              "ticketing.send"
                                                            )
                                                          ) +
                                                          " "
                                                      ),
                                                    ],
                                                    1
                                                  ),
                                                ],
                                                1
                                              ),
                                            ],
                                            1
                                          ),
                                        ]
                                      ),
                                      _c(
                                        "v-tab-item",
                                        { attrs: { value: "activity" } },
                                        [
                                          _c(
                                            "div",
                                            {
                                              ref: "activityList",
                                              staticClass: "activity-list",
                                            },
                                            [
                                              !_vm.activity.length
                                                ? _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "text-caption grey--text text-center pa-3",
                                                    },
                                                    [
                                                      _vm._v(
                                                        " " +
                                                          _vm._s(
                                                            _vm.$t(
                                                              "ticketing.no-activity"
                                                            )
                                                          ) +
                                                          " "
                                                      ),
                                                    ]
                                                  )
                                                : _vm._e(),
                                              _vm._l(
                                                _vm.activity,
                                                function (a) {
                                                  return _c(
                                                    "div",
                                                    {
                                                      key: a.id,
                                                      staticClass:
                                                        "activity-item",
                                                    },
                                                    [
                                                      _c(
                                                        "v-icon",
                                                        {
                                                          staticClass:
                                                            "activity-dot",
                                                          attrs: {
                                                            "x-small": "",
                                                            color:
                                                              _vm.activityIconColor(
                                                                a
                                                              ),
                                                          },
                                                        },
                                                        [
                                                          _vm._v(
                                                            " " +
                                                              _vm._s(
                                                                _vm.activityIcon(
                                                                  a
                                                                )
                                                              ) +
                                                              " "
                                                          ),
                                                        ]
                                                      ),
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "activity-body",
                                                        },
                                                        [
                                                          _c(
                                                            "div",
                                                            {
                                                              staticClass:
                                                                "text-body-2",
                                                            },
                                                            [
                                                              _c(
                                                                "span",
                                                                {
                                                                  staticClass:
                                                                    "font-weight-medium",
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    _vm._s(
                                                                      a.actorName ||
                                                                        _vm.$t(
                                                                          "ticketing.someone"
                                                                        )
                                                                    )
                                                                  ),
                                                                ]
                                                              ),
                                                              a.type ===
                                                              "created"
                                                                ? _c("span", [
                                                                    _vm._v(
                                                                      " " +
                                                                        _vm._s(
                                                                          " " +
                                                                            _vm.$t(
                                                                              "ticketing.activity-created"
                                                                            )
                                                                        ) +
                                                                        " "
                                                                    ),
                                                                  ])
                                                                : a.type ===
                                                                  "visited"
                                                                ? _c(
                                                                    "span",
                                                                    {
                                                                      staticClass:
                                                                        "grey--text text--darken-1",
                                                                    },
                                                                    [
                                                                      _vm._v(
                                                                        " " +
                                                                          _vm._s(
                                                                            " " +
                                                                              _vm.$t(
                                                                                "ticketing.activity-visited"
                                                                              )
                                                                          ) +
                                                                          " "
                                                                      ),
                                                                    ]
                                                                  )
                                                                : a.type ===
                                                                  "follow-up"
                                                                ? _c("span", [
                                                                    _vm._v(
                                                                      " " +
                                                                        _vm._s(
                                                                          " " +
                                                                            _vm.$t(
                                                                              "ticketing.activity-follow-up"
                                                                            )
                                                                        ) +
                                                                        " "
                                                                    ),
                                                                    _c(
                                                                      "span",
                                                                      {
                                                                        staticClass:
                                                                          "activity-value",
                                                                      },
                                                                      [
                                                                        _vm._v(
                                                                          _vm._s(
                                                                            _vm.$t(
                                                                              "ticketing.follow-up-method." +
                                                                                a.toValue
                                                                            )
                                                                          )
                                                                        ),
                                                                      ]
                                                                    ),
                                                                    a.contactName
                                                                      ? _c(
                                                                          "span",
                                                                          {
                                                                            staticClass:
                                                                              "grey--text text--darken-1",
                                                                          },
                                                                          [
                                                                            _vm._v(
                                                                              " — " +
                                                                                _vm._s(
                                                                                  a.contactName
                                                                                ) +
                                                                                " "
                                                                            ),
                                                                          ]
                                                                        )
                                                                      : _vm._e(),
                                                                    a.organizationName
                                                                      ? _c(
                                                                          "span",
                                                                          {
                                                                            staticClass:
                                                                              "grey--text text--darken-1",
                                                                          },
                                                                          [
                                                                            _vm._v(
                                                                              " — " +
                                                                                _vm._s(
                                                                                  a.organizationName
                                                                                ) +
                                                                                " "
                                                                            ),
                                                                          ]
                                                                        )
                                                                      : _vm._e(),
                                                                  ])
                                                                : a.type ===
                                                                  "attachments-added"
                                                                ? _c("span", [
                                                                    _vm._v(
                                                                      " " +
                                                                        _vm._s(
                                                                          " " +
                                                                            _vm.$t(
                                                                              "ticketing.activity-attachments-added"
                                                                            )
                                                                        ) +
                                                                        " "
                                                                    ),
                                                                    _c(
                                                                      "span",
                                                                      {
                                                                        staticClass:
                                                                          "activity-value",
                                                                      },
                                                                      [
                                                                        _vm._v(
                                                                          _vm._s(
                                                                            a.toValue
                                                                          )
                                                                        ),
                                                                      ]
                                                                    ),
                                                                  ])
                                                                : a.type ===
                                                                  "attachments-removed"
                                                                ? _c("span", [
                                                                    _vm._v(
                                                                      " " +
                                                                        _vm._s(
                                                                          " " +
                                                                            _vm.$t(
                                                                              "ticketing.activity-attachments-removed"
                                                                            )
                                                                        ) +
                                                                        " "
                                                                    ),
                                                                    _c(
                                                                      "span",
                                                                      {
                                                                        staticClass:
                                                                          "activity-value",
                                                                      },
                                                                      [
                                                                        _vm._v(
                                                                          _vm._s(
                                                                            a.toValue
                                                                          )
                                                                        ),
                                                                      ]
                                                                    ),
                                                                  ])
                                                                : a.type ===
                                                                  "watcher-added"
                                                                ? _c("span", [
                                                                    _vm._v(
                                                                      " " +
                                                                        _vm._s(
                                                                          " " +
                                                                            _vm.$t(
                                                                              "ticketing.activity-watcher-added"
                                                                            )
                                                                        ) +
                                                                        " "
                                                                    ),
                                                                    _c(
                                                                      "span",
                                                                      {
                                                                        staticClass:
                                                                          "activity-value",
                                                                      },
                                                                      [
                                                                        _vm._v(
                                                                          _vm._s(
                                                                            a.toValue
                                                                          )
                                                                        ),
                                                                      ]
                                                                    ),
                                                                  ])
                                                                : a.type ===
                                                                  "watcher-removed"
                                                                ? _c("span", [
                                                                    _vm._v(
                                                                      " " +
                                                                        _vm._s(
                                                                          " " +
                                                                            _vm.$t(
                                                                              "ticketing.activity-watcher-removed"
                                                                            )
                                                                        ) +
                                                                        " "
                                                                    ),
                                                                    _c(
                                                                      "span",
                                                                      {
                                                                        staticClass:
                                                                          "activity-value",
                                                                      },
                                                                      [
                                                                        _vm._v(
                                                                          _vm._s(
                                                                            a.toValue
                                                                          )
                                                                        ),
                                                                      ]
                                                                    ),
                                                                  ])
                                                                : a.type ===
                                                                  "todo-added"
                                                                ? _c("span", [
                                                                    _vm._v(
                                                                      " " +
                                                                        _vm._s(
                                                                          " " +
                                                                            _vm.$t(
                                                                              "ticketing.activity-todo-added"
                                                                            )
                                                                        ) +
                                                                        " "
                                                                    ),
                                                                    _c(
                                                                      "span",
                                                                      {
                                                                        staticClass:
                                                                          "activity-value",
                                                                      },
                                                                      [
                                                                        _vm._v(
                                                                          _vm._s(
                                                                            a.toValue
                                                                          )
                                                                        ),
                                                                      ]
                                                                    ),
                                                                  ])
                                                                : a.type ===
                                                                  "todo-edited"
                                                                ? _c("span", [
                                                                    _vm._v(
                                                                      " " +
                                                                        _vm._s(
                                                                          " " +
                                                                            _vm.$t(
                                                                              "ticketing.activity-todo-edited"
                                                                            )
                                                                        ) +
                                                                        " "
                                                                    ),
                                                                    a.fromValue !=
                                                                      null &&
                                                                    a.fromValue !==
                                                                      ""
                                                                      ? _c(
                                                                          "span",
                                                                          {
                                                                            staticClass:
                                                                              "grey--text text--darken-1",
                                                                          },
                                                                          [
                                                                            _vm._v(
                                                                              " " +
                                                                                _vm._s(
                                                                                  " " +
                                                                                    _vm.$t(
                                                                                      "ticketing.activity-from"
                                                                                    )
                                                                                ) +
                                                                                " "
                                                                            ),
                                                                          ]
                                                                        )
                                                                      : _vm._e(),
                                                                    a.fromValue !=
                                                                      null &&
                                                                    a.fromValue !==
                                                                      ""
                                                                      ? _c(
                                                                          "span",
                                                                          {
                                                                            staticClass:
                                                                              "activity-value",
                                                                          },
                                                                          [
                                                                            _vm._v(
                                                                              _vm._s(
                                                                                a.fromValue
                                                                              )
                                                                            ),
                                                                          ]
                                                                        )
                                                                      : _vm._e(),
                                                                    _c(
                                                                      "span",
                                                                      {
                                                                        staticClass:
                                                                          "grey--text text--darken-1",
                                                                      },
                                                                      [
                                                                        _vm._v(
                                                                          " " +
                                                                            _vm._s(
                                                                              " " +
                                                                                _vm.$t(
                                                                                  "ticketing.activity-to"
                                                                                )
                                                                            ) +
                                                                            " "
                                                                        ),
                                                                      ]
                                                                    ),
                                                                    _c(
                                                                      "span",
                                                                      {
                                                                        staticClass:
                                                                          "activity-value",
                                                                      },
                                                                      [
                                                                        _vm._v(
                                                                          _vm._s(
                                                                            a.toValue
                                                                          )
                                                                        ),
                                                                      ]
                                                                    ),
                                                                  ])
                                                                : a.type ===
                                                                  "todo-completed"
                                                                ? _c("span", [
                                                                    _vm._v(
                                                                      " " +
                                                                        _vm._s(
                                                                          " " +
                                                                            _vm.$t(
                                                                              "ticketing.activity-todo-completed"
                                                                            )
                                                                        ) +
                                                                        " "
                                                                    ),
                                                                    _c(
                                                                      "span",
                                                                      {
                                                                        staticClass:
                                                                          "activity-value",
                                                                      },
                                                                      [
                                                                        _vm._v(
                                                                          _vm._s(
                                                                            a.toValue
                                                                          )
                                                                        ),
                                                                      ]
                                                                    ),
                                                                  ])
                                                                : a.type ===
                                                                  "todo-uncompleted"
                                                                ? _c("span", [
                                                                    _vm._v(
                                                                      " " +
                                                                        _vm._s(
                                                                          " " +
                                                                            _vm.$t(
                                                                              "ticketing.activity-todo-uncompleted"
                                                                            )
                                                                        ) +
                                                                        " "
                                                                    ),
                                                                    _c(
                                                                      "span",
                                                                      {
                                                                        staticClass:
                                                                          "activity-value",
                                                                      },
                                                                      [
                                                                        _vm._v(
                                                                          _vm._s(
                                                                            a.toValue
                                                                          )
                                                                        ),
                                                                      ]
                                                                    ),
                                                                  ])
                                                                : a.type ===
                                                                  "todo-deleted"
                                                                ? _c("span", [
                                                                    _vm._v(
                                                                      " " +
                                                                        _vm._s(
                                                                          " " +
                                                                            _vm.$t(
                                                                              "ticketing.activity-todo-deleted"
                                                                            )
                                                                        ) +
                                                                        " "
                                                                    ),
                                                                    _c(
                                                                      "span",
                                                                      {
                                                                        staticClass:
                                                                          "activity-value",
                                                                      },
                                                                      [
                                                                        _vm._v(
                                                                          _vm._s(
                                                                            a.toValue
                                                                          )
                                                                        ),
                                                                      ]
                                                                    ),
                                                                  ])
                                                                : a.type ===
                                                                  "org-added"
                                                                ? _c("span", [
                                                                    _vm._v(
                                                                      " " +
                                                                        _vm._s(
                                                                          " " +
                                                                            _vm.$t(
                                                                              "ticketing.activity-org-added"
                                                                            )
                                                                        ) +
                                                                        " "
                                                                    ),
                                                                    _c(
                                                                      "span",
                                                                      {
                                                                        staticClass:
                                                                          "activity-value",
                                                                      },
                                                                      [
                                                                        _vm._v(
                                                                          _vm._s(
                                                                            a.toValue
                                                                          )
                                                                        ),
                                                                      ]
                                                                    ),
                                                                  ])
                                                                : a.type ===
                                                                  "org-removed"
                                                                ? _c("span", [
                                                                    _vm._v(
                                                                      " " +
                                                                        _vm._s(
                                                                          " " +
                                                                            _vm.$t(
                                                                              "ticketing.activity-org-removed"
                                                                            )
                                                                        ) +
                                                                        " "
                                                                    ),
                                                                    _c(
                                                                      "span",
                                                                      {
                                                                        staticClass:
                                                                          "activity-value",
                                                                      },
                                                                      [
                                                                        _vm._v(
                                                                          _vm._s(
                                                                            a.toValue
                                                                          )
                                                                        ),
                                                                      ]
                                                                    ),
                                                                  ])
                                                                : a.type ===
                                                                  "org-contact-updated"
                                                                ? _c("span", [
                                                                    _vm._v(
                                                                      " " +
                                                                        _vm._s(
                                                                          " " +
                                                                            _vm.$t(
                                                                              "ticketing.activity-org-contact-updated"
                                                                            )
                                                                        ) +
                                                                        " "
                                                                    ),
                                                                    a.fromValue
                                                                      ? _c(
                                                                          "span",
                                                                          {
                                                                            staticClass:
                                                                              "grey--text text--darken-1",
                                                                          },
                                                                          [
                                                                            _vm._v(
                                                                              " " +
                                                                                _vm._s(
                                                                                  " " +
                                                                                    _vm.$t(
                                                                                      "ticketing.activity-from"
                                                                                    )
                                                                                ) +
                                                                                " "
                                                                            ),
                                                                          ]
                                                                        )
                                                                      : _vm._e(),
                                                                    a.fromValue
                                                                      ? _c(
                                                                          "span",
                                                                          {
                                                                            staticClass:
                                                                              "activity-value",
                                                                          },
                                                                          [
                                                                            _vm._v(
                                                                              _vm._s(
                                                                                a.fromValue
                                                                              )
                                                                            ),
                                                                          ]
                                                                        )
                                                                      : _vm._e(),
                                                                    _c(
                                                                      "span",
                                                                      {
                                                                        staticClass:
                                                                          "grey--text text--darken-1",
                                                                      },
                                                                      [
                                                                        _vm._v(
                                                                          " " +
                                                                            _vm._s(
                                                                              " " +
                                                                                _vm.$t(
                                                                                  "ticketing.activity-to"
                                                                                )
                                                                            ) +
                                                                            " "
                                                                        ),
                                                                      ]
                                                                    ),
                                                                    _c(
                                                                      "span",
                                                                      {
                                                                        staticClass:
                                                                          "activity-value",
                                                                      },
                                                                      [
                                                                        _vm._v(
                                                                          _vm._s(
                                                                            a.toValue ||
                                                                              "—"
                                                                          )
                                                                        ),
                                                                      ]
                                                                    ),
                                                                  ])
                                                                : _c("span", [
                                                                    _vm._v(
                                                                      " " +
                                                                        _vm._s(
                                                                          " " +
                                                                            _vm.$t(
                                                                              "ticketing.activity-changed",
                                                                              {
                                                                                field:
                                                                                  _vm.$t(
                                                                                    "ticketing.field." +
                                                                                      a.field
                                                                                  ),
                                                                              }
                                                                            )
                                                                        ) +
                                                                        " "
                                                                    ),
                                                                    a.fromValue !=
                                                                      null &&
                                                                    a.fromValue !==
                                                                      ""
                                                                      ? _c(
                                                                          "span",
                                                                          {
                                                                            staticClass:
                                                                              "grey--text text--darken-1",
                                                                          },
                                                                          [
                                                                            _vm._v(
                                                                              " " +
                                                                                _vm._s(
                                                                                  " " +
                                                                                    _vm.$t(
                                                                                      "ticketing.activity-from"
                                                                                    )
                                                                                ) +
                                                                                " "
                                                                            ),
                                                                          ]
                                                                        )
                                                                      : _vm._e(),
                                                                    a.fromValue !=
                                                                      null &&
                                                                    a.fromValue !==
                                                                      ""
                                                                      ? _c(
                                                                          "span",
                                                                          {
                                                                            staticClass:
                                                                              "activity-value",
                                                                          },
                                                                          [
                                                                            _vm._v(
                                                                              _vm._s(
                                                                                a.fromValue
                                                                              )
                                                                            ),
                                                                          ]
                                                                        )
                                                                      : _vm._e(),
                                                                    _c(
                                                                      "span",
                                                                      {
                                                                        staticClass:
                                                                          "grey--text text--darken-1",
                                                                      },
                                                                      [
                                                                        _vm._v(
                                                                          " " +
                                                                            _vm._s(
                                                                              " " +
                                                                                _vm.$t(
                                                                                  "ticketing.activity-to"
                                                                                )
                                                                            ) +
                                                                            " "
                                                                        ),
                                                                      ]
                                                                    ),
                                                                    _c(
                                                                      "span",
                                                                      {
                                                                        staticClass:
                                                                          "activity-value",
                                                                      },
                                                                      [
                                                                        _vm._v(
                                                                          _vm._s(
                                                                            a.toValue ||
                                                                              "—"
                                                                          )
                                                                        ),
                                                                      ]
                                                                    ),
                                                                  ]),
                                                            ]
                                                          ),
                                                          _c(
                                                            "div",
                                                            {
                                                              directives: [
                                                                {
                                                                  name: "cursor-tip",
                                                                  rawName:
                                                                    "v-cursor-tip",
                                                                  value:
                                                                    _vm.formatTimeAbsolute(
                                                                      a.createdAt
                                                                    ),
                                                                  expression:
                                                                    "formatTimeAbsolute(a.createdAt)",
                                                                },
                                                              ],
                                                              staticClass:
                                                                "text-caption grey--text",
                                                            },
                                                            [
                                                              _vm._v(
                                                                " " +
                                                                  _vm._s(
                                                                    _vm.formatTime(
                                                                      a.createdAt
                                                                    )
                                                                  ) +
                                                                  " "
                                                              ),
                                                            ]
                                                          ),
                                                        ]
                                                      ),
                                                    ],
                                                    1
                                                  )
                                                }
                                              ),
                                            ],
                                            2
                                          ),
                                        ]
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ]),
                            _c(
                              "div",
                              { staticClass: "td-side" },
                              [
                                _c(
                                  "v-card",
                                  {
                                    staticClass: "pa-3",
                                    attrs: { outlined: "" },
                                  },
                                  [
                                    _c("div", { staticClass: "field-block" }, [
                                      _c(
                                        "div",
                                        { staticClass: "d-flex align-center" },
                                        [
                                          _c(
                                            "v-icon",
                                            {
                                              staticClass: "mr-1 primary--text",
                                              attrs: { small: "" },
                                            },
                                            [_vm._v("mdi-domain")]
                                          ),
                                          _c(
                                            "span",
                                            { staticClass: "field-label mb-0" },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t(
                                                    "ticketing.affected-organizations"
                                                  )
                                                )
                                              ),
                                            ]
                                          ),
                                          _c(
                                            "v-chip",
                                            {
                                              staticClass: "ml-2",
                                              attrs: {
                                                "x-small": "",
                                                color: "primary",
                                                outlined: "",
                                              },
                                            },
                                            [
                                              _vm._v(
                                                " " +
                                                  _vm._s(
                                                    _vm
                                                      .activeTicketOrganizations
                                                      .length
                                                  ) +
                                                  " "
                                              ),
                                            ]
                                          ),
                                        ],
                                        1
                                      ),
                                      _c(
                                        "div",
                                        { staticClass: "mt-2" },
                                        [
                                          _c(
                                            "div",
                                            {
                                              class: [
                                                "affected-orgs-list",
                                                {
                                                  "is-expanded":
                                                    _vm.expandedAffectedOrgId,
                                                },
                                              ],
                                            },
                                            _vm._l(
                                              _vm.visibleAffectedOrganizations,
                                              function (o) {
                                                return _c(
                                                  "div",
                                                  {
                                                    key: o.id || o.name,
                                                    staticClass:
                                                      "affected-org-card mb-2",
                                                  },
                                                  [
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "affected-org-row d-flex align-center",
                                                        on: {
                                                          click: function (
                                                            $event
                                                          ) {
                                                            return _vm.toggleAffectedOrgExpand(
                                                              o.id
                                                            )
                                                          },
                                                        },
                                                      },
                                                      [
                                                        _c(
                                                          "v-icon",
                                                          {
                                                            staticClass:
                                                              "mr-1 grey--text",
                                                            attrs: {
                                                              small: "",
                                                            },
                                                          },
                                                          [
                                                            _vm._v(
                                                              " " +
                                                                _vm._s(
                                                                  _vm
                                                                    .expandedAffectedOrgs[
                                                                    o.id
                                                                  ]
                                                                    ? "mdi-chevron-down"
                                                                    : "mdi-chevron-right"
                                                                ) +
                                                                " "
                                                            ),
                                                          ]
                                                        ),
                                                        _c(
                                                          "v-avatar",
                                                          {
                                                            staticClass:
                                                              "mr-2 org-logo-avatar",
                                                            attrs: {
                                                              size: "28",
                                                            },
                                                          },
                                                          [
                                                            _vm.organizationLogo(
                                                              o.id
                                                            )
                                                              ? _c("v-img", {
                                                                  attrs: {
                                                                    src: _vm.organizationLogo(
                                                                      o.id
                                                                    ),
                                                                  },
                                                                })
                                                              : _c(
                                                                  "v-icon",
                                                                  {
                                                                    attrs: {
                                                                      small: "",
                                                                      color:
                                                                        "grey",
                                                                    },
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      "mdi-domain"
                                                                    ),
                                                                  ]
                                                                ),
                                                          ],
                                                          1
                                                        ),
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "flex-grow-1",
                                                            staticStyle: {
                                                              "min-width": "0",
                                                            },
                                                          },
                                                          [
                                                            _c(
                                                              "div",
                                                              {
                                                                staticClass:
                                                                  "d-flex align-center",
                                                                staticStyle: {
                                                                  "min-width":
                                                                    "0",
                                                                },
                                                              },
                                                              [
                                                                _c(
                                                                  "span",
                                                                  {
                                                                    staticClass:
                                                                      "text-body-2 text-truncate font-weight-medium",
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      _vm._s(
                                                                        o.name
                                                                      )
                                                                    ),
                                                                  ]
                                                                ),
                                                                o.id ===
                                                                _vm.activeTicket
                                                                  .organizationId
                                                                  ? _c(
                                                                      "v-chip",
                                                                      {
                                                                        staticClass:
                                                                          "ml-2 flex-shrink-0",
                                                                        attrs: {
                                                                          "x-small":
                                                                            "",
                                                                          color:
                                                                            "primary",
                                                                          outlined:
                                                                            "",
                                                                        },
                                                                      },
                                                                      [
                                                                        _vm._v(
                                                                          " " +
                                                                            _vm._s(
                                                                              _vm.$t(
                                                                                "ticketing.primary-organization"
                                                                              )
                                                                            ) +
                                                                            " "
                                                                        ),
                                                                      ]
                                                                    )
                                                                  : _vm._e(),
                                                              ],
                                                              1
                                                            ),
                                                            _c(
                                                              "div",
                                                              {
                                                                staticClass:
                                                                  "text-caption d-flex align-center",
                                                                class: {
                                                                  "red--text font-weight-medium":
                                                                    !o.assignedUserName,
                                                                },
                                                                staticStyle: {
                                                                  "min-width":
                                                                    "0",
                                                                },
                                                              },
                                                              [
                                                                _c(
                                                                  "v-icon",
                                                                  {
                                                                    staticClass:
                                                                      "mr-1 flex-shrink-0",
                                                                    attrs: {
                                                                      "x-small":
                                                                        "",
                                                                      color:
                                                                        !o.assignedUserName
                                                                          ? "red"
                                                                          : undefined,
                                                                    },
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      "mdi-account-outline"
                                                                    ),
                                                                  ]
                                                                ),
                                                                _c(
                                                                  "span",
                                                                  {
                                                                    staticClass:
                                                                      "text-truncate",
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      _vm._s(
                                                                        o.assignedUserName ||
                                                                          _vm.$t(
                                                                            "ticketing.no-contact"
                                                                          )
                                                                      )
                                                                    ),
                                                                  ]
                                                                ),
                                                                o.assignedUserName &&
                                                                _vm.affectedOrgUserRole(
                                                                  o
                                                                )
                                                                  ? [
                                                                      _c(
                                                                        "span",
                                                                        {
                                                                          staticClass:
                                                                            "grey--text mx-1 flex-shrink-0",
                                                                        },
                                                                        [
                                                                          _vm._v(
                                                                            "·"
                                                                          ),
                                                                        ]
                                                                      ),
                                                                      _c(
                                                                        "span",
                                                                        {
                                                                          staticClass:
                                                                            "flex-shrink-0",
                                                                          class:
                                                                            _vm.userRoleColor(
                                                                              _vm.affectedOrgUserRole(
                                                                                o
                                                                              )
                                                                            ),
                                                                          staticStyle:
                                                                            {
                                                                              "font-size":
                                                                                "0.7rem",
                                                                            },
                                                                        },
                                                                        [
                                                                          _vm._v(
                                                                            _vm._s(
                                                                              _vm.affectedOrgUserRole(
                                                                                o
                                                                              )
                                                                            )
                                                                          ),
                                                                        ]
                                                                      ),
                                                                    ]
                                                                  : _vm._e(),
                                                              ],
                                                              2
                                                            ),
                                                            o.id
                                                              ? _c(
                                                                  "div",
                                                                  {
                                                                    staticClass:
                                                                      "text-caption grey--text d-flex align-center",
                                                                    staticStyle:
                                                                      {
                                                                        "min-width":
                                                                          "0",
                                                                      },
                                                                  },
                                                                  [
                                                                    _c(
                                                                      "v-icon",
                                                                      {
                                                                        staticClass:
                                                                          "mr-1 flex-shrink-0",
                                                                        attrs: {
                                                                          "x-small":
                                                                            "",
                                                                        },
                                                                      },
                                                                      [
                                                                        _vm._v(
                                                                          "mdi-identifier"
                                                                        ),
                                                                      ]
                                                                    ),
                                                                    _c(
                                                                      "span",
                                                                      {
                                                                        staticClass:
                                                                          "text-truncate affected-org-id",
                                                                        on: {
                                                                          click:
                                                                            function (
                                                                              $event
                                                                            ) {
                                                                              $event.stopPropagation()
                                                                              return _vm.copyText(
                                                                                o.id
                                                                              )
                                                                            },
                                                                        },
                                                                      },
                                                                      [
                                                                        _vm._v(
                                                                          _vm._s(
                                                                            o.id
                                                                          )
                                                                        ),
                                                                      ]
                                                                    ),
                                                                    _c(
                                                                      "v-btn",
                                                                      {
                                                                        staticClass:
                                                                          "ml-1 flex-shrink-0",
                                                                        attrs: {
                                                                          icon: "",
                                                                          "x-small":
                                                                            "",
                                                                          title:
                                                                            _vm.$t(
                                                                              "copy"
                                                                            ),
                                                                        },
                                                                        on: {
                                                                          click:
                                                                            function (
                                                                              $event
                                                                            ) {
                                                                              $event.stopPropagation()
                                                                              return _vm.copyText(
                                                                                o.id
                                                                              )
                                                                            },
                                                                        },
                                                                      },
                                                                      [
                                                                        _c(
                                                                          "v-icon",
                                                                          {
                                                                            attrs:
                                                                              {
                                                                                "x-small":
                                                                                  "",
                                                                              },
                                                                          },
                                                                          [
                                                                            _vm._v(
                                                                              "mdi-content-copy"
                                                                            ),
                                                                          ]
                                                                        ),
                                                                      ],
                                                                      1
                                                                    ),
                                                                  ],
                                                                  1
                                                                )
                                                              : _vm._e(),
                                                          ]
                                                        ),
                                                        _c(
                                                          "v-menu",
                                                          {
                                                            attrs: {
                                                              "offset-y": "",
                                                              "close-on-content-click": true,
                                                              "max-height":
                                                                "420",
                                                            },
                                                            scopedSlots: _vm._u(
                                                              [
                                                                {
                                                                  key: "activator",
                                                                  fn: function ({
                                                                    on,
                                                                    attrs,
                                                                  }) {
                                                                    return [
                                                                      _c(
                                                                        "v-tooltip",
                                                                        {
                                                                          attrs:
                                                                            {
                                                                              top: "",
                                                                            },
                                                                          scopedSlots:
                                                                            _vm._u(
                                                                              [
                                                                                {
                                                                                  key: "activator",
                                                                                  fn: function ({
                                                                                    on: tOn,
                                                                                    attrs:
                                                                                      tAttrs,
                                                                                  }) {
                                                                                    return [
                                                                                      _c(
                                                                                        "v-btn",
                                                                                        _vm._g(
                                                                                          _vm._b(
                                                                                            {
                                                                                              attrs:
                                                                                                {
                                                                                                  icon: "",
                                                                                                  "x-small":
                                                                                                    "",
                                                                                                  loading:
                                                                                                    _vm.loggingFollowUpOrgId ===
                                                                                                    (o.id ||
                                                                                                      "_"),
                                                                                                },
                                                                                              on: {
                                                                                                click:
                                                                                                  function (
                                                                                                    $event
                                                                                                  ) {
                                                                                                    $event.stopPropagation()
                                                                                                  },
                                                                                              },
                                                                                            },
                                                                                            "v-btn",
                                                                                            {
                                                                                              ...attrs,
                                                                                              ...tAttrs,
                                                                                            },
                                                                                            false
                                                                                          ),
                                                                                          {
                                                                                            ...on,
                                                                                            ...tOn,
                                                                                          }
                                                                                        ),
                                                                                        [
                                                                                          _c(
                                                                                            "v-icon",
                                                                                            {
                                                                                              attrs:
                                                                                                {
                                                                                                  "x-small":
                                                                                                    "",
                                                                                                  color:
                                                                                                    !_vm.activeTicketOrgFollowUp(
                                                                                                      o.id
                                                                                                    )
                                                                                                      ? "red"
                                                                                                      : undefined,
                                                                                                },
                                                                                            },
                                                                                            [
                                                                                              _vm._v(
                                                                                                "mdi-phone-log-outline"
                                                                                              ),
                                                                                            ]
                                                                                          ),
                                                                                        ],
                                                                                        1
                                                                                      ),
                                                                                    ]
                                                                                  },
                                                                                },
                                                                              ],
                                                                              null,
                                                                              true
                                                                            ),
                                                                        },
                                                                        [
                                                                          _c(
                                                                            "span",
                                                                            [
                                                                              _vm._v(
                                                                                _vm._s(
                                                                                  _vm.$t(
                                                                                    "ticketing.log-follow-up"
                                                                                  )
                                                                                )
                                                                              ),
                                                                            ]
                                                                          ),
                                                                        ]
                                                                      ),
                                                                    ]
                                                                  },
                                                                },
                                                              ],
                                                              null,
                                                              true
                                                            ),
                                                          },
                                                          [
                                                            _c(
                                                              "v-list",
                                                              {
                                                                staticClass:
                                                                  "follow-up-contacts-menu",
                                                                attrs: {
                                                                  dense: "",
                                                                },
                                                              },
                                                              [
                                                                _c(
                                                                  "v-subheader",
                                                                  {
                                                                    staticClass:
                                                                      "text-caption",
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      " " +
                                                                        _vm._s(
                                                                          _vm.$t(
                                                                            "ticketing.follow-up-with"
                                                                          )
                                                                        ) +
                                                                        " "
                                                                    ),
                                                                  ]
                                                                ),
                                                                _vm._l(
                                                                  _vm.orgFollowUpContacts(
                                                                    o
                                                                  ),
                                                                  function (
                                                                    c,
                                                                    ci
                                                                  ) {
                                                                    return _c(
                                                                      "v-list-item",
                                                                      {
                                                                        key: `${
                                                                          o.id ||
                                                                          "_"
                                                                        }-c-${ci}`,
                                                                        staticClass:
                                                                          "follow-up-contact-item",
                                                                        class: {
                                                                          "follow-up-contact-item--missing":
                                                                            !c.name,
                                                                        },
                                                                      },
                                                                      [
                                                                        _c(
                                                                          "v-list-item-avatar",
                                                                          {
                                                                            staticClass:
                                                                              "white--text text-caption mr-2",
                                                                            attrs:
                                                                              {
                                                                                size: "28",
                                                                                color:
                                                                                  c.name
                                                                                    ? _vm.userColor(
                                                                                        c.name
                                                                                      )
                                                                                    : "grey lighten-2",
                                                                              },
                                                                          },
                                                                          [
                                                                            c.name
                                                                              ? [
                                                                                  _vm._v(
                                                                                    " " +
                                                                                      _vm._s(
                                                                                        _vm.viewerInitials(
                                                                                          c.name
                                                                                        )
                                                                                      ) +
                                                                                      " "
                                                                                  ),
                                                                                ]
                                                                              : _c(
                                                                                  "v-icon",
                                                                                  {
                                                                                    attrs:
                                                                                      {
                                                                                        "x-small":
                                                                                          "",
                                                                                        color:
                                                                                          "grey darken-1",
                                                                                      },
                                                                                  },
                                                                                  [
                                                                                    _vm._v(
                                                                                      "mdi-account-off-outline"
                                                                                    ),
                                                                                  ]
                                                                                ),
                                                                          ],
                                                                          2
                                                                        ),
                                                                        _c(
                                                                          "v-list-item-content",
                                                                          [
                                                                            c.name
                                                                              ? [
                                                                                  _c(
                                                                                    "v-list-item-title",
                                                                                    {
                                                                                      staticClass:
                                                                                        "text-body-2",
                                                                                    },
                                                                                    [
                                                                                      _vm._v(
                                                                                        " " +
                                                                                          _vm._s(
                                                                                            c.name
                                                                                          ) +
                                                                                          " "
                                                                                      ),
                                                                                    ]
                                                                                  ),
                                                                                  _c(
                                                                                    "v-list-item-subtitle",
                                                                                    {
                                                                                      staticClass:
                                                                                        "text-caption",
                                                                                    },
                                                                                    [
                                                                                      _vm._v(
                                                                                        " " +
                                                                                          _vm._s(
                                                                                            c.kindLabel
                                                                                          ) +
                                                                                          " "
                                                                                      ),
                                                                                    ]
                                                                                  ),
                                                                                ]
                                                                              : [
                                                                                  _c(
                                                                                    "v-list-item-title",
                                                                                    {
                                                                                      staticClass:
                                                                                        "text-body-2 grey--text text--darken-1",
                                                                                    },
                                                                                    [
                                                                                      _vm._v(
                                                                                        " " +
                                                                                          _vm._s(
                                                                                            c.kindLabel
                                                                                          ) +
                                                                                          " "
                                                                                      ),
                                                                                    ]
                                                                                  ),
                                                                                  _c(
                                                                                    "v-list-item-subtitle",
                                                                                    {
                                                                                      staticClass:
                                                                                        "text-caption grey--text",
                                                                                    },
                                                                                    [
                                                                                      _c(
                                                                                        "a",
                                                                                        {
                                                                                          staticClass:
                                                                                            "primary--text follow-up-contact-link",
                                                                                          attrs:
                                                                                            {
                                                                                              href: "#",
                                                                                            },
                                                                                          on: {
                                                                                            click:
                                                                                              function (
                                                                                                $event
                                                                                              ) {
                                                                                                $event.preventDefault()
                                                                                                return _vm.expandAffectedOrgFromMenu(
                                                                                                  o.id,
                                                                                                  c.kind
                                                                                                )
                                                                                              },
                                                                                          },
                                                                                        },
                                                                                        [
                                                                                          _vm._v(
                                                                                            " " +
                                                                                              _vm._s(
                                                                                                _vm.$t(
                                                                                                  "ticketing.follow-up-contact-missing." +
                                                                                                    c.kind
                                                                                                )
                                                                                              ) +
                                                                                              " "
                                                                                          ),
                                                                                        ]
                                                                                      ),
                                                                                    ]
                                                                                  ),
                                                                                ],
                                                                          ],
                                                                          2
                                                                        ),
                                                                        _c(
                                                                          "v-list-item-action",
                                                                          {
                                                                            staticClass:
                                                                              "ma-0",
                                                                          },
                                                                          [
                                                                            _c(
                                                                              "div",
                                                                              {
                                                                                staticClass:
                                                                                  "d-flex align-center",
                                                                                staticStyle:
                                                                                  {
                                                                                    gap: "2px",
                                                                                  },
                                                                              },
                                                                              _vm._l(
                                                                                _vm.followUpMethods,
                                                                                function (
                                                                                  m
                                                                                ) {
                                                                                  return _c(
                                                                                    "v-tooltip",
                                                                                    {
                                                                                      key: m.value,
                                                                                      attrs:
                                                                                        {
                                                                                          top: "",
                                                                                          disabled:
                                                                                            !c.name,
                                                                                        },
                                                                                      scopedSlots:
                                                                                        _vm._u(
                                                                                          [
                                                                                            {
                                                                                              key: "activator",
                                                                                              fn: function ({
                                                                                                on: mOn,
                                                                                                attrs:
                                                                                                  mAttrs,
                                                                                              }) {
                                                                                                return [
                                                                                                  _c(
                                                                                                    "v-btn",
                                                                                                    _vm._g(
                                                                                                      _vm._b(
                                                                                                        {
                                                                                                          attrs:
                                                                                                            {
                                                                                                              icon: "",
                                                                                                              "x-small":
                                                                                                                "",
                                                                                                              disabled:
                                                                                                                !c.name,
                                                                                                            },
                                                                                                          on: {
                                                                                                            click:
                                                                                                              function (
                                                                                                                $event
                                                                                                              ) {
                                                                                                                $event.stopPropagation()
                                                                                                                return _vm.logFollowUpClick(
                                                                                                                  m.value,
                                                                                                                  o,
                                                                                                                  c
                                                                                                                )
                                                                                                              },
                                                                                                          },
                                                                                                        },
                                                                                                        "v-btn",
                                                                                                        mAttrs,
                                                                                                        false
                                                                                                      ),
                                                                                                      mOn
                                                                                                    ),
                                                                                                    [
                                                                                                      _c(
                                                                                                        "v-icon",
                                                                                                        {
                                                                                                          attrs:
                                                                                                            {
                                                                                                              small:
                                                                                                                "",
                                                                                                            },
                                                                                                        },
                                                                                                        [
                                                                                                          _vm._v(
                                                                                                            _vm._s(
                                                                                                              m.icon
                                                                                                            )
                                                                                                          ),
                                                                                                        ]
                                                                                                      ),
                                                                                                    ],
                                                                                                    1
                                                                                                  ),
                                                                                                ]
                                                                                              },
                                                                                            },
                                                                                          ],
                                                                                          null,
                                                                                          true
                                                                                        ),
                                                                                    },
                                                                                    [
                                                                                      _c(
                                                                                        "span",
                                                                                        [
                                                                                          _vm._v(
                                                                                            _vm._s(
                                                                                              m.text
                                                                                            )
                                                                                          ),
                                                                                        ]
                                                                                      ),
                                                                                    ]
                                                                                  )
                                                                                }
                                                                              ),
                                                                              1
                                                                            ),
                                                                          ]
                                                                        ),
                                                                      ],
                                                                      1
                                                                    )
                                                                  }
                                                                ),
                                                              ],
                                                              2
                                                            ),
                                                          ],
                                                          1
                                                        ),
                                                        _c(
                                                          "v-tooltip",
                                                          {
                                                            attrs: { top: "" },
                                                            scopedSlots: _vm._u(
                                                              [
                                                                {
                                                                  key: "activator",
                                                                  fn: function ({
                                                                    on,
                                                                    attrs,
                                                                  }) {
                                                                    return [
                                                                      _c(
                                                                        "v-btn",
                                                                        _vm._g(
                                                                          _vm._b(
                                                                            {
                                                                              attrs:
                                                                                {
                                                                                  icon: "",
                                                                                  "x-small":
                                                                                    "",
                                                                                },
                                                                              on: {
                                                                                click:
                                                                                  function (
                                                                                    $event
                                                                                  ) {
                                                                                    $event.stopPropagation()
                                                                                    return _vm.openOrgTicketsFor(
                                                                                      o.id
                                                                                    )
                                                                                  },
                                                                              },
                                                                            },
                                                                            "v-btn",
                                                                            attrs,
                                                                            false
                                                                          ),
                                                                          on
                                                                        ),
                                                                        [
                                                                          _c(
                                                                            "v-icon",
                                                                            {
                                                                              attrs:
                                                                                {
                                                                                  "x-small":
                                                                                    "",
                                                                                },
                                                                            },
                                                                            [
                                                                              _vm._v(
                                                                                "mdi-format-list-bulleted"
                                                                              ),
                                                                            ]
                                                                          ),
                                                                        ],
                                                                        1
                                                                      ),
                                                                    ]
                                                                  },
                                                                },
                                                              ],
                                                              null,
                                                              true
                                                            ),
                                                          },
                                                          [
                                                            _c("span", [
                                                              _vm._v(
                                                                _vm._s(
                                                                  _vm.$t(
                                                                    "ticketing.org-tickets"
                                                                  )
                                                                )
                                                              ),
                                                            ]),
                                                          ]
                                                        ),
                                                        _c(
                                                          "v-tooltip",
                                                          {
                                                            attrs: { top: "" },
                                                            scopedSlots: _vm._u(
                                                              [
                                                                {
                                                                  key: "activator",
                                                                  fn: function ({
                                                                    on,
                                                                    attrs,
                                                                  }) {
                                                                    return [
                                                                      _c(
                                                                        "v-btn",
                                                                        _vm._g(
                                                                          _vm._b(
                                                                            {
                                                                              attrs:
                                                                                {
                                                                                  icon: "",
                                                                                  "x-small":
                                                                                    "",
                                                                                },
                                                                              on: {
                                                                                click:
                                                                                  function (
                                                                                    $event
                                                                                  ) {
                                                                                    $event.stopPropagation()
                                                                                    return _vm.impersonateOrganization(
                                                                                      o.id
                                                                                    )
                                                                                  },
                                                                              },
                                                                            },
                                                                            "v-btn",
                                                                            attrs,
                                                                            false
                                                                          ),
                                                                          on
                                                                        ),
                                                                        [
                                                                          _c(
                                                                            "v-icon",
                                                                            {
                                                                              attrs:
                                                                                {
                                                                                  "x-small":
                                                                                    "",
                                                                                },
                                                                            },
                                                                            [
                                                                              _vm._v(
                                                                                "mdi-login-variant"
                                                                              ),
                                                                            ]
                                                                          ),
                                                                        ],
                                                                        1
                                                                      ),
                                                                    ]
                                                                  },
                                                                },
                                                              ],
                                                              null,
                                                              true
                                                            ),
                                                          },
                                                          [
                                                            _c("span", [
                                                              _vm._v(
                                                                _vm._s(
                                                                  _vm.$t(
                                                                    "impersonate"
                                                                  )
                                                                )
                                                              ),
                                                            ]),
                                                          ]
                                                        ),
                                                        o.id !==
                                                          _vm.activeTicket
                                                            .organizationId ||
                                                        _vm
                                                          .activeTicketOrganizations
                                                          .length > 1
                                                          ? _c(
                                                              "v-tooltip",
                                                              {
                                                                attrs: {
                                                                  top: "",
                                                                },
                                                                scopedSlots:
                                                                  _vm._u(
                                                                    [
                                                                      {
                                                                        key: "activator",
                                                                        fn: function ({
                                                                          on,
                                                                          attrs,
                                                                        }) {
                                                                          return [
                                                                            _c(
                                                                              "v-btn",
                                                                              _vm._g(
                                                                                _vm._b(
                                                                                  {
                                                                                    attrs:
                                                                                      {
                                                                                        icon: "",
                                                                                        "x-small":
                                                                                          "",
                                                                                      },
                                                                                    on: {
                                                                                      click:
                                                                                        function (
                                                                                          $event
                                                                                        ) {
                                                                                          $event.stopPropagation()
                                                                                          return _vm.removeAffectedOrg(
                                                                                            o.id
                                                                                          )
                                                                                        },
                                                                                    },
                                                                                  },
                                                                                  "v-btn",
                                                                                  attrs,
                                                                                  false
                                                                                ),
                                                                                on
                                                                              ),
                                                                              [
                                                                                _c(
                                                                                  "v-icon",
                                                                                  {
                                                                                    attrs:
                                                                                      {
                                                                                        "x-small":
                                                                                          "",
                                                                                      },
                                                                                  },
                                                                                  [
                                                                                    _vm._v(
                                                                                      "mdi-close"
                                                                                    ),
                                                                                  ]
                                                                                ),
                                                                              ],
                                                                              1
                                                                            ),
                                                                          ]
                                                                        },
                                                                      },
                                                                    ],
                                                                    null,
                                                                    true
                                                                  ),
                                                              },
                                                              [
                                                                _c("span", [
                                                                  _vm._v(
                                                                    _vm._s(
                                                                      _vm.$t(
                                                                        "ticketing.remove-organization"
                                                                      )
                                                                    )
                                                                  ),
                                                                ]),
                                                              ]
                                                            )
                                                          : _vm._e(),
                                                      ],
                                                      1
                                                    ),
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "affected-org-follow-up pb-1",
                                                        staticStyle: {
                                                          "padding-left":
                                                            "56px",
                                                          "padding-right":
                                                            "8px",
                                                        },
                                                      },
                                                      [
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "text-caption",
                                                            class:
                                                              _vm.activeTicketOrgFollowUp(
                                                                o.id
                                                              ) &&
                                                              !_vm.isFollowUpStale(
                                                                _vm.activeTicketOrgFollowUp(
                                                                  o.id
                                                                ).at
                                                              )
                                                                ? "primary--text"
                                                                : "red--text font-weight-medium",
                                                            staticStyle: {
                                                              width: "100%",
                                                              display: "flex",
                                                              "align-items":
                                                                "center",
                                                            },
                                                          },
                                                          [
                                                            _c(
                                                              "v-icon",
                                                              {
                                                                staticClass:
                                                                  "mr-1 flex-shrink-0",
                                                                attrs: {
                                                                  "x-small": "",
                                                                  color:
                                                                    _vm.activeTicketOrgFollowUp(
                                                                      o.id
                                                                    ) &&
                                                                    !_vm.isFollowUpStale(
                                                                      _vm.activeTicketOrgFollowUp(
                                                                        o.id
                                                                      ).at
                                                                    )
                                                                      ? "primary"
                                                                      : "red",
                                                                },
                                                              },
                                                              [
                                                                _vm._v(
                                                                  " mdi-phone-log-outline "
                                                                ),
                                                              ]
                                                            ),
                                                            _vm.activeTicketOrgFollowUp(
                                                              o.id
                                                            )
                                                              ? _c(
                                                                  "div",
                                                                  {
                                                                    directives:
                                                                      [
                                                                        {
                                                                          name: "cursor-tip",
                                                                          rawName:
                                                                            "v-cursor-tip",
                                                                          value:
                                                                            _vm.followUpTooltip(
                                                                              _vm.activeTicketOrgFollowUp(
                                                                                o.id
                                                                              )
                                                                            ),
                                                                          expression:
                                                                            "followUpTooltip(activeTicketOrgFollowUp(o.id))",
                                                                        },
                                                                      ],
                                                                    staticStyle:
                                                                      {
                                                                        flex: "1 1 0",
                                                                        "min-width":
                                                                          "0",
                                                                        overflow:
                                                                          "hidden",
                                                                        "text-overflow":
                                                                          "ellipsis",
                                                                        "white-space":
                                                                          "nowrap",
                                                                      },
                                                                  },
                                                                  [
                                                                    _vm.followUpContactLabel(
                                                                      _vm.activeTicketOrgFollowUp(
                                                                        o.id
                                                                      )
                                                                    )
                                                                      ? _c(
                                                                          "span",
                                                                          [
                                                                            _vm._v(
                                                                              "· " +
                                                                                _vm._s(
                                                                                  _vm.followUpContactLabel(
                                                                                    _vm.activeTicketOrgFollowUp(
                                                                                      o.id
                                                                                    )
                                                                                  )
                                                                                ) +
                                                                                " "
                                                                            ),
                                                                          ]
                                                                        )
                                                                      : _vm._e(),
                                                                    _vm._v(
                                                                      "· " +
                                                                        _vm._s(
                                                                          _vm.$t(
                                                                            "ticketing.follow-up-method." +
                                                                              _vm.activeTicketOrgFollowUp(
                                                                                o.id
                                                                              )
                                                                                .method
                                                                          )
                                                                        ) +
                                                                        " · " +
                                                                        _vm._s(
                                                                          _vm.formatTime(
                                                                            _vm.activeTicketOrgFollowUp(
                                                                              o.id
                                                                            ).at
                                                                          )
                                                                        )
                                                                    ),
                                                                    _vm.activeTicketOrgFollowUp(
                                                                      o.id
                                                                    ).byUserName
                                                                      ? _c(
                                                                          "span",
                                                                          [
                                                                            _vm._v(
                                                                              " · " +
                                                                                _vm._s(
                                                                                  _vm.$t(
                                                                                    "ticketing.follow-up-by",
                                                                                    {
                                                                                      name: _vm.activeTicketOrgFollowUp(
                                                                                        o.id
                                                                                      )
                                                                                        .byUserName,
                                                                                    }
                                                                                  )
                                                                                )
                                                                            ),
                                                                          ]
                                                                        )
                                                                      : _vm._e(),
                                                                  ]
                                                                )
                                                              : _c(
                                                                  "span",
                                                                  {
                                                                    staticStyle:
                                                                      {
                                                                        flex: "1 1 0",
                                                                        "min-width":
                                                                          "0",
                                                                      },
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      _vm._s(
                                                                        _vm.$t(
                                                                          "ticketing.never-follow-up"
                                                                        )
                                                                      )
                                                                    ),
                                                                  ]
                                                                ),
                                                            _vm.activeTicketOrgFollowUp(
                                                              o.id
                                                            ) &&
                                                            _vm.previousFollowUpsForOrg(
                                                              o.id
                                                            ).length
                                                              ? _c(
                                                                  "v-btn",
                                                                  {
                                                                    staticClass:
                                                                      "px-1 text-caption text-none follow-up-toggle-btn",
                                                                    staticStyle:
                                                                      {
                                                                        "flex-shrink":
                                                                          "0",
                                                                        "margin-left":
                                                                          "4px",
                                                                      },
                                                                    attrs: {
                                                                      text: "",
                                                                      "x-small":
                                                                        "",
                                                                    },
                                                                    on: {
                                                                      click:
                                                                        function (
                                                                          $event
                                                                        ) {
                                                                          $event.stopPropagation()
                                                                          return _vm.togglePrevFollowUps(
                                                                            o.id,
                                                                            $event
                                                                          )
                                                                        },
                                                                    },
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      " " +
                                                                        _vm._s(
                                                                          _vm
                                                                            .expandedPrevFollowUpsByOrg[
                                                                            o.id ||
                                                                              "_"
                                                                          ]
                                                                            ? _vm.$t(
                                                                                "ticketing.show-less"
                                                                              )
                                                                            : _vm.$t(
                                                                                "ticketing.show-more"
                                                                              )
                                                                        ) +
                                                                        " "
                                                                    ),
                                                                  ]
                                                                )
                                                              : _vm._e(),
                                                          ],
                                                          1
                                                        ),
                                                        _vm.activeTicketOrgFollowUp(
                                                          o.id
                                                        ) &&
                                                        _vm
                                                          .expandedPrevFollowUpsByOrg[
                                                          o.id || "_"
                                                        ] &&
                                                        _vm.previousFollowUpsForOrg(
                                                          o.id
                                                        ).length
                                                          ? _c(
                                                              "div",
                                                              {
                                                                directives: [
                                                                  {
                                                                    name: "click-outside",
                                                                    rawName:
                                                                      "v-click-outside",
                                                                    value: () =>
                                                                      _vm.collapsePrevFollowUps(
                                                                        o.id
                                                                      ),
                                                                    expression:
                                                                      "() => collapsePrevFollowUps(o.id)",
                                                                  },
                                                                ],
                                                                staticClass:
                                                                  "prev-follow-ups grey--text text--darken-1",
                                                                on: {
                                                                  click:
                                                                    function (
                                                                      $event
                                                                    ) {
                                                                      $event.stopPropagation()
                                                                    },
                                                                },
                                                              },
                                                              _vm._l(
                                                                _vm.previousFollowUpsForOrg(
                                                                  o.id
                                                                ),
                                                                function (
                                                                  entry,
                                                                  idx
                                                                ) {
                                                                  return _c(
                                                                    "div",
                                                                    {
                                                                      key: idx,
                                                                      staticClass:
                                                                        "text-caption d-flex align-center",
                                                                    },
                                                                    [
                                                                      _c(
                                                                        "v-icon",
                                                                        {
                                                                          staticClass:
                                                                            "mr-1",
                                                                          attrs:
                                                                            {
                                                                              "x-small":
                                                                                "",
                                                                            },
                                                                        },
                                                                        [
                                                                          _vm._v(
                                                                            "mdi-phone-log-outline"
                                                                          ),
                                                                        ]
                                                                      ),
                                                                      _c(
                                                                        "span",
                                                                        {
                                                                          directives:
                                                                            [
                                                                              {
                                                                                name: "cursor-tip",
                                                                                rawName:
                                                                                  "v-cursor-tip",
                                                                                value:
                                                                                  _vm.followUpTooltip(
                                                                                    entry
                                                                                  ),
                                                                                expression:
                                                                                  "followUpTooltip(entry)",
                                                                              },
                                                                            ],
                                                                          staticClass:
                                                                            "text-truncate",
                                                                        },
                                                                        [
                                                                          _vm.followUpContactLabel(
                                                                            entry
                                                                          )
                                                                            ? _c(
                                                                                "span",
                                                                                [
                                                                                  _vm._v(
                                                                                    "· " +
                                                                                      _vm._s(
                                                                                        _vm.followUpContactLabel(
                                                                                          entry
                                                                                        )
                                                                                      ) +
                                                                                      " "
                                                                                  ),
                                                                                ]
                                                                              )
                                                                            : _vm._e(),
                                                                          _vm._v(
                                                                            "· " +
                                                                              _vm._s(
                                                                                _vm.$t(
                                                                                  "ticketing.follow-up-method." +
                                                                                    entry.method
                                                                                )
                                                                              ) +
                                                                              " · " +
                                                                              _vm._s(
                                                                                _vm.formatTime(
                                                                                  entry.at
                                                                                )
                                                                              )
                                                                          ),
                                                                          entry.byUserName
                                                                            ? _c(
                                                                                "span",
                                                                                [
                                                                                  _vm._v(
                                                                                    " · " +
                                                                                      _vm._s(
                                                                                        _vm.$t(
                                                                                          "ticketing.follow-up-by",
                                                                                          {
                                                                                            name: entry.byUserName,
                                                                                          }
                                                                                        )
                                                                                      )
                                                                                  ),
                                                                                ]
                                                                              )
                                                                            : _vm._e(),
                                                                        ]
                                                                      ),
                                                                    ],
                                                                    1
                                                                  )
                                                                }
                                                              ),
                                                              0
                                                            )
                                                          : _vm._e(),
                                                      ]
                                                    ),
                                                    _c("v-expand-transition", [
                                                      _vm.expandedAffectedOrgs[
                                                        o.id
                                                      ]
                                                        ? _c(
                                                            "div",
                                                            {
                                                              staticClass:
                                                                "affected-org-details pa-3",
                                                            },
                                                            [
                                                              _c(
                                                                "div",
                                                                {
                                                                  staticClass:
                                                                    "d-flex align-center mb-1",
                                                                },
                                                                [
                                                                  !o.assignedUserName &&
                                                                  !_vm
                                                                    .changeContactOpen[
                                                                    o.id
                                                                  ]
                                                                    ? _c(
                                                                        "div",
                                                                        [
                                                                          _c(
                                                                            "div",
                                                                            {
                                                                              staticClass:
                                                                                "text-caption font-weight-medium grey--text text--darken-1",
                                                                            },
                                                                            [
                                                                              _vm._v(
                                                                                " " +
                                                                                  _vm._s(
                                                                                    _vm.$t(
                                                                                      "ticketing.assigned-user"
                                                                                    )
                                                                                  ) +
                                                                                  " "
                                                                              ),
                                                                            ]
                                                                          ),
                                                                          _c(
                                                                            "div",
                                                                            {
                                                                              staticClass:
                                                                                "text-caption grey--text",
                                                                            },
                                                                            [
                                                                              _vm._v(
                                                                                " " +
                                                                                  _vm._s(
                                                                                    _vm.$t(
                                                                                      "ticketing.no-contact-yet"
                                                                                    )
                                                                                  ) +
                                                                                  " "
                                                                              ),
                                                                            ]
                                                                          ),
                                                                        ]
                                                                      )
                                                                    : _c(
                                                                        "span",
                                                                        {
                                                                          staticClass:
                                                                            "text-caption font-weight-medium grey--text text--darken-1",
                                                                        },
                                                                        [
                                                                          _vm._v(
                                                                            " " +
                                                                              _vm._s(
                                                                                _vm.$t(
                                                                                  "ticketing.assigned-user"
                                                                                )
                                                                              ) +
                                                                              " "
                                                                          ),
                                                                        ]
                                                                      ),
                                                                  _c(
                                                                    "v-spacer"
                                                                  ),
                                                                  !o.assignedUserName &&
                                                                  !_vm
                                                                    .changeContactOpen[
                                                                    o.id
                                                                  ]
                                                                    ? _c(
                                                                        "v-tooltip",
                                                                        {
                                                                          attrs:
                                                                            {
                                                                              top: "",
                                                                            },
                                                                          scopedSlots:
                                                                            _vm._u(
                                                                              [
                                                                                {
                                                                                  key: "activator",
                                                                                  fn: function ({
                                                                                    on,
                                                                                    attrs,
                                                                                  }) {
                                                                                    return [
                                                                                      _c(
                                                                                        "v-btn",
                                                                                        _vm._g(
                                                                                          _vm._b(
                                                                                            {
                                                                                              attrs:
                                                                                                {
                                                                                                  icon: "",
                                                                                                  "x-small":
                                                                                                    "",
                                                                                                  color:
                                                                                                    "primary",
                                                                                                },
                                                                                              on: {
                                                                                                click:
                                                                                                  function (
                                                                                                    $event
                                                                                                  ) {
                                                                                                    return _vm.openChangeContact(
                                                                                                      o.id
                                                                                                    )
                                                                                                  },
                                                                                              },
                                                                                            },
                                                                                            "v-btn",
                                                                                            attrs,
                                                                                            false
                                                                                          ),
                                                                                          on
                                                                                        ),
                                                                                        [
                                                                                          _c(
                                                                                            "v-icon",
                                                                                            {
                                                                                              attrs:
                                                                                                {
                                                                                                  small:
                                                                                                    "",
                                                                                                },
                                                                                            },
                                                                                            [
                                                                                              _vm._v(
                                                                                                "mdi-plus"
                                                                                              ),
                                                                                            ]
                                                                                          ),
                                                                                        ],
                                                                                        1
                                                                                      ),
                                                                                    ]
                                                                                  },
                                                                                },
                                                                              ],
                                                                              null,
                                                                              true
                                                                            ),
                                                                        },
                                                                        [
                                                                          _c(
                                                                            "span",
                                                                            [
                                                                              _vm._v(
                                                                                _vm._s(
                                                                                  _vm.$t(
                                                                                    "ticketing.set-contact"
                                                                                  )
                                                                                )
                                                                              ),
                                                                            ]
                                                                          ),
                                                                        ]
                                                                      )
                                                                    : _vm._e(),
                                                                ],
                                                                1
                                                              ),
                                                              o.assignedUserName &&
                                                              !_vm
                                                                .changeContactOpen[
                                                                o.id
                                                              ]
                                                                ? _c(
                                                                    "div",
                                                                    {
                                                                      staticClass:
                                                                        "affected-contact-row d-flex align-center mb-2",
                                                                    },
                                                                    [
                                                                      _c(
                                                                        "v-avatar",
                                                                        {
                                                                          staticClass:
                                                                            "mr-2 white--text text-caption flex-shrink-0",
                                                                          attrs:
                                                                            {
                                                                              size: "26",
                                                                              color:
                                                                                _vm.userColor(
                                                                                  o.assignedUserId
                                                                                ),
                                                                            },
                                                                        },
                                                                        [
                                                                          _vm._v(
                                                                            " " +
                                                                              _vm._s(
                                                                                _vm.viewerInitials(
                                                                                  o.assignedUserName
                                                                                )
                                                                              ) +
                                                                              " "
                                                                          ),
                                                                        ]
                                                                      ),
                                                                      _c(
                                                                        "div",
                                                                        {
                                                                          staticClass:
                                                                            "flex-grow-1",
                                                                          staticStyle:
                                                                            {
                                                                              "min-width":
                                                                                "0",
                                                                            },
                                                                        },
                                                                        [
                                                                          _c(
                                                                            "div",
                                                                            {
                                                                              staticClass:
                                                                                "text-body-2 text-truncate",
                                                                            },
                                                                            [
                                                                              _vm._v(
                                                                                " " +
                                                                                  _vm._s(
                                                                                    o.assignedUserName
                                                                                  ) +
                                                                                  " "
                                                                              ),
                                                                              _vm.affectedOrgUserRole(
                                                                                o
                                                                              )
                                                                                ? [
                                                                                    _c(
                                                                                      "span",
                                                                                      {
                                                                                        staticClass:
                                                                                          "grey--text mx-1",
                                                                                      },
                                                                                      [
                                                                                        _vm._v(
                                                                                          "·"
                                                                                        ),
                                                                                      ]
                                                                                    ),
                                                                                    _c(
                                                                                      "span",
                                                                                      {
                                                                                        class:
                                                                                          _vm.userRoleColor(
                                                                                            _vm.affectedOrgUserRole(
                                                                                              o
                                                                                            )
                                                                                          ),
                                                                                      },
                                                                                      [
                                                                                        _vm._v(
                                                                                          _vm._s(
                                                                                            _vm.affectedOrgUserRole(
                                                                                              o
                                                                                            )
                                                                                          )
                                                                                        ),
                                                                                      ]
                                                                                    ),
                                                                                  ]
                                                                                : _vm._e(),
                                                                            ],
                                                                            2
                                                                          ),
                                                                          o.assignedUserEmail
                                                                            ? _c(
                                                                                "div",
                                                                                {
                                                                                  staticClass:
                                                                                    "d-flex align-center",
                                                                                },
                                                                                [
                                                                                  _c(
                                                                                    "a",
                                                                                    {
                                                                                      staticClass:
                                                                                        "text-caption primary--text contact-phone-link text-truncate",
                                                                                      attrs:
                                                                                        {
                                                                                          href: "#",
                                                                                        },
                                                                                      on: {
                                                                                        click:
                                                                                          function (
                                                                                            $event
                                                                                          ) {
                                                                                            $event.preventDefault()
                                                                                            return _vm.copyText(
                                                                                              o.assignedUserEmail
                                                                                            )
                                                                                          },
                                                                                      },
                                                                                    },
                                                                                    [
                                                                                      _vm._v(
                                                                                        _vm._s(
                                                                                          o.assignedUserEmail
                                                                                        )
                                                                                      ),
                                                                                    ]
                                                                                  ),
                                                                                  _c(
                                                                                    "v-btn",
                                                                                    {
                                                                                      staticClass:
                                                                                        "ml-1",
                                                                                      attrs:
                                                                                        {
                                                                                          icon: "",
                                                                                          "x-small":
                                                                                            "",
                                                                                          title:
                                                                                            _vm.$t(
                                                                                              "copy"
                                                                                            ),
                                                                                        },
                                                                                      on: {
                                                                                        click:
                                                                                          function (
                                                                                            $event
                                                                                          ) {
                                                                                            return _vm.copyText(
                                                                                              o.assignedUserEmail
                                                                                            )
                                                                                          },
                                                                                      },
                                                                                    },
                                                                                    [
                                                                                      _c(
                                                                                        "v-icon",
                                                                                        {
                                                                                          attrs:
                                                                                            {
                                                                                              "x-small":
                                                                                                "",
                                                                                            },
                                                                                        },
                                                                                        [
                                                                                          _vm._v(
                                                                                            "mdi-content-copy"
                                                                                          ),
                                                                                        ]
                                                                                      ),
                                                                                    ],
                                                                                    1
                                                                                  ),
                                                                                ],
                                                                                1
                                                                              )
                                                                            : _vm._e(),
                                                                          o.assignedUserId
                                                                            ? _c(
                                                                                "div",
                                                                                {
                                                                                  staticClass:
                                                                                    "text-caption grey--text d-flex align-center",
                                                                                },
                                                                                [
                                                                                  _c(
                                                                                    "span",
                                                                                    {
                                                                                      staticClass:
                                                                                        "text-truncate",
                                                                                    },
                                                                                    [
                                                                                      _vm._v(
                                                                                        _vm._s(
                                                                                          o.assignedUserId
                                                                                        )
                                                                                      ),
                                                                                    ]
                                                                                  ),
                                                                                  _c(
                                                                                    "v-btn",
                                                                                    {
                                                                                      staticClass:
                                                                                        "ml-1",
                                                                                      attrs:
                                                                                        {
                                                                                          icon: "",
                                                                                          "x-small":
                                                                                            "",
                                                                                          title:
                                                                                            _vm.$t(
                                                                                              "copy"
                                                                                            ),
                                                                                        },
                                                                                      on: {
                                                                                        click:
                                                                                          function (
                                                                                            $event
                                                                                          ) {
                                                                                            return _vm.copyText(
                                                                                              o.assignedUserId
                                                                                            )
                                                                                          },
                                                                                      },
                                                                                    },
                                                                                    [
                                                                                      _c(
                                                                                        "v-icon",
                                                                                        {
                                                                                          attrs:
                                                                                            {
                                                                                              "x-small":
                                                                                                "",
                                                                                            },
                                                                                        },
                                                                                        [
                                                                                          _vm._v(
                                                                                            "mdi-content-copy"
                                                                                          ),
                                                                                        ]
                                                                                      ),
                                                                                    ],
                                                                                    1
                                                                                  ),
                                                                                ],
                                                                                1
                                                                              )
                                                                            : _vm._e(),
                                                                        ]
                                                                      ),
                                                                      _c(
                                                                        "div",
                                                                        {
                                                                          staticClass:
                                                                            "d-flex align-center flex-shrink-0 ml-1",
                                                                        },
                                                                        [
                                                                          _c(
                                                                            "v-btn",
                                                                            {
                                                                              attrs:
                                                                                {
                                                                                  icon: "",
                                                                                  "x-small":
                                                                                    "",
                                                                                  color:
                                                                                    "primary",
                                                                                },
                                                                              on: {
                                                                                click:
                                                                                  function (
                                                                                    $event
                                                                                  ) {
                                                                                    return _vm.openChangeContact(
                                                                                      o.id
                                                                                    )
                                                                                  },
                                                                              },
                                                                            },
                                                                            [
                                                                              _c(
                                                                                "v-icon",
                                                                                {
                                                                                  attrs:
                                                                                    {
                                                                                      "x-small":
                                                                                        "",
                                                                                    },
                                                                                },
                                                                                [
                                                                                  _vm._v(
                                                                                    "mdi-account-switch-outline"
                                                                                  ),
                                                                                ]
                                                                              ),
                                                                            ],
                                                                            1
                                                                          ),
                                                                        ],
                                                                        1
                                                                      ),
                                                                    ],
                                                                    1
                                                                  )
                                                                : _vm._e(),
                                                              _vm
                                                                .changeContactOpen[
                                                                o.id
                                                              ]
                                                                ? _c(
                                                                    "v-autocomplete",
                                                                    {
                                                                      staticClass:
                                                                        "mb-2",
                                                                      attrs: {
                                                                        value:
                                                                          o.assignedUserId,
                                                                        items:
                                                                          (_vm
                                                                            .viewOrgUsers[
                                                                            o.id
                                                                          ] &&
                                                                            _vm
                                                                              .viewOrgUsers[
                                                                              o
                                                                                .id
                                                                            ]
                                                                              .items) ||
                                                                          [],
                                                                        "item-text":
                                                                          "fullName",
                                                                        "item-value":
                                                                          "id",
                                                                        filter:
                                                                          _vm.filterUser,
                                                                        label:
                                                                          o.assignedUserName
                                                                            ? _vm.$t(
                                                                                "ticketing.change-contact"
                                                                              )
                                                                            : _vm.$t(
                                                                                "ticketing.set-contact"
                                                                              ),
                                                                        outlined:
                                                                          "",
                                                                        dense:
                                                                          "",
                                                                        "hide-details":
                                                                          "",
                                                                        clearable:
                                                                          "",
                                                                        loading:
                                                                          _vm
                                                                            .viewOrgUsers[
                                                                            o.id
                                                                          ] &&
                                                                          _vm
                                                                            .viewOrgUsers[
                                                                            o.id
                                                                          ]
                                                                            .loading,
                                                                        "no-data-text":
                                                                          _vm.$t(
                                                                            "ticketing.no-users"
                                                                          ),
                                                                        "append-outer-icon":
                                                                          "mdi-close",
                                                                      },
                                                                      on: {
                                                                        change:
                                                                          (
                                                                            uid
                                                                          ) =>
                                                                            _vm.onAffectedOrgContactChange(
                                                                              o,
                                                                              uid
                                                                            ),
                                                                        "click:append-outer":
                                                                          function (
                                                                            $event
                                                                          ) {
                                                                            return _vm.closeChangeContact(
                                                                              o.id
                                                                            )
                                                                          },
                                                                      },
                                                                      scopedSlots:
                                                                        _vm._u(
                                                                          [
                                                                            {
                                                                              key: "item",
                                                                              fn: function ({
                                                                                item,
                                                                              }) {
                                                                                return [
                                                                                  _c(
                                                                                    "v-list-item-content",
                                                                                    [
                                                                                      _c(
                                                                                        "v-list-item-title",
                                                                                        [
                                                                                          _vm._v(
                                                                                            _vm._s(
                                                                                              item.fullName
                                                                                            )
                                                                                          ),
                                                                                        ]
                                                                                      ),
                                                                                      item.email
                                                                                        ? _c(
                                                                                            "v-list-item-subtitle",
                                                                                            {
                                                                                              staticClass:
                                                                                                "text-caption grey--text",
                                                                                            },
                                                                                            [
                                                                                              _vm._v(
                                                                                                " " +
                                                                                                  _vm._s(
                                                                                                    item.email
                                                                                                  ) +
                                                                                                  " "
                                                                                              ),
                                                                                            ]
                                                                                          )
                                                                                        : _vm._e(),
                                                                                    ],
                                                                                    1
                                                                                  ),
                                                                                ]
                                                                              },
                                                                            },
                                                                          ],
                                                                          null,
                                                                          true
                                                                        ),
                                                                    }
                                                                  )
                                                                : _vm._e(),
                                                              _c("v-divider", {
                                                                staticClass:
                                                                  "my-2",
                                                              }),
                                                              _c(
                                                                "div",
                                                                {
                                                                  staticClass:
                                                                    "d-flex align-center mb-1",
                                                                },
                                                                [
                                                                  !_vm.orgAdminContacts(
                                                                    o.id
                                                                  ).length
                                                                    ? _c(
                                                                        "div",
                                                                        [
                                                                          _c(
                                                                            "div",
                                                                            {
                                                                              staticClass:
                                                                                "text-caption font-weight-medium grey--text text--darken-1",
                                                                            },
                                                                            [
                                                                              _vm._v(
                                                                                " " +
                                                                                  _vm._s(
                                                                                    _vm.$t(
                                                                                      "ticketing.contacts.admin-contacts"
                                                                                    )
                                                                                  ) +
                                                                                  " "
                                                                              ),
                                                                            ]
                                                                          ),
                                                                          _c(
                                                                            "div",
                                                                            {
                                                                              staticClass:
                                                                                "text-caption grey--text",
                                                                            },
                                                                            [
                                                                              _vm._v(
                                                                                " " +
                                                                                  _vm._s(
                                                                                    _vm.$t(
                                                                                      "ticketing.contacts.no-admin"
                                                                                    )
                                                                                  ) +
                                                                                  " "
                                                                              ),
                                                                            ]
                                                                          ),
                                                                        ]
                                                                      )
                                                                    : _c(
                                                                        "span",
                                                                        {
                                                                          staticClass:
                                                                            "text-caption font-weight-medium grey--text text--darken-1",
                                                                        },
                                                                        [
                                                                          _vm._v(
                                                                            " " +
                                                                              _vm._s(
                                                                                _vm.$t(
                                                                                  "ticketing.contacts.admin-contacts"
                                                                                )
                                                                              ) +
                                                                              " "
                                                                          ),
                                                                        ]
                                                                      ),
                                                                  _c(
                                                                    "v-spacer"
                                                                  ),
                                                                  _c(
                                                                    "v-tooltip",
                                                                    {
                                                                      attrs: {
                                                                        top: "",
                                                                      },
                                                                      scopedSlots:
                                                                        _vm._u(
                                                                          [
                                                                            {
                                                                              key: "activator",
                                                                              fn: function ({
                                                                                on,
                                                                                attrs,
                                                                              }) {
                                                                                return [
                                                                                  _c(
                                                                                    "v-btn",
                                                                                    _vm._g(
                                                                                      _vm._b(
                                                                                        {
                                                                                          attrs:
                                                                                            {
                                                                                              icon: "",
                                                                                              "x-small":
                                                                                                "",
                                                                                              color:
                                                                                                "primary",
                                                                                            },
                                                                                          on: {
                                                                                            click:
                                                                                              function (
                                                                                                $event
                                                                                              ) {
                                                                                                return _vm.addContact(
                                                                                                  o.id,
                                                                                                  "admin"
                                                                                                )
                                                                                              },
                                                                                          },
                                                                                        },
                                                                                        "v-btn",
                                                                                        attrs,
                                                                                        false
                                                                                      ),
                                                                                      on
                                                                                    ),
                                                                                    [
                                                                                      _c(
                                                                                        "v-icon",
                                                                                        {
                                                                                          attrs:
                                                                                            {
                                                                                              small:
                                                                                                "",
                                                                                            },
                                                                                        },
                                                                                        [
                                                                                          _vm._v(
                                                                                            "mdi-plus"
                                                                                          ),
                                                                                        ]
                                                                                      ),
                                                                                    ],
                                                                                    1
                                                                                  ),
                                                                                ]
                                                                              },
                                                                            },
                                                                          ],
                                                                          null,
                                                                          true
                                                                        ),
                                                                    },
                                                                    [
                                                                      _c(
                                                                        "span",
                                                                        [
                                                                          _vm._v(
                                                                            _vm._s(
                                                                              _vm.$t(
                                                                                "ticketing.contacts.add-admin"
                                                                              )
                                                                            )
                                                                          ),
                                                                        ]
                                                                      ),
                                                                    ]
                                                                  ),
                                                                ],
                                                                1
                                                              ),
                                                              _vm._l(
                                                                _vm.orgAdminContacts(
                                                                  o.id
                                                                ),
                                                                function (
                                                                  c,
                                                                  idx
                                                                ) {
                                                                  return _c(
                                                                    "div",
                                                                    {
                                                                      key: `${o.id}-admin-${idx}`,
                                                                      staticClass:
                                                                        "affected-contact-row d-flex align-center mb-2",
                                                                    },
                                                                    [
                                                                      _c(
                                                                        "v-avatar",
                                                                        {
                                                                          staticClass:
                                                                            "mr-2 white--text text-caption flex-shrink-0",
                                                                          attrs:
                                                                            {
                                                                              size: "26",
                                                                              color:
                                                                                _vm.userColor(
                                                                                  c.fullName ||
                                                                                    `admin-${idx}`
                                                                                ),
                                                                            },
                                                                        },
                                                                        [
                                                                          _vm._v(
                                                                            " " +
                                                                              _vm._s(
                                                                                _vm.viewerInitials(
                                                                                  c.fullName ||
                                                                                    _vm.$t(
                                                                                      "ticketing.contacts.unnamed"
                                                                                    )
                                                                                )
                                                                              ) +
                                                                              " "
                                                                          ),
                                                                        ]
                                                                      ),
                                                                      _c(
                                                                        "div",
                                                                        {
                                                                          staticClass:
                                                                            "flex-grow-1",
                                                                          staticStyle:
                                                                            {
                                                                              "min-width":
                                                                                "0",
                                                                            },
                                                                        },
                                                                        [
                                                                          _c(
                                                                            "div",
                                                                            {
                                                                              staticClass:
                                                                                "text-body-2 text-truncate",
                                                                            },
                                                                            [
                                                                              _vm._v(
                                                                                " " +
                                                                                  _vm._s(
                                                                                    c.fullName ||
                                                                                      _vm.$t(
                                                                                        "ticketing.contacts.unnamed"
                                                                                      )
                                                                                  ) +
                                                                                  " "
                                                                              ),
                                                                              c.title
                                                                                ? _c(
                                                                                    "span",
                                                                                    {
                                                                                      staticClass:
                                                                                        "text-caption grey--text",
                                                                                    },
                                                                                    [
                                                                                      _vm._v(
                                                                                        "· " +
                                                                                          _vm._s(
                                                                                            c.title
                                                                                          )
                                                                                      ),
                                                                                    ]
                                                                                  )
                                                                                : _vm._e(),
                                                                            ]
                                                                          ),
                                                                          _vm._l(
                                                                            _vm.contactMethodsOf(
                                                                              c
                                                                            ),
                                                                            function (
                                                                              method,
                                                                              mIdx
                                                                            ) {
                                                                              return _c(
                                                                                "div",
                                                                                {
                                                                                  key: mIdx,
                                                                                  staticClass:
                                                                                    "d-flex align-center",
                                                                                },
                                                                                [
                                                                                  _c(
                                                                                    "v-icon",
                                                                                    {
                                                                                      staticClass:
                                                                                        "mr-1",
                                                                                      attrs:
                                                                                        {
                                                                                          "x-small":
                                                                                            "",
                                                                                        },
                                                                                    },
                                                                                    [
                                                                                      _vm._v(
                                                                                        _vm._s(
                                                                                          _vm.contactMethodIcon(
                                                                                            method.method
                                                                                          )
                                                                                        )
                                                                                      ),
                                                                                    ]
                                                                                  ),
                                                                                  _c(
                                                                                    "a",
                                                                                    {
                                                                                      staticClass:
                                                                                        "text-caption text-truncate primary--text contact-phone-link",
                                                                                      attrs:
                                                                                        {
                                                                                          href: "#",
                                                                                        },
                                                                                      on: {
                                                                                        click:
                                                                                          function (
                                                                                            $event
                                                                                          ) {
                                                                                            $event.preventDefault()
                                                                                            return _vm.copyText(
                                                                                              method.value
                                                                                            )
                                                                                          },
                                                                                      },
                                                                                    },
                                                                                    [
                                                                                      _vm._v(
                                                                                        " " +
                                                                                          _vm._s(
                                                                                            _vm.formatContactValue(
                                                                                              method
                                                                                            )
                                                                                          ) +
                                                                                          " "
                                                                                      ),
                                                                                      method.method ===
                                                                                        "call" &&
                                                                                      method.extension
                                                                                        ? _c(
                                                                                            "span",
                                                                                            {
                                                                                              staticClass:
                                                                                                "grey--text",
                                                                                            },
                                                                                            [
                                                                                              _vm._v(
                                                                                                " ext. " +
                                                                                                  _vm._s(
                                                                                                    method.extension
                                                                                                  ) +
                                                                                                  " "
                                                                                              ),
                                                                                            ]
                                                                                          )
                                                                                        : _vm._e(),
                                                                                    ]
                                                                                  ),
                                                                                ],
                                                                                1
                                                                              )
                                                                            }
                                                                          ),
                                                                        ],
                                                                        2
                                                                      ),
                                                                      _c(
                                                                        "div",
                                                                        {
                                                                          staticClass:
                                                                            "d-flex align-center flex-shrink-0 ml-1",
                                                                        },
                                                                        [
                                                                          _c(
                                                                            "v-btn",
                                                                            {
                                                                              attrs:
                                                                                {
                                                                                  icon: "",
                                                                                  "x-small":
                                                                                    "",
                                                                                },
                                                                              on: {
                                                                                click:
                                                                                  function (
                                                                                    $event
                                                                                  ) {
                                                                                    return _vm.editContact(
                                                                                      o.id,
                                                                                      "admin",
                                                                                      idx
                                                                                    )
                                                                                  },
                                                                              },
                                                                            },
                                                                            [
                                                                              _c(
                                                                                "v-icon",
                                                                                {
                                                                                  attrs:
                                                                                    {
                                                                                      "x-small":
                                                                                        "",
                                                                                    },
                                                                                },
                                                                                [
                                                                                  _vm._v(
                                                                                    "mdi-pencil"
                                                                                  ),
                                                                                ]
                                                                              ),
                                                                            ],
                                                                            1
                                                                          ),
                                                                          _c(
                                                                            "v-btn",
                                                                            {
                                                                              attrs:
                                                                                {
                                                                                  icon: "",
                                                                                  "x-small":
                                                                                    "",
                                                                                },
                                                                              on: {
                                                                                click:
                                                                                  function (
                                                                                    $event
                                                                                  ) {
                                                                                    return _vm.confirmDeleteContact(
                                                                                      o.id,
                                                                                      "admin",
                                                                                      idx
                                                                                    )
                                                                                  },
                                                                              },
                                                                            },
                                                                            [
                                                                              _c(
                                                                                "v-icon",
                                                                                {
                                                                                  attrs:
                                                                                    {
                                                                                      "x-small":
                                                                                        "",
                                                                                    },
                                                                                },
                                                                                [
                                                                                  _vm._v(
                                                                                    "mdi-delete"
                                                                                  ),
                                                                                ]
                                                                              ),
                                                                            ],
                                                                            1
                                                                          ),
                                                                        ],
                                                                        1
                                                                      ),
                                                                    ],
                                                                    1
                                                                  )
                                                                }
                                                              ),
                                                              _c(
                                                                "div",
                                                                {
                                                                  staticClass:
                                                                    "d-flex align-center mb-1 mt-2",
                                                                },
                                                                [
                                                                  !_vm.orgTechContacts(
                                                                    o.id
                                                                  ).length
                                                                    ? _c(
                                                                        "div",
                                                                        [
                                                                          _c(
                                                                            "div",
                                                                            {
                                                                              staticClass:
                                                                                "text-caption font-weight-medium grey--text text--darken-1",
                                                                            },
                                                                            [
                                                                              _vm._v(
                                                                                " " +
                                                                                  _vm._s(
                                                                                    _vm.$t(
                                                                                      "ticketing.contacts.tech-contacts"
                                                                                    )
                                                                                  ) +
                                                                                  " "
                                                                              ),
                                                                            ]
                                                                          ),
                                                                          _c(
                                                                            "div",
                                                                            {
                                                                              staticClass:
                                                                                "text-caption grey--text",
                                                                            },
                                                                            [
                                                                              _vm._v(
                                                                                " " +
                                                                                  _vm._s(
                                                                                    _vm.$t(
                                                                                      "ticketing.contacts.no-tech"
                                                                                    )
                                                                                  ) +
                                                                                  " "
                                                                              ),
                                                                            ]
                                                                          ),
                                                                        ]
                                                                      )
                                                                    : _c(
                                                                        "span",
                                                                        {
                                                                          staticClass:
                                                                            "text-caption font-weight-medium grey--text text--darken-1",
                                                                        },
                                                                        [
                                                                          _vm._v(
                                                                            " " +
                                                                              _vm._s(
                                                                                _vm.$t(
                                                                                  "ticketing.contacts.tech-contacts"
                                                                                )
                                                                              ) +
                                                                              " "
                                                                          ),
                                                                        ]
                                                                      ),
                                                                  _c(
                                                                    "v-spacer"
                                                                  ),
                                                                  _c(
                                                                    "v-tooltip",
                                                                    {
                                                                      attrs: {
                                                                        top: "",
                                                                      },
                                                                      scopedSlots:
                                                                        _vm._u(
                                                                          [
                                                                            {
                                                                              key: "activator",
                                                                              fn: function ({
                                                                                on,
                                                                                attrs,
                                                                              }) {
                                                                                return [
                                                                                  _c(
                                                                                    "v-btn",
                                                                                    _vm._g(
                                                                                      _vm._b(
                                                                                        {
                                                                                          attrs:
                                                                                            {
                                                                                              icon: "",
                                                                                              "x-small":
                                                                                                "",
                                                                                              color:
                                                                                                "primary",
                                                                                            },
                                                                                          on: {
                                                                                            click:
                                                                                              function (
                                                                                                $event
                                                                                              ) {
                                                                                                return _vm.addContact(
                                                                                                  o.id,
                                                                                                  "tech"
                                                                                                )
                                                                                              },
                                                                                          },
                                                                                        },
                                                                                        "v-btn",
                                                                                        attrs,
                                                                                        false
                                                                                      ),
                                                                                      on
                                                                                    ),
                                                                                    [
                                                                                      _c(
                                                                                        "v-icon",
                                                                                        {
                                                                                          attrs:
                                                                                            {
                                                                                              small:
                                                                                                "",
                                                                                            },
                                                                                        },
                                                                                        [
                                                                                          _vm._v(
                                                                                            "mdi-plus"
                                                                                          ),
                                                                                        ]
                                                                                      ),
                                                                                    ],
                                                                                    1
                                                                                  ),
                                                                                ]
                                                                              },
                                                                            },
                                                                          ],
                                                                          null,
                                                                          true
                                                                        ),
                                                                    },
                                                                    [
                                                                      _c(
                                                                        "span",
                                                                        [
                                                                          _vm._v(
                                                                            _vm._s(
                                                                              _vm.$t(
                                                                                "ticketing.contacts.add-tech"
                                                                              )
                                                                            )
                                                                          ),
                                                                        ]
                                                                      ),
                                                                    ]
                                                                  ),
                                                                ],
                                                                1
                                                              ),
                                                              _vm._l(
                                                                _vm.orgTechContacts(
                                                                  o.id
                                                                ),
                                                                function (
                                                                  c,
                                                                  idx
                                                                ) {
                                                                  return _c(
                                                                    "div",
                                                                    {
                                                                      key: `${o.id}-tech-${idx}`,
                                                                      staticClass:
                                                                        "affected-contact-row d-flex align-center mb-2",
                                                                    },
                                                                    [
                                                                      _c(
                                                                        "v-avatar",
                                                                        {
                                                                          staticClass:
                                                                            "mr-2 white--text text-caption flex-shrink-0",
                                                                          attrs:
                                                                            {
                                                                              size: "26",
                                                                              color:
                                                                                _vm.userColor(
                                                                                  c.fullName ||
                                                                                    c.businessName ||
                                                                                    `tech-${idx}`
                                                                                ),
                                                                            },
                                                                        },
                                                                        [
                                                                          _vm._v(
                                                                            " " +
                                                                              _vm._s(
                                                                                _vm.viewerInitials(
                                                                                  c.fullName ||
                                                                                    c.businessName ||
                                                                                    _vm.$t(
                                                                                      "ticketing.contacts.unnamed"
                                                                                    )
                                                                                )
                                                                              ) +
                                                                              " "
                                                                          ),
                                                                        ]
                                                                      ),
                                                                      _c(
                                                                        "div",
                                                                        {
                                                                          staticClass:
                                                                            "flex-grow-1",
                                                                          staticStyle:
                                                                            {
                                                                              "min-width":
                                                                                "0",
                                                                            },
                                                                        },
                                                                        [
                                                                          _c(
                                                                            "div",
                                                                            {
                                                                              staticClass:
                                                                                "text-body-2 text-truncate",
                                                                            },
                                                                            [
                                                                              _vm._v(
                                                                                " " +
                                                                                  _vm._s(
                                                                                    c.fullName ||
                                                                                      c.businessName ||
                                                                                      _vm.$t(
                                                                                        "ticketing.contacts.unnamed"
                                                                                      )
                                                                                  ) +
                                                                                  " "
                                                                              ),
                                                                              c.fullName &&
                                                                              c.businessName
                                                                                ? _c(
                                                                                    "span",
                                                                                    {
                                                                                      staticClass:
                                                                                        "text-caption grey--text",
                                                                                    },
                                                                                    [
                                                                                      _vm._v(
                                                                                        "· " +
                                                                                          _vm._s(
                                                                                            c.businessName
                                                                                          )
                                                                                      ),
                                                                                    ]
                                                                                  )
                                                                                : _vm._e(),
                                                                            ]
                                                                          ),
                                                                          _vm._l(
                                                                            _vm.contactMethodsOf(
                                                                              c
                                                                            ),
                                                                            function (
                                                                              method,
                                                                              mIdx
                                                                            ) {
                                                                              return _c(
                                                                                "div",
                                                                                {
                                                                                  key: mIdx,
                                                                                  staticClass:
                                                                                    "d-flex align-center",
                                                                                },
                                                                                [
                                                                                  _c(
                                                                                    "v-icon",
                                                                                    {
                                                                                      staticClass:
                                                                                        "mr-1",
                                                                                      attrs:
                                                                                        {
                                                                                          "x-small":
                                                                                            "",
                                                                                        },
                                                                                    },
                                                                                    [
                                                                                      _vm._v(
                                                                                        _vm._s(
                                                                                          _vm.contactMethodIcon(
                                                                                            method.method
                                                                                          )
                                                                                        )
                                                                                      ),
                                                                                    ]
                                                                                  ),
                                                                                  _c(
                                                                                    "a",
                                                                                    {
                                                                                      staticClass:
                                                                                        "text-caption text-truncate primary--text contact-phone-link",
                                                                                      attrs:
                                                                                        {
                                                                                          href: "#",
                                                                                        },
                                                                                      on: {
                                                                                        click:
                                                                                          function (
                                                                                            $event
                                                                                          ) {
                                                                                            $event.preventDefault()
                                                                                            return _vm.copyText(
                                                                                              method.value
                                                                                            )
                                                                                          },
                                                                                      },
                                                                                    },
                                                                                    [
                                                                                      _vm._v(
                                                                                        " " +
                                                                                          _vm._s(
                                                                                            _vm.formatContactValue(
                                                                                              method
                                                                                            )
                                                                                          ) +
                                                                                          " "
                                                                                      ),
                                                                                      method.method ===
                                                                                        "call" &&
                                                                                      method.extension
                                                                                        ? _c(
                                                                                            "span",
                                                                                            {
                                                                                              staticClass:
                                                                                                "grey--text",
                                                                                            },
                                                                                            [
                                                                                              _vm._v(
                                                                                                " ext. " +
                                                                                                  _vm._s(
                                                                                                    method.extension
                                                                                                  ) +
                                                                                                  " "
                                                                                              ),
                                                                                            ]
                                                                                          )
                                                                                        : _vm._e(),
                                                                                    ]
                                                                                  ),
                                                                                ],
                                                                                1
                                                                              )
                                                                            }
                                                                          ),
                                                                          c.consent
                                                                            ? _c(
                                                                                "div",
                                                                                {
                                                                                  staticClass:
                                                                                    "d-flex align-center mt-1",
                                                                                },
                                                                                [
                                                                                  _c(
                                                                                    "v-icon",
                                                                                    {
                                                                                      staticClass:
                                                                                        "mr-1",
                                                                                      attrs:
                                                                                        {
                                                                                          "x-small":
                                                                                            "",
                                                                                        },
                                                                                    },
                                                                                    [
                                                                                      _vm._v(
                                                                                        "mdi-shield-check-outline"
                                                                                      ),
                                                                                    ]
                                                                                  ),
                                                                                  _c(
                                                                                    "v-chip",
                                                                                    {
                                                                                      attrs:
                                                                                        {
                                                                                          "x-small":
                                                                                            "",
                                                                                          color:
                                                                                            _vm.consentColor(
                                                                                              c.consent
                                                                                            ),
                                                                                          dark: "",
                                                                                        },
                                                                                    },
                                                                                    [
                                                                                      _vm._v(
                                                                                        " " +
                                                                                          _vm._s(
                                                                                            _vm.$t(
                                                                                              `ticketing.contacts.consent-options.${
                                                                                                c.consent ||
                                                                                                "unknown"
                                                                                              }`
                                                                                            )
                                                                                          ) +
                                                                                          " "
                                                                                      ),
                                                                                    ]
                                                                                  ),
                                                                                ],
                                                                                1
                                                                              )
                                                                            : _vm._e(),
                                                                        ],
                                                                        2
                                                                      ),
                                                                      _c(
                                                                        "div",
                                                                        {
                                                                          staticClass:
                                                                            "d-flex align-center flex-shrink-0 ml-1",
                                                                        },
                                                                        [
                                                                          _c(
                                                                            "v-btn",
                                                                            {
                                                                              attrs:
                                                                                {
                                                                                  icon: "",
                                                                                  "x-small":
                                                                                    "",
                                                                                },
                                                                              on: {
                                                                                click:
                                                                                  function (
                                                                                    $event
                                                                                  ) {
                                                                                    return _vm.editContact(
                                                                                      o.id,
                                                                                      "tech",
                                                                                      idx
                                                                                    )
                                                                                  },
                                                                              },
                                                                            },
                                                                            [
                                                                              _c(
                                                                                "v-icon",
                                                                                {
                                                                                  attrs:
                                                                                    {
                                                                                      "x-small":
                                                                                        "",
                                                                                    },
                                                                                },
                                                                                [
                                                                                  _vm._v(
                                                                                    "mdi-pencil"
                                                                                  ),
                                                                                ]
                                                                              ),
                                                                            ],
                                                                            1
                                                                          ),
                                                                          _c(
                                                                            "v-btn",
                                                                            {
                                                                              attrs:
                                                                                {
                                                                                  icon: "",
                                                                                  "x-small":
                                                                                    "",
                                                                                },
                                                                              on: {
                                                                                click:
                                                                                  function (
                                                                                    $event
                                                                                  ) {
                                                                                    return _vm.confirmDeleteContact(
                                                                                      o.id,
                                                                                      "tech",
                                                                                      idx
                                                                                    )
                                                                                  },
                                                                              },
                                                                            },
                                                                            [
                                                                              _c(
                                                                                "v-icon",
                                                                                {
                                                                                  attrs:
                                                                                    {
                                                                                      "x-small":
                                                                                        "",
                                                                                    },
                                                                                },
                                                                                [
                                                                                  _vm._v(
                                                                                    "mdi-delete"
                                                                                  ),
                                                                                ]
                                                                              ),
                                                                            ],
                                                                            1
                                                                          ),
                                                                        ],
                                                                        1
                                                                      ),
                                                                    ],
                                                                    1
                                                                  )
                                                                }
                                                              ),
                                                            ],
                                                            2
                                                          )
                                                        : _vm._e(),
                                                    ]),
                                                  ],
                                                  1
                                                )
                                              }
                                            ),
                                            0
                                          ),
                                          _c("v-autocomplete", {
                                            ref: "affectedOrgPicker",
                                            staticClass: "mt-2",
                                            attrs: {
                                              "search-input":
                                                _vm.affectedOrgPickSearch,
                                              items: _vm.affectedOrgPickerItems,
                                              "item-text": "text",
                                              "item-value": "value",
                                              filter: _vm.filterOrganization,
                                              label: _vm.$t(
                                                "ticketing.add-organization"
                                              ),
                                              "prepend-inner-icon": "mdi-plus",
                                              outlined: "",
                                              dense: "",
                                              "hide-details": "",
                                              clearable: "",
                                            },
                                            on: {
                                              "update:searchInput": function (
                                                $event
                                              ) {
                                                _vm.affectedOrgPickSearch =
                                                  $event
                                              },
                                              "update:search-input": function (
                                                $event
                                              ) {
                                                _vm.affectedOrgPickSearch =
                                                  $event
                                              },
                                              change: _vm.onAffectedOrgAdd,
                                            },
                                            scopedSlots: _vm._u(
                                              [
                                                {
                                                  key: "item",
                                                  fn: function ({ item }) {
                                                    return [
                                                      _c(
                                                        "v-list-item-content",
                                                        [
                                                          _c(
                                                            "v-list-item-title",
                                                            [
                                                              _vm._v(
                                                                _vm._s(
                                                                  item.text
                                                                )
                                                              ),
                                                            ]
                                                          ),
                                                          _c(
                                                            "v-list-item-subtitle",
                                                            {
                                                              staticClass:
                                                                "text-caption grey--text",
                                                            },
                                                            [
                                                              _vm._v(
                                                                " " +
                                                                  _vm._s(
                                                                    item.value
                                                                  ) +
                                                                  " "
                                                              ),
                                                            ]
                                                          ),
                                                        ],
                                                        1
                                                      ),
                                                    ]
                                                  },
                                                },
                                              ],
                                              null,
                                              false,
                                              504888194
                                            ),
                                            model: {
                                              value: _vm.affectedOrgPick,
                                              callback: function ($$v) {
                                                _vm.affectedOrgPick = $$v
                                              },
                                              expression: "affectedOrgPick",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                    ]),
                                    _c("v-divider", { staticClass: "my-2" }),
                                    _c(
                                      "div",
                                      { staticClass: "field-block" },
                                      [
                                        _c(
                                          "div",
                                          { staticClass: "field-label" },
                                          [
                                            _vm._v(
                                              " " +
                                                _vm._s(
                                                  _vm.$t(
                                                    "ticketing.assigned-devops"
                                                  )
                                                ) +
                                                " "
                                            ),
                                          ]
                                        ),
                                        _c("v-autocomplete", {
                                          attrs: {
                                            value:
                                              _vm.activeTicket
                                                .assignedDevopsIds || [],
                                            items: _vm.devopsUsers,
                                            "item-text": "fullName",
                                            "item-value": "id",
                                            multiple: "",
                                            "small-chips": "",
                                            "deletable-chips": "",
                                            dense: "",
                                            outlined: "",
                                            "hide-details": "",
                                            loading: _vm.savingDevops,
                                          },
                                          on: {
                                            change: _vm.changeAssignedDevops,
                                          },
                                          scopedSlots: _vm._u(
                                            [
                                              {
                                                key: "append",
                                                fn: function () {
                                                  return [
                                                    _vm.canTakeDevops
                                                      ? _c(
                                                          "v-btn",
                                                          {
                                                            staticClass:
                                                              "take-devops-btn",
                                                            attrs: {
                                                              "x-small": "",
                                                              text: "",
                                                              color: "primary",
                                                              loading:
                                                                _vm.savingDevops,
                                                            },
                                                            on: {
                                                              mousedown:
                                                                function (
                                                                  $event
                                                                ) {
                                                                  $event.stopPropagation()
                                                                  $event.preventDefault()
                                                                  return _vm.takeDevops.apply(
                                                                    null,
                                                                    arguments
                                                                  )
                                                                },
                                                            },
                                                          },
                                                          [
                                                            _c(
                                                              "v-icon",
                                                              {
                                                                attrs: {
                                                                  "x-small": "",
                                                                  left: "",
                                                                },
                                                              },
                                                              [
                                                                _vm._v(
                                                                  _vm._s(
                                                                    _vm.takeDevopsIcon
                                                                  )
                                                                ),
                                                              ]
                                                            ),
                                                            _vm._v(
                                                              " " +
                                                                _vm._s(
                                                                  _vm.takeDevopsLabel
                                                                ) +
                                                                " "
                                                            ),
                                                          ],
                                                          1
                                                        )
                                                      : _vm._e(),
                                                  ]
                                                },
                                                proxy: true,
                                              },
                                            ],
                                            null,
                                            false,
                                            3135998041
                                          ),
                                        }),
                                      ],
                                      1
                                    ),
                                    _c("div", { staticClass: "field-block" }, [
                                      _c(
                                        "div",
                                        { staticClass: "d-flex align-center" },
                                        [
                                          _c(
                                            "span",
                                            { staticClass: "field-label mb-0" },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t("ticketing.watchers")
                                                )
                                              ),
                                            ]
                                          ),
                                          _c("v-spacer"),
                                          _c(
                                            "v-menu",
                                            {
                                              attrs: {
                                                "close-on-content-click": false,
                                                "offset-y": "",
                                                left: "",
                                                "max-width": "320",
                                              },
                                              on: {
                                                input: _vm.onWatchersMenuToggle,
                                              },
                                              scopedSlots: _vm._u(
                                                [
                                                  {
                                                    key: "activator",
                                                    fn: function ({
                                                      on,
                                                      attrs,
                                                    }) {
                                                      return [
                                                        _c(
                                                          "v-btn",
                                                          _vm._g(
                                                            _vm._b(
                                                              {
                                                                attrs: {
                                                                  icon: "",
                                                                  "x-small": "",
                                                                  color:
                                                                    "primary",
                                                                },
                                                              },
                                                              "v-btn",
                                                              attrs,
                                                              false
                                                            ),
                                                            on
                                                          ),
                                                          [
                                                            _c(
                                                              "v-icon",
                                                              {
                                                                attrs: {
                                                                  small: "",
                                                                },
                                                              },
                                                              [
                                                                _vm._v(
                                                                  "mdi-plus"
                                                                ),
                                                              ]
                                                            ),
                                                          ],
                                                          1
                                                        ),
                                                      ]
                                                    },
                                                  },
                                                ],
                                                null,
                                                false,
                                                3080548887
                                              ),
                                              model: {
                                                value: _vm.watchersMenuOpen,
                                                callback: function ($$v) {
                                                  _vm.watchersMenuOpen = $$v
                                                },
                                                expression: "watchersMenuOpen",
                                              },
                                            },
                                            [
                                              _c(
                                                "v-card",
                                                { attrs: { width: "320" } },
                                                [
                                                  _c(
                                                    "v-card-text",
                                                    { staticClass: "pa-2" },
                                                    [
                                                      _c("v-autocomplete", {
                                                        ref: "watchersAutocomplete",
                                                        attrs: {
                                                          value:
                                                            _vm.activeTicket
                                                              .watcherIds || [],
                                                          items:
                                                            _vm.devopsUsers,
                                                          "item-text":
                                                            "fullName",
                                                          "item-value": "id",
                                                          multiple: "",
                                                          "small-chips": "",
                                                          "deletable-chips": "",
                                                          dense: "",
                                                          outlined: "",
                                                          "hide-details": "",
                                                          autofocus: "",
                                                          loading:
                                                            _vm.savingWatchers,
                                                          label:
                                                            _vm.$t(
                                                              "ticketing.watchers"
                                                            ),
                                                        },
                                                        on: {
                                                          change:
                                                            _vm.changeWatchers,
                                                        },
                                                      }),
                                                    ],
                                                    1
                                                  ),
                                                ],
                                                1
                                              ),
                                            ],
                                            1
                                          ),
                                          !_vm.isWatching
                                            ? _c(
                                                "v-btn",
                                                {
                                                  attrs: {
                                                    "x-small": "",
                                                    text: "",
                                                    color: "primary",
                                                  },
                                                  on: {
                                                    click: _vm.watchTicket,
                                                  },
                                                },
                                                [
                                                  _c(
                                                    "v-icon",
                                                    {
                                                      attrs: {
                                                        "x-small": "",
                                                        left: "",
                                                      },
                                                    },
                                                    [_vm._v("mdi-eye-plus")]
                                                  ),
                                                  _vm._v(
                                                    " " +
                                                      _vm._s(
                                                        _vm.$t(
                                                          "ticketing.watch"
                                                        )
                                                      ) +
                                                      " "
                                                  ),
                                                ],
                                                1
                                              )
                                            : _c(
                                                "v-btn",
                                                {
                                                  attrs: {
                                                    "x-small": "",
                                                    text: "",
                                                  },
                                                  on: {
                                                    click: _vm.unwatchTicket,
                                                  },
                                                },
                                                [
                                                  _c(
                                                    "v-icon",
                                                    {
                                                      attrs: {
                                                        "x-small": "",
                                                        left: "",
                                                      },
                                                    },
                                                    [_vm._v("mdi-eye-off")]
                                                  ),
                                                  _vm._v(
                                                    " " +
                                                      _vm._s(
                                                        _vm.$t(
                                                          "ticketing.unwatch"
                                                        )
                                                      ) +
                                                      " "
                                                  ),
                                                ],
                                                1
                                              ),
                                        ],
                                        1
                                      ),
                                      _c(
                                        "div",
                                        {
                                          staticClass: "field-value",
                                          class: {
                                            "field-value--empty":
                                              !_vm.activeTicket.watcherIds
                                                ?.length,
                                          },
                                        },
                                        [
                                          _vm.activeTicket.watcherIds?.length
                                            ? _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "viewers-stack d-flex",
                                                },
                                                _vm._l(
                                                  _vm.activeTicket.watcherIds,
                                                  function (uid) {
                                                    return _c(
                                                      "v-tooltip",
                                                      {
                                                        key: uid,
                                                        attrs: { top: "" },
                                                        scopedSlots: _vm._u(
                                                          [
                                                            {
                                                              key: "activator",
                                                              fn: function ({
                                                                on,
                                                                attrs,
                                                              }) {
                                                                return [
                                                                  _c(
                                                                    "v-avatar",
                                                                    _vm._g(
                                                                      _vm._b(
                                                                        {
                                                                          staticClass:
                                                                            "viewer-avatar white--text text-caption",
                                                                          attrs:
                                                                            {
                                                                              size: "24",
                                                                              color:
                                                                                _vm.userColor(
                                                                                  uid
                                                                                ),
                                                                            },
                                                                          on: {
                                                                            click:
                                                                              function (
                                                                                $event
                                                                              ) {
                                                                                return _vm.removeWatcherClick(
                                                                                  uid
                                                                                )
                                                                              },
                                                                          },
                                                                        },
                                                                        "v-avatar",
                                                                        attrs,
                                                                        false
                                                                      ),
                                                                      on
                                                                    ),
                                                                    [
                                                                      _vm._v(
                                                                        " " +
                                                                          _vm._s(
                                                                            _vm.viewerInitials(
                                                                              _vm.devopsName(
                                                                                uid
                                                                              )
                                                                            )
                                                                          ) +
                                                                          " "
                                                                      ),
                                                                    ]
                                                                  ),
                                                                ]
                                                              },
                                                            },
                                                          ],
                                                          null,
                                                          true
                                                        ),
                                                      },
                                                      [
                                                        _c("span", [
                                                          _vm._v(
                                                            _vm._s(
                                                              _vm.devopsName(
                                                                uid
                                                              )
                                                            )
                                                          ),
                                                        ]),
                                                      ]
                                                    )
                                                  }
                                                ),
                                                1
                                              )
                                            : _c("span", [_vm._v("-")]),
                                        ]
                                      ),
                                    ]),
                                    _c("div", { staticClass: "field-block" }, [
                                      _c(
                                        "div",
                                        { staticClass: "field-label" },
                                        [
                                          _vm._v(
                                            " " +
                                              _vm._s(
                                                _vm.$t("ticketing.seen-by")
                                              ) +
                                              " "
                                          ),
                                        ]
                                      ),
                                      _c(
                                        "div",
                                        {
                                          staticClass: "field-value",
                                          class: {
                                            "field-value--empty":
                                              !_vm.ticketSeenBy.length,
                                          },
                                        },
                                        [
                                          _vm.ticketSeenBy.length
                                            ? _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "viewers-stack d-flex flex-wrap",
                                                },
                                                _vm._l(
                                                  _vm.ticketSeenBy,
                                                  function (v) {
                                                    return _c(
                                                      "v-tooltip",
                                                      {
                                                        key: `seen-${v.userId}`,
                                                        attrs: { top: "" },
                                                        scopedSlots: _vm._u(
                                                          [
                                                            {
                                                              key: "activator",
                                                              fn: function ({
                                                                on,
                                                                attrs,
                                                              }) {
                                                                return [
                                                                  _c(
                                                                    "v-avatar",
                                                                    _vm._g(
                                                                      _vm._b(
                                                                        {
                                                                          staticClass:
                                                                            "viewer-avatar white--text text-caption",
                                                                          attrs:
                                                                            {
                                                                              size: "24",
                                                                              color:
                                                                                _vm.userColor(
                                                                                  v.userId
                                                                                ),
                                                                            },
                                                                        },
                                                                        "v-avatar",
                                                                        attrs,
                                                                        false
                                                                      ),
                                                                      on
                                                                    ),
                                                                    [
                                                                      _vm._v(
                                                                        " " +
                                                                          _vm._s(
                                                                            _vm.viewerInitials(
                                                                              _vm.devopsName(
                                                                                v.userId
                                                                              )
                                                                            )
                                                                          ) +
                                                                          " "
                                                                      ),
                                                                    ]
                                                                  ),
                                                                ]
                                                              },
                                                            },
                                                          ],
                                                          null,
                                                          true
                                                        ),
                                                      },
                                                      [
                                                        _c("span", [
                                                          _vm._v(
                                                            _vm._s(
                                                              _vm.$t(
                                                                "ticketing.seen-by-last-visit",
                                                                {
                                                                  name: _vm.devopsName(
                                                                    v.userId
                                                                  ),
                                                                  time: _vm.formatTimeAbsolute(
                                                                    v.lastMs
                                                                  ),
                                                                }
                                                              )
                                                            )
                                                          ),
                                                        ]),
                                                      ]
                                                    )
                                                  }
                                                ),
                                                1
                                              )
                                            : _c("span", [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.$t(
                                                      "ticketing.seen-by-empty"
                                                    )
                                                  )
                                                ),
                                              ]),
                                        ]
                                      ),
                                    ]),
                                    _c(
                                      "div",
                                      { staticClass: "field-block" },
                                      [
                                        _c(
                                          "div",
                                          { staticClass: "field-label" },
                                          [
                                            _vm._v(
                                              " " +
                                                _vm._s(
                                                  _vm.$t(
                                                    "ticketing.status-label"
                                                  )
                                                ) +
                                                " "
                                            ),
                                          ]
                                        ),
                                        _c("v-select", {
                                          attrs: {
                                            items: _vm.statusOptions,
                                            dense: "",
                                            outlined: "",
                                            "hide-details": "",
                                          },
                                          on: { change: _vm.changeStatus },
                                          scopedSlots: _vm._u(
                                            [
                                              {
                                                key: "selection",
                                                fn: function ({ item }) {
                                                  return [
                                                    _c("span", [
                                                      _vm._v(_vm._s(item.text)),
                                                    ]),
                                                  ]
                                                },
                                              },
                                              {
                                                key: "item",
                                                fn: function ({ item }) {
                                                  return [
                                                    _c("span", [
                                                      _vm._v(_vm._s(item.text)),
                                                    ]),
                                                  ]
                                                },
                                              },
                                            ],
                                            null,
                                            false,
                                            3813113852
                                          ),
                                          model: {
                                            value: _vm.quickStatus,
                                            callback: function ($$v) {
                                              _vm.quickStatus = $$v
                                            },
                                            expression: "quickStatus",
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                    _c(
                                      "div",
                                      { staticClass: "field-block" },
                                      [
                                        _c(
                                          "div",
                                          { staticClass: "field-label" },
                                          [
                                            _vm._v(
                                              " " +
                                                _vm._s(
                                                  _vm.$t(
                                                    "ticketing.priority-label"
                                                  )
                                                ) +
                                                " "
                                            ),
                                          ]
                                        ),
                                        _c("v-select", {
                                          attrs: {
                                            items: _vm.priorityOptions,
                                            dense: "",
                                            outlined: "",
                                            "hide-details": "",
                                          },
                                          on: { change: _vm.changePriority },
                                          scopedSlots: _vm._u(
                                            [
                                              {
                                                key: "selection",
                                                fn: function ({ item }) {
                                                  return [
                                                    _c(
                                                      "span",
                                                      {
                                                        staticClass:
                                                          "font-weight-medium",
                                                        style: {
                                                          color:
                                                            _vm.priorityHex(
                                                              item.value
                                                            ),
                                                        },
                                                      },
                                                      [
                                                        _vm._v(
                                                          " " +
                                                            _vm._s(
                                                              _vm.priorityEmoji(
                                                                item.value
                                                              )
                                                            ) +
                                                            "  " +
                                                            _vm._s(item.text) +
                                                            " "
                                                        ),
                                                      ]
                                                    ),
                                                  ]
                                                },
                                              },
                                              {
                                                key: "item",
                                                fn: function ({ item }) {
                                                  return [
                                                    _c(
                                                      "span",
                                                      {
                                                        staticClass:
                                                          "font-weight-medium",
                                                        style: {
                                                          color:
                                                            _vm.priorityHex(
                                                              item.value
                                                            ),
                                                        },
                                                      },
                                                      [
                                                        _vm._v(
                                                          " " +
                                                            _vm._s(
                                                              _vm.priorityEmoji(
                                                                item.value
                                                              )
                                                            ) +
                                                            "  " +
                                                            _vm._s(item.text) +
                                                            " "
                                                        ),
                                                      ]
                                                    ),
                                                  ]
                                                },
                                              },
                                            ],
                                            null,
                                            false,
                                            837978588
                                          ),
                                          model: {
                                            value: _vm.quickPriority,
                                            callback: function ($$v) {
                                              _vm.quickPriority = $$v
                                            },
                                            expression: "quickPriority",
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                    _c(
                                      "div",
                                      { staticClass: "field-block" },
                                      [
                                        _c(
                                          "div",
                                          { staticClass: "field-label" },
                                          [
                                            _vm._v(
                                              " " +
                                                _vm._s(
                                                  _vm.$t("ticketing.due-date")
                                                ) +
                                                " "
                                            ),
                                          ]
                                        ),
                                        _c(
                                          "v-menu",
                                          {
                                            attrs: {
                                              "close-on-content-click": false,
                                              "offset-y": "",
                                              "min-width": "auto",
                                              transition: "scale-transition",
                                            },
                                            scopedSlots: _vm._u(
                                              [
                                                {
                                                  key: "activator",
                                                  fn: function ({ on, attrs }) {
                                                    return [
                                                      _c(
                                                        "v-text-field",
                                                        _vm._g(
                                                          _vm._b(
                                                            {
                                                              class: {
                                                                "due-date--overdue":
                                                                  _vm.isOverdue(
                                                                    _vm.activeTicket
                                                                  ),
                                                              },
                                                              attrs: {
                                                                value: _vm
                                                                  .activeTicket
                                                                  .dueAt
                                                                  ? _vm.formatDueDate(
                                                                      _vm
                                                                        .activeTicket
                                                                        .dueAt
                                                                    )
                                                                  : "",
                                                                placeholder:
                                                                  _vm.$t(
                                                                    "ticketing.due-date-placeholder"
                                                                  ),
                                                                dense: "",
                                                                outlined: "",
                                                                "hide-details":
                                                                  "",
                                                                readonly: "",
                                                                clearable: "",
                                                                "prepend-inner-icon":
                                                                  "mdi-calendar",
                                                              },
                                                              on: {
                                                                "click:clear":
                                                                  function (
                                                                    $event
                                                                  ) {
                                                                    return _vm.changeDueDate(
                                                                      null
                                                                    )
                                                                  },
                                                              },
                                                            },
                                                            "v-text-field",
                                                            attrs,
                                                            false
                                                          ),
                                                          on
                                                        )
                                                      ),
                                                    ]
                                                  },
                                                },
                                              ],
                                              null,
                                              false,
                                              386689448
                                            ),
                                            model: {
                                              value: _vm.dueDateMenu,
                                              callback: function ($$v) {
                                                _vm.dueDateMenu = $$v
                                              },
                                              expression: "dueDateMenu",
                                            },
                                          },
                                          [
                                            _c("v-date-picker", {
                                              attrs: {
                                                value:
                                                  _vm.activeTicket.dueAt ||
                                                  null,
                                                locale: _vm.$i18n.locale,
                                                "no-title": "",
                                              },
                                              on: {
                                                input: (v) => {
                                                  _vm.dueDateMenu = false
                                                  _vm.changeDueDate(v)
                                                },
                                              },
                                            }),
                                          ],
                                          1
                                        ),
                                      ],
                                      1
                                    ),
                                    _c("v-divider", { staticClass: "my-2" }),
                                    _c("div", { staticClass: "field-block" }, [
                                      _c(
                                        "div",
                                        { staticClass: "field-label" },
                                        [
                                          _vm._v(
                                            " " +
                                              _vm._s(
                                                _vm.$t("ticketing.created-by")
                                              ) +
                                              " "
                                          ),
                                        ]
                                      ),
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "field-value text-body-2",
                                        },
                                        [
                                          _vm._v(
                                            " " +
                                              _vm._s(
                                                _vm.activeTicket.createdByName
                                              ) +
                                              " "
                                          ),
                                          _c(
                                            "div",
                                            {
                                              directives: [
                                                {
                                                  name: "cursor-tip",
                                                  rawName: "v-cursor-tip",
                                                  value: _vm.formatTimeAbsolute(
                                                    _vm.activeTicket.createdAt
                                                  ),
                                                  expression:
                                                    "formatTimeAbsolute(activeTicket.createdAt)",
                                                },
                                              ],
                                              staticClass:
                                                "text-caption grey--text",
                                            },
                                            [
                                              _vm._v(
                                                " " +
                                                  _vm._s(
                                                    _vm.formatTime(
                                                      _vm.activeTicket.createdAt
                                                    )
                                                  ) +
                                                  " "
                                              ),
                                            ]
                                          ),
                                        ]
                                      ),
                                    ]),
                                    _c("div", { staticClass: "field-block" }, [
                                      _c(
                                        "div",
                                        { staticClass: "field-label" },
                                        [
                                          _vm._v(
                                            " " +
                                              _vm._s(
                                                _vm.$t("ticketing.last-update")
                                              ) +
                                              " "
                                          ),
                                        ]
                                      ),
                                      _c(
                                        "div",
                                        {
                                          directives: [
                                            {
                                              name: "cursor-tip",
                                              rawName: "v-cursor-tip",
                                              value: _vm.formatTimeAbsolute(
                                                _vm.activeTicket.updatedAt
                                              ),
                                              expression:
                                                "formatTimeAbsolute(activeTicket.updatedAt)",
                                            },
                                          ],
                                          staticClass:
                                            "field-value text-body-2",
                                        },
                                        [
                                          _vm._v(
                                            " " +
                                              _vm._s(
                                                _vm.formatTime(
                                                  _vm.activeTicket.updatedAt
                                                )
                                              ) +
                                              " "
                                          ),
                                        ]
                                      ),
                                    ]),
                                    _vm.lastStatusEvent
                                      ? _c(
                                          "div",
                                          { staticClass: "field-block" },
                                          [
                                            _c(
                                              "div",
                                              { staticClass: "field-label" },
                                              [
                                                _vm._v(
                                                  " " +
                                                    _vm._s(
                                                      _vm.$t(
                                                        "ticketing.status-event." +
                                                          _vm.lastStatusEvent
                                                            .kind
                                                      )
                                                    ) +
                                                    " "
                                                ),
                                              ]
                                            ),
                                            _c(
                                              "div",
                                              {
                                                directives: [
                                                  {
                                                    name: "cursor-tip",
                                                    rawName: "v-cursor-tip",
                                                    value:
                                                      _vm.formatTimeAbsolute(
                                                        _vm.lastStatusEvent.at
                                                      ),
                                                    expression:
                                                      "formatTimeAbsolute(lastStatusEvent.at)",
                                                  },
                                                ],
                                                staticClass:
                                                  "field-value text-body-2",
                                              },
                                              [
                                                _vm._v(
                                                  " " +
                                                    _vm._s(
                                                      _vm.formatTime(
                                                        _vm.lastStatusEvent.at
                                                      )
                                                    ) +
                                                    " "
                                                ),
                                                _vm.lastStatusEvent.actorName
                                                  ? _c(
                                                      "span",
                                                      {
                                                        staticClass:
                                                          "grey--text",
                                                      },
                                                      [
                                                        _vm._v(
                                                          " · " +
                                                            _vm._s(
                                                              _vm.$t(
                                                                "ticketing.follow-up-by",
                                                                {
                                                                  name: _vm
                                                                    .lastStatusEvent
                                                                    .actorName,
                                                                }
                                                              )
                                                            ) +
                                                            " "
                                                        ),
                                                      ]
                                                    )
                                                  : _vm._e(),
                                              ]
                                            ),
                                          ]
                                        )
                                      : _vm._e(),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                          ]),
                        ]
                      ),
                    ],
                    1
                  )
                : _vm._e(),
            ],
            1
          ),
          _c(
            "v-dialog",
            {
              attrs: {
                fullscreen: "",
                "hide-overlay": "",
                transition: "dialog-bottom-transition",
                "content-class": "image-preview-dialog",
              },
              nativeOn: {
                keydown: function ($event) {
                  return _vm.onImagePreviewKey.apply(null, arguments)
                },
              },
              model: {
                value: _vm.imagePreviewOpen,
                callback: function ($$v) {
                  _vm.imagePreviewOpen = $$v
                },
                expression: "imagePreviewOpen",
              },
            },
            [
              _vm.imagePreviewList.length
                ? _c(
                    "div",
                    { staticClass: "image-preview-container" },
                    [
                      _c(
                        "v-btn",
                        {
                          staticClass: "image-preview-close",
                          attrs: { icon: "", dark: "" },
                          on: {
                            click: function ($event) {
                              _vm.imagePreviewOpen = false
                            },
                          },
                        },
                        [_c("v-icon", [_vm._v("mdi-close")])],
                        1
                      ),
                      _vm.imagePreviewList.length > 1
                        ? _c(
                            "v-btn",
                            {
                              staticClass:
                                "image-preview-nav image-preview-nav--prev",
                              attrs: {
                                icon: "",
                                dark: "",
                                disabled: _vm.imagePreviewIndex === 0,
                              },
                              on: { click: _vm.prevImagePreview },
                            },
                            [_c("v-icon", [_vm._v("mdi-chevron-left")])],
                            1
                          )
                        : _vm._e(),
                      _vm.imagePreviewList.length > 1
                        ? _c(
                            "v-btn",
                            {
                              staticClass:
                                "image-preview-nav image-preview-nav--next",
                              attrs: {
                                icon: "",
                                dark: "",
                                disabled:
                                  _vm.imagePreviewIndex >=
                                  _vm.imagePreviewList.length - 1,
                              },
                              on: { click: _vm.nextImagePreview },
                            },
                            [_c("v-icon", [_vm._v("mdi-chevron-right")])],
                            1
                          )
                        : _vm._e(),
                      _c("img", {
                        staticClass: "image-preview-img",
                        attrs: {
                          src: _vm.imagePreviewList[_vm.imagePreviewIndex].url,
                          alt: _vm.imagePreviewList[_vm.imagePreviewIndex].name,
                        },
                      }),
                      _c(
                        "div",
                        { staticClass: "image-preview-caption" },
                        [
                          _c("span", { staticClass: "text-truncate" }, [
                            _vm._v(
                              _vm._s(
                                _vm.imagePreviewList[_vm.imagePreviewIndex].name
                              )
                            ),
                          ]),
                          _vm.imagePreviewList.length > 1
                            ? _c("span", { staticClass: "ml-2 text-caption" }, [
                                _vm._v(
                                  _vm._s(_vm.imagePreviewIndex + 1) +
                                    " / " +
                                    _vm._s(_vm.imagePreviewList.length)
                                ),
                              ])
                            : _vm._e(),
                          _c("v-spacer"),
                          _c(
                            "a",
                            {
                              staticClass: "white--text text-caption",
                              attrs: {
                                href: _vm.imagePreviewList[
                                  _vm.imagePreviewIndex
                                ].url,
                                target: "_blank",
                                rel: "noopener",
                              },
                            },
                            [
                              _c(
                                "v-icon",
                                { attrs: { small: "", color: "white" } },
                                [_vm._v("mdi-open-in-new")]
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
            ]
          ),
          _c(
            "v-dialog",
            {
              attrs: {
                "max-width": "460",
                "content-class": "external-link-dialog",
              },
              model: {
                value: _vm.externalLinkConfirmOpen,
                callback: function ($$v) {
                  _vm.externalLinkConfirmOpen = $$v
                },
                expression: "externalLinkConfirmOpen",
              },
            },
            [
              _c(
                "v-card",
                { staticClass: "external-link-card" },
                [
                  _c("div", { staticClass: "external-link-header" }, [
                    _c(
                      "div",
                      { staticClass: "external-link-icon-wrap" },
                      [
                        _c("v-icon", { staticClass: "external-link-icon" }, [
                          _vm._v("mdi-shield-link-variant-outline"),
                        ]),
                      ],
                      1
                    ),
                    _c("div", { staticClass: "external-link-titles" }, [
                      _c("div", { staticClass: "external-link-title" }, [
                        _vm._v(
                          " " +
                            _vm._s(_vm.$t("ticketing.external-link-title")) +
                            " "
                        ),
                      ]),
                      _c("div", { staticClass: "external-link-subtitle" }, [
                        _vm._v(
                          " " +
                            _vm._s(_vm.$t("ticketing.external-link-subtitle")) +
                            " "
                        ),
                      ]),
                    ]),
                  ]),
                  _c("v-divider"),
                  _c("v-card-text", { staticClass: "external-link-body" }, [
                    _c("p", { staticClass: "external-link-warning" }, [
                      _vm._v(
                        " " +
                          _vm._s(_vm.$t("ticketing.external-link-warning")) +
                          " "
                      ),
                    ]),
                    _c(
                      "div",
                      { staticClass: "external-link-url-wrap" },
                      [
                        _c(
                          "v-icon",
                          {
                            staticClass: "external-link-url-icon",
                            attrs: { small: "" },
                          },
                          [_vm._v("mdi-link-variant")]
                        ),
                        _c("span", {
                          staticClass: "external-link-url",
                          domProps: {
                            innerHTML: _vm._s(
                              _vm.formatUrlForBreaking(_vm.pendingExternalLink)
                            ),
                          },
                        }),
                      ],
                      1
                    ),
                  ]),
                  _c("v-divider"),
                  _c(
                    "v-card-actions",
                    { staticClass: "px-4 py-3" },
                    [
                      _c("v-spacer"),
                      _c(
                        "v-btn",
                        {
                          attrs: { text: "" },
                          on: {
                            click: function ($event) {
                              _vm.externalLinkConfirmOpen = false
                            },
                          },
                        },
                        [_vm._v(" " + _vm._s(_vm.$t("ticketing.cancel")) + " ")]
                      ),
                      _c(
                        "v-btn",
                        {
                          attrs: { color: "primary", depressed: "" },
                          on: { click: _vm.confirmExternalLink },
                        },
                        [
                          _c("v-icon", { attrs: { small: "", left: "" } }, [
                            _vm._v("mdi-open-in-new"),
                          ]),
                          _vm._v(
                            " " +
                              _vm._s(_vm.$t("ticketing.external-link-open")) +
                              " "
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "v-dialog",
            {
              attrs: { "max-width": "420" },
              model: {
                value: _vm.clearAllConfirmOpen,
                callback: function ($$v) {
                  _vm.clearAllConfirmOpen = $$v
                },
                expression: "clearAllConfirmOpen",
              },
            },
            [
              _c(
                "v-card",
                [
                  _c("v-card-title", { staticClass: "text-h6" }, [
                    _vm._v(
                      " " +
                        _vm._s(_vm.$t("ticketing.clear-all-confirm-title")) +
                        " "
                    ),
                  ]),
                  _c("v-card-text", { staticClass: "text-body-2" }, [
                    _vm._v(
                      " " +
                        _vm._s(_vm.$t("ticketing.clear-all-confirm-text")) +
                        " "
                    ),
                  ]),
                  _c(
                    "v-card-actions",
                    [
                      _c("v-spacer"),
                      _c(
                        "v-btn",
                        {
                          attrs: { text: "" },
                          on: {
                            click: function ($event) {
                              _vm.clearAllConfirmOpen = false
                            },
                          },
                        },
                        [_vm._v(" " + _vm._s(_vm.$t("ticketing.cancel")) + " ")]
                      ),
                      _c(
                        "v-btn",
                        {
                          attrs: { color: "red", dark: "" },
                          on: { click: _vm.clearAllNotifications },
                        },
                        [
                          _vm._v(
                            " " + _vm._s(_vm.$t("ticketing.clear-all")) + " "
                          ),
                        ]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "v-dialog",
            {
              attrs: { "max-width": "900", scrollable: "" },
              model: {
                value: _vm.orgTicketsDialog,
                callback: function ($$v) {
                  _vm.orgTicketsDialog = $$v
                },
                expression: "orgTicketsDialog",
              },
            },
            [
              _vm.activeTicket
                ? _c(
                    "v-card",
                    [
                      _c(
                        "v-tabs",
                        {
                          attrs: { grow: "" },
                          model: {
                            value: _vm.orgTicketsTab,
                            callback: function ($$v) {
                              _vm.orgTicketsTab = $$v
                            },
                            expression: "orgTicketsTab",
                          },
                        },
                        [
                          _c("v-tab", [
                            _vm._v(
                              _vm._s(_vm.$t("ticketing.org-tickets-open")) +
                                " (" +
                                _vm._s(_vm.orgOpenTickets.length) +
                                ")"
                            ),
                          ]),
                          _c("v-tab", [
                            _vm._v(
                              _vm._s(_vm.$t("ticketing.org-tickets-closed")) +
                                " (" +
                                _vm._s(_vm.orgClosedTickets.length) +
                                ")"
                            ),
                          ]),
                        ],
                        1
                      ),
                      _c("v-divider"),
                      _c(
                        "v-card-text",
                        {
                          staticClass: "pa-4",
                          staticStyle: { "max-height": "70vh" },
                        },
                        [
                          _c(
                            "v-tabs-items",
                            {
                              model: {
                                value: _vm.orgTicketsTab,
                                callback: function ($$v) {
                                  _vm.orgTicketsTab = $$v
                                },
                                expression: "orgTicketsTab",
                              },
                            },
                            [
                              _c(
                                "v-tab-item",
                                [
                                  _c("v-data-table", {
                                    staticClass: "ticketing-table",
                                    attrs: {
                                      headers: _vm.orgOpenHeaders,
                                      items: _vm.orgOpenTickets,
                                      "items-per-page": -1,
                                      "sort-by": "createdAt",
                                      "sort-desc": false,
                                      "hide-default-footer": "",
                                      dense: "",
                                      "no-data-text": "",
                                    },
                                    on: {
                                      "click:row": _vm.openTicketFromOrgList,
                                    },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "item.type",
                                          fn: function ({ item }) {
                                            return [
                                              _c(
                                                "span",
                                                { staticClass: "text-caption" },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.$t(
                                                        `ticketing.type.${item.type}`
                                                      )
                                                    )
                                                  ),
                                                ]
                                              ),
                                            ]
                                          },
                                        },
                                        {
                                          key: "item.assignedDevopsIds",
                                          fn: function ({ item }) {
                                            return [
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "d-flex align-center",
                                                  staticStyle: {
                                                    overflow: "hidden",
                                                  },
                                                },
                                                [
                                                  _vm._l(
                                                    (
                                                      item.assignedDevopsIds ||
                                                      []
                                                    ).slice(0, 3),
                                                    function (uid, idx) {
                                                      return _c(
                                                        "v-tooltip",
                                                        {
                                                          key: idx,
                                                          attrs: { bottom: "" },
                                                          scopedSlots: _vm._u(
                                                            [
                                                              {
                                                                key: "activator",
                                                                fn: function ({
                                                                  on,
                                                                  attrs,
                                                                }) {
                                                                  return [
                                                                    _c(
                                                                      "v-avatar",
                                                                      _vm._g(
                                                                        _vm._b(
                                                                          {
                                                                            staticClass:
                                                                              "mr-1 flex-shrink-0",
                                                                            attrs:
                                                                              {
                                                                                size: "22",
                                                                                color:
                                                                                  _vm.userColor(
                                                                                    uid
                                                                                  ),
                                                                              },
                                                                          },
                                                                          "v-avatar",
                                                                          attrs,
                                                                          false
                                                                        ),
                                                                        on
                                                                      ),
                                                                      [
                                                                        _c(
                                                                          "span",
                                                                          {
                                                                            staticClass:
                                                                              "white--text text-caption",
                                                                          },
                                                                          [
                                                                            _vm._v(
                                                                              _vm._s(
                                                                                _vm.initials(
                                                                                  _vm.devopsName(
                                                                                    uid
                                                                                  )
                                                                                )
                                                                              )
                                                                            ),
                                                                          ]
                                                                        ),
                                                                      ]
                                                                    ),
                                                                  ]
                                                                },
                                                              },
                                                            ],
                                                            null,
                                                            true
                                                          ),
                                                        },
                                                        [
                                                          _c("span", [
                                                            _vm._v(
                                                              _vm._s(
                                                                _vm.devopsName(
                                                                  uid
                                                                )
                                                              )
                                                            ),
                                                          ]),
                                                        ]
                                                      )
                                                    }
                                                  ),
                                                  (item.assignedDevopsIds || [])
                                                    .length > 3
                                                    ? _c(
                                                        "v-tooltip",
                                                        {
                                                          attrs: { bottom: "" },
                                                          scopedSlots: _vm._u(
                                                            [
                                                              {
                                                                key: "activator",
                                                                fn: function ({
                                                                  on,
                                                                  attrs,
                                                                }) {
                                                                  return [
                                                                    _c(
                                                                      "span",
                                                                      _vm._g(
                                                                        _vm._b(
                                                                          {
                                                                            staticClass:
                                                                              "text-caption grey--text",
                                                                          },
                                                                          "span",
                                                                          attrs,
                                                                          false
                                                                        ),
                                                                        on
                                                                      ),
                                                                      [
                                                                        _vm._v(
                                                                          "+" +
                                                                            _vm._s(
                                                                              item
                                                                                .assignedDevopsIds
                                                                                .length -
                                                                                3
                                                                            )
                                                                        ),
                                                                      ]
                                                                    ),
                                                                  ]
                                                                },
                                                              },
                                                            ],
                                                            null,
                                                            true
                                                          ),
                                                        },
                                                        [
                                                          _c("span", [
                                                            _vm._v(
                                                              _vm._s(
                                                                item.assignedDevopsIds
                                                                  .slice(3)
                                                                  .map(
                                                                    _vm.devopsName
                                                                  )
                                                                  .join(", ")
                                                              )
                                                            ),
                                                          ]),
                                                        ]
                                                      )
                                                    : _vm._e(),
                                                  !item.assignedDevopsIds
                                                    ?.length
                                                    ? _c(
                                                        "span",
                                                        {
                                                          staticClass:
                                                            "text-caption grey--text",
                                                        },
                                                        [_vm._v("-")]
                                                      )
                                                    : _vm._e(),
                                                ],
                                                2
                                              ),
                                            ]
                                          },
                                        },
                                        {
                                          key: "item.watcherIds",
                                          fn: function ({ item }) {
                                            return [
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "d-flex align-center",
                                                  staticStyle: {
                                                    overflow: "hidden",
                                                  },
                                                },
                                                [
                                                  _vm._l(
                                                    (
                                                      item.watcherIds || []
                                                    ).slice(0, 3),
                                                    function (uid, idx) {
                                                      return _c(
                                                        "v-tooltip",
                                                        {
                                                          key: idx,
                                                          attrs: { bottom: "" },
                                                          scopedSlots: _vm._u(
                                                            [
                                                              {
                                                                key: "activator",
                                                                fn: function ({
                                                                  on,
                                                                  attrs,
                                                                }) {
                                                                  return [
                                                                    _c(
                                                                      "v-avatar",
                                                                      _vm._g(
                                                                        _vm._b(
                                                                          {
                                                                            staticClass:
                                                                              "mr-1 flex-shrink-0",
                                                                            attrs:
                                                                              {
                                                                                size: "22",
                                                                                color:
                                                                                  _vm.userColor(
                                                                                    uid
                                                                                  ),
                                                                              },
                                                                          },
                                                                          "v-avatar",
                                                                          attrs,
                                                                          false
                                                                        ),
                                                                        on
                                                                      ),
                                                                      [
                                                                        _c(
                                                                          "span",
                                                                          {
                                                                            staticClass:
                                                                              "white--text text-caption",
                                                                          },
                                                                          [
                                                                            _vm._v(
                                                                              _vm._s(
                                                                                _vm.initials(
                                                                                  _vm.devopsName(
                                                                                    uid
                                                                                  )
                                                                                )
                                                                              )
                                                                            ),
                                                                          ]
                                                                        ),
                                                                      ]
                                                                    ),
                                                                  ]
                                                                },
                                                              },
                                                            ],
                                                            null,
                                                            true
                                                          ),
                                                        },
                                                        [
                                                          _c("span", [
                                                            _vm._v(
                                                              _vm._s(
                                                                _vm.devopsName(
                                                                  uid
                                                                )
                                                              )
                                                            ),
                                                          ]),
                                                        ]
                                                      )
                                                    }
                                                  ),
                                                  (item.watcherIds || [])
                                                    .length > 3
                                                    ? _c(
                                                        "v-tooltip",
                                                        {
                                                          attrs: { bottom: "" },
                                                          scopedSlots: _vm._u(
                                                            [
                                                              {
                                                                key: "activator",
                                                                fn: function ({
                                                                  on,
                                                                  attrs,
                                                                }) {
                                                                  return [
                                                                    _c(
                                                                      "span",
                                                                      _vm._g(
                                                                        _vm._b(
                                                                          {
                                                                            staticClass:
                                                                              "text-caption grey--text",
                                                                          },
                                                                          "span",
                                                                          attrs,
                                                                          false
                                                                        ),
                                                                        on
                                                                      ),
                                                                      [
                                                                        _vm._v(
                                                                          "+" +
                                                                            _vm._s(
                                                                              item
                                                                                .watcherIds
                                                                                .length -
                                                                                3
                                                                            )
                                                                        ),
                                                                      ]
                                                                    ),
                                                                  ]
                                                                },
                                                              },
                                                            ],
                                                            null,
                                                            true
                                                          ),
                                                        },
                                                        [
                                                          _c("span", [
                                                            _vm._v(
                                                              _vm._s(
                                                                item.watcherIds
                                                                  .slice(3)
                                                                  .map(
                                                                    _vm.devopsName
                                                                  )
                                                                  .join(", ")
                                                              )
                                                            ),
                                                          ]),
                                                        ]
                                                      )
                                                    : _vm._e(),
                                                  !item.watcherIds?.length
                                                    ? _c(
                                                        "span",
                                                        {
                                                          staticClass:
                                                            "text-caption grey--text",
                                                        },
                                                        [_vm._v("-")]
                                                      )
                                                    : _vm._e(),
                                                ],
                                                2
                                              ),
                                            ]
                                          },
                                        },
                                        {
                                          key: "item.status",
                                          fn: function ({ item }) {
                                            return [
                                              _c(
                                                "span",
                                                { staticClass: "text-caption" },
                                                [
                                                  _vm._v(
                                                    " " +
                                                      _vm._s(
                                                        _vm.$t(
                                                          `ticketing.status.${item.status}`
                                                        )
                                                      ) +
                                                      " "
                                                  ),
                                                ]
                                              ),
                                            ]
                                          },
                                        },
                                        {
                                          key: "item.priority",
                                          fn: function ({ item }) {
                                            return [
                                              _c(
                                                "span",
                                                {
                                                  staticClass:
                                                    "text-caption font-weight-medium",
                                                  style: {
                                                    color: _vm.priorityHex(
                                                      item.priority
                                                    ),
                                                  },
                                                },
                                                [
                                                  _vm._v(
                                                    " " +
                                                      _vm._s(
                                                        _vm.priorityEmoji(
                                                          item.priority
                                                        )
                                                      ) +
                                                      "  " +
                                                      _vm._s(
                                                        _vm.$t(
                                                          `ticketing.priority.${item.priority}`
                                                        )
                                                      ) +
                                                      " "
                                                  ),
                                                ]
                                              ),
                                            ]
                                          },
                                        },
                                        {
                                          key: "item.createdAt",
                                          fn: function ({ item }) {
                                            return [
                                              _c(
                                                "span",
                                                {
                                                  directives: [
                                                    {
                                                      name: "cursor-tip",
                                                      rawName: "v-cursor-tip",
                                                      value:
                                                        _vm.formatTimeAbsolute(
                                                          item.createdAt
                                                        ),
                                                      expression:
                                                        "formatTimeAbsolute(item.createdAt)",
                                                    },
                                                  ],
                                                  staticClass: "text-caption",
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.formatTime(
                                                        item.createdAt
                                                      )
                                                    )
                                                  ),
                                                ]
                                              ),
                                            ]
                                          },
                                        },
                                      ],
                                      null,
                                      false,
                                      2074085373
                                    ),
                                  }),
                                ],
                                1
                              ),
                              _c(
                                "v-tab-item",
                                [
                                  _c("v-data-table", {
                                    staticClass: "ticketing-table",
                                    attrs: {
                                      headers: _vm.orgClosedHeaders,
                                      items: _vm.orgClosedTickets,
                                      "items-per-page": -1,
                                      "sort-by": "createdAt",
                                      "sort-desc": false,
                                      "hide-default-footer": "",
                                      dense: "",
                                      "no-data-text": "",
                                    },
                                    on: {
                                      "click:row": _vm.openTicketFromOrgList,
                                    },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "item.type",
                                          fn: function ({ item }) {
                                            return [
                                              _c(
                                                "span",
                                                { staticClass: "text-caption" },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.$t(
                                                        `ticketing.type.${item.type}`
                                                      )
                                                    )
                                                  ),
                                                ]
                                              ),
                                            ]
                                          },
                                        },
                                        {
                                          key: "item.assignedDevopsIds",
                                          fn: function ({ item }) {
                                            return [
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "d-flex align-center",
                                                  staticStyle: {
                                                    overflow: "hidden",
                                                  },
                                                },
                                                [
                                                  _vm._l(
                                                    (
                                                      item.assignedDevopsIds ||
                                                      []
                                                    ).slice(0, 3),
                                                    function (uid, idx) {
                                                      return _c(
                                                        "v-tooltip",
                                                        {
                                                          key: idx,
                                                          attrs: { bottom: "" },
                                                          scopedSlots: _vm._u(
                                                            [
                                                              {
                                                                key: "activator",
                                                                fn: function ({
                                                                  on,
                                                                  attrs,
                                                                }) {
                                                                  return [
                                                                    _c(
                                                                      "v-avatar",
                                                                      _vm._g(
                                                                        _vm._b(
                                                                          {
                                                                            staticClass:
                                                                              "mr-1 flex-shrink-0",
                                                                            attrs:
                                                                              {
                                                                                size: "22",
                                                                                color:
                                                                                  _vm.userColor(
                                                                                    uid
                                                                                  ),
                                                                              },
                                                                          },
                                                                          "v-avatar",
                                                                          attrs,
                                                                          false
                                                                        ),
                                                                        on
                                                                      ),
                                                                      [
                                                                        _c(
                                                                          "span",
                                                                          {
                                                                            staticClass:
                                                                              "white--text text-caption",
                                                                          },
                                                                          [
                                                                            _vm._v(
                                                                              _vm._s(
                                                                                _vm.initials(
                                                                                  _vm.devopsName(
                                                                                    uid
                                                                                  )
                                                                                )
                                                                              )
                                                                            ),
                                                                          ]
                                                                        ),
                                                                      ]
                                                                    ),
                                                                  ]
                                                                },
                                                              },
                                                            ],
                                                            null,
                                                            true
                                                          ),
                                                        },
                                                        [
                                                          _c("span", [
                                                            _vm._v(
                                                              _vm._s(
                                                                _vm.devopsName(
                                                                  uid
                                                                )
                                                              )
                                                            ),
                                                          ]),
                                                        ]
                                                      )
                                                    }
                                                  ),
                                                  (item.assignedDevopsIds || [])
                                                    .length > 3
                                                    ? _c(
                                                        "v-tooltip",
                                                        {
                                                          attrs: { bottom: "" },
                                                          scopedSlots: _vm._u(
                                                            [
                                                              {
                                                                key: "activator",
                                                                fn: function ({
                                                                  on,
                                                                  attrs,
                                                                }) {
                                                                  return [
                                                                    _c(
                                                                      "span",
                                                                      _vm._g(
                                                                        _vm._b(
                                                                          {
                                                                            staticClass:
                                                                              "text-caption grey--text",
                                                                          },
                                                                          "span",
                                                                          attrs,
                                                                          false
                                                                        ),
                                                                        on
                                                                      ),
                                                                      [
                                                                        _vm._v(
                                                                          "+" +
                                                                            _vm._s(
                                                                              item
                                                                                .assignedDevopsIds
                                                                                .length -
                                                                                3
                                                                            )
                                                                        ),
                                                                      ]
                                                                    ),
                                                                  ]
                                                                },
                                                              },
                                                            ],
                                                            null,
                                                            true
                                                          ),
                                                        },
                                                        [
                                                          _c("span", [
                                                            _vm._v(
                                                              _vm._s(
                                                                item.assignedDevopsIds
                                                                  .slice(3)
                                                                  .map(
                                                                    _vm.devopsName
                                                                  )
                                                                  .join(", ")
                                                              )
                                                            ),
                                                          ]),
                                                        ]
                                                      )
                                                    : _vm._e(),
                                                  !item.assignedDevopsIds
                                                    ?.length
                                                    ? _c(
                                                        "span",
                                                        {
                                                          staticClass:
                                                            "text-caption grey--text",
                                                        },
                                                        [_vm._v("-")]
                                                      )
                                                    : _vm._e(),
                                                ],
                                                2
                                              ),
                                            ]
                                          },
                                        },
                                        {
                                          key: "item.watcherIds",
                                          fn: function ({ item }) {
                                            return [
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "d-flex align-center",
                                                  staticStyle: {
                                                    overflow: "hidden",
                                                  },
                                                },
                                                [
                                                  _vm._l(
                                                    (
                                                      item.watcherIds || []
                                                    ).slice(0, 3),
                                                    function (uid, idx) {
                                                      return _c(
                                                        "v-tooltip",
                                                        {
                                                          key: idx,
                                                          attrs: { bottom: "" },
                                                          scopedSlots: _vm._u(
                                                            [
                                                              {
                                                                key: "activator",
                                                                fn: function ({
                                                                  on,
                                                                  attrs,
                                                                }) {
                                                                  return [
                                                                    _c(
                                                                      "v-avatar",
                                                                      _vm._g(
                                                                        _vm._b(
                                                                          {
                                                                            staticClass:
                                                                              "mr-1 flex-shrink-0",
                                                                            attrs:
                                                                              {
                                                                                size: "22",
                                                                                color:
                                                                                  _vm.userColor(
                                                                                    uid
                                                                                  ),
                                                                              },
                                                                          },
                                                                          "v-avatar",
                                                                          attrs,
                                                                          false
                                                                        ),
                                                                        on
                                                                      ),
                                                                      [
                                                                        _c(
                                                                          "span",
                                                                          {
                                                                            staticClass:
                                                                              "white--text text-caption",
                                                                          },
                                                                          [
                                                                            _vm._v(
                                                                              _vm._s(
                                                                                _vm.initials(
                                                                                  _vm.devopsName(
                                                                                    uid
                                                                                  )
                                                                                )
                                                                              )
                                                                            ),
                                                                          ]
                                                                        ),
                                                                      ]
                                                                    ),
                                                                  ]
                                                                },
                                                              },
                                                            ],
                                                            null,
                                                            true
                                                          ),
                                                        },
                                                        [
                                                          _c("span", [
                                                            _vm._v(
                                                              _vm._s(
                                                                _vm.devopsName(
                                                                  uid
                                                                )
                                                              )
                                                            ),
                                                          ]),
                                                        ]
                                                      )
                                                    }
                                                  ),
                                                  (item.watcherIds || [])
                                                    .length > 3
                                                    ? _c(
                                                        "v-tooltip",
                                                        {
                                                          attrs: { bottom: "" },
                                                          scopedSlots: _vm._u(
                                                            [
                                                              {
                                                                key: "activator",
                                                                fn: function ({
                                                                  on,
                                                                  attrs,
                                                                }) {
                                                                  return [
                                                                    _c(
                                                                      "span",
                                                                      _vm._g(
                                                                        _vm._b(
                                                                          {
                                                                            staticClass:
                                                                              "text-caption grey--text",
                                                                          },
                                                                          "span",
                                                                          attrs,
                                                                          false
                                                                        ),
                                                                        on
                                                                      ),
                                                                      [
                                                                        _vm._v(
                                                                          "+" +
                                                                            _vm._s(
                                                                              item
                                                                                .watcherIds
                                                                                .length -
                                                                                3
                                                                            )
                                                                        ),
                                                                      ]
                                                                    ),
                                                                  ]
                                                                },
                                                              },
                                                            ],
                                                            null,
                                                            true
                                                          ),
                                                        },
                                                        [
                                                          _c("span", [
                                                            _vm._v(
                                                              _vm._s(
                                                                item.watcherIds
                                                                  .slice(3)
                                                                  .map(
                                                                    _vm.devopsName
                                                                  )
                                                                  .join(", ")
                                                              )
                                                            ),
                                                          ]),
                                                        ]
                                                      )
                                                    : _vm._e(),
                                                  !item.watcherIds?.length
                                                    ? _c(
                                                        "span",
                                                        {
                                                          staticClass:
                                                            "text-caption grey--text",
                                                        },
                                                        [_vm._v("-")]
                                                      )
                                                    : _vm._e(),
                                                ],
                                                2
                                              ),
                                            ]
                                          },
                                        },
                                        {
                                          key: "item.createdAt",
                                          fn: function ({ item }) {
                                            return [
                                              _c(
                                                "span",
                                                {
                                                  directives: [
                                                    {
                                                      name: "cursor-tip",
                                                      rawName: "v-cursor-tip",
                                                      value:
                                                        _vm.formatTimeAbsolute(
                                                          item.createdAt
                                                        ),
                                                      expression:
                                                        "formatTimeAbsolute(item.createdAt)",
                                                    },
                                                  ],
                                                  staticClass: "text-caption",
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.formatTime(
                                                        item.createdAt
                                                      )
                                                    )
                                                  ),
                                                ]
                                              ),
                                            ]
                                          },
                                        },
                                      ],
                                      null,
                                      false,
                                      4001199400
                                    ),
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
            ],
            1
          ),
          _c(
            "v-dialog",
            {
              attrs: { "max-width": "540", persistent: "" },
              model: {
                value: _vm.contactDialog,
                callback: function ($$v) {
                  _vm.contactDialog = $$v
                },
                expression: "contactDialog",
              },
            },
            [
              _vm.contactDraft
                ? _c(
                    "v-card",
                    [
                      _c("v-card-title", { staticClass: "text-h6" }, [
                        _vm._v(
                          " " +
                            _vm._s(
                              _vm.contactDraftKind === "admin"
                                ? _vm.$t("ticketing.contacts.edit-admin")
                                : _vm.$t("ticketing.contacts.edit-tech")
                            ) +
                            " "
                        ),
                      ]),
                      _c(
                        "v-card-text",
                        [
                          _c(
                            "v-form",
                            {
                              ref: "contactForm",
                              model: {
                                value: _vm.contactFormValid,
                                callback: function ($$v) {
                                  _vm.contactFormValid = $$v
                                },
                                expression: "contactFormValid",
                              },
                            },
                            [
                              _vm.contactDraftKind === "admin"
                                ? _c("v-autocomplete", {
                                    staticClass: "mb-5",
                                    attrs: {
                                      items: _vm.orgUsers,
                                      "item-text": _vm.adminUserItemText,
                                      filter: _vm.adminUserSearchFilter,
                                      label: _vm.$t(
                                        "ticketing.contacts.search-org-user"
                                      ),
                                      placeholder: _vm.$t(
                                        "ticketing.contacts.search-org-user-hint"
                                      ),
                                      "return-object": "",
                                      clearable: "",
                                      "hide-no-data": "",
                                      "hide-details": "auto",
                                      dense: "",
                                      outlined: "",
                                      "prepend-inner-icon": "mdi-magnify",
                                      loading: _vm.orgUsersLoading,
                                    },
                                    on: {
                                      change: _vm.applyAdminUserAutocomplete,
                                    },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "item",
                                          fn: function ({ item }) {
                                            return [
                                              _c(
                                                "v-list-item-content",
                                                [
                                                  _c("v-list-item-title", [
                                                    _vm._v(
                                                      _vm._s(
                                                        item.fullName ||
                                                          _vm.$t(
                                                            "ticketing.contacts.unnamed"
                                                          )
                                                      )
                                                    ),
                                                  ]),
                                                  _c("v-list-item-subtitle", [
                                                    item.email
                                                      ? _c("span", [
                                                          _vm._v(
                                                            _vm._s(item.email)
                                                          ),
                                                        ])
                                                      : _vm._e(),
                                                    item.role
                                                      ? _c("span", [
                                                          _vm._v(
                                                            " · " +
                                                              _vm._s(item.role)
                                                          ),
                                                        ])
                                                      : _vm._e(),
                                                  ]),
                                                ],
                                                1
                                              ),
                                            ]
                                          },
                                        },
                                      ],
                                      null,
                                      false,
                                      2905970332
                                    ),
                                  })
                                : _vm._e(),
                              _vm.contactDraftKind === "admin"
                                ? _c("v-divider", { staticClass: "mb-5" })
                                : _vm._e(),
                              _vm.contactDraftKind === "tech"
                                ? _c("v-autocomplete", {
                                    staticClass: "mb-5",
                                    attrs: {
                                      items: _vm.globalTechContacts,
                                      "item-text": _vm.techContactItemText,
                                      filter: _vm.techContactSearchFilter,
                                      label: _vm.$t(
                                        "ticketing.contacts.search-existing"
                                      ),
                                      placeholder: _vm.$t(
                                        "ticketing.contacts.search-existing-hint"
                                      ),
                                      "return-object": "",
                                      clearable: "",
                                      "hide-no-data": "",
                                      "hide-details": "auto",
                                      dense: "",
                                      outlined: "",
                                      "prepend-inner-icon": "mdi-magnify",
                                    },
                                    on: { change: _vm.applyTechAutocomplete },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "item",
                                          fn: function ({ item }) {
                                            return [
                                              _c(
                                                "v-list-item-content",
                                                [
                                                  _c("v-list-item-title", [
                                                    _vm._v(
                                                      _vm._s(
                                                        item.fullName ||
                                                          _vm.$t(
                                                            "ticketing.contacts.unnamed"
                                                          )
                                                      )
                                                    ),
                                                  ]),
                                                  _c("v-list-item-subtitle", [
                                                    item.businessName
                                                      ? _c("span", [
                                                          _vm._v(
                                                            _vm._s(
                                                              item.businessName
                                                            ) + " · "
                                                          ),
                                                        ])
                                                      : _vm._e(),
                                                    _c("span", [
                                                      _vm._v(
                                                        _vm._s(
                                                          item.primaryValue
                                                        )
                                                      ),
                                                    ]),
                                                    item.secondaryValue
                                                      ? _c("span", [
                                                          _vm._v(
                                                            " · " +
                                                              _vm._s(
                                                                item.secondaryValue
                                                              )
                                                          ),
                                                        ])
                                                      : _vm._e(),
                                                  ]),
                                                ],
                                                1
                                              ),
                                            ]
                                          },
                                        },
                                      ],
                                      null,
                                      false,
                                      196919790
                                    ),
                                  })
                                : _vm._e(),
                              _vm.contactDraftKind === "tech"
                                ? _c("v-divider", { staticClass: "mb-5" })
                                : _vm._e(),
                              _vm.contactDraftKind === "tech"
                                ? _c("v-text-field", {
                                    staticClass: "mb-3",
                                    attrs: {
                                      label: _vm.$t(
                                        "ticketing.contacts.business-name"
                                      ),
                                      dense: "",
                                      outlined: "",
                                      "hide-details": "auto",
                                    },
                                    model: {
                                      value: _vm.contactDraft.businessName,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.contactDraft,
                                          "businessName",
                                          $$v
                                        )
                                      },
                                      expression: "contactDraft.businessName",
                                    },
                                  })
                                : _vm._e(),
                              _c("v-text-field", {
                                staticClass: "mb-3",
                                attrs: {
                                  label: _vm.$t("ticketing.contacts.full-name"),
                                  rules:
                                    _vm.contactDraftKind === "admin"
                                      ? [(v) => !!v || _vm.$t("required")]
                                      : [],
                                  dense: "",
                                  outlined: "",
                                  "hide-details": "auto",
                                },
                                model: {
                                  value: _vm.contactDraft.fullName,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.contactDraft, "fullName", $$v)
                                  },
                                  expression: "contactDraft.fullName",
                                },
                              }),
                              _vm.contactDraftKind === "admin"
                                ? _c("v-text-field", {
                                    staticClass: "mb-5",
                                    attrs: {
                                      label: _vm.$t(
                                        "ticketing.contacts.contact-title"
                                      ),
                                      dense: "",
                                      outlined: "",
                                      "hide-details": "auto",
                                    },
                                    model: {
                                      value: _vm.contactDraft.title,
                                      callback: function ($$v) {
                                        _vm.$set(_vm.contactDraft, "title", $$v)
                                      },
                                      expression: "contactDraft.title",
                                    },
                                  })
                                : _vm._e(),
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "text-caption font-weight-medium mb-1",
                                },
                                [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm.$t(
                                          "ticketing.contacts.preferred-method"
                                        )
                                      ) +
                                      " "
                                  ),
                                ]
                              ),
                              _c(
                                "v-row",
                                { attrs: { dense: "" } },
                                [
                                  _c(
                                    "v-col",
                                    { attrs: { cols: "4" } },
                                    [
                                      _c("v-select", {
                                        attrs: {
                                          value: _vm.contactDraft.primaryMethod,
                                          items: _vm.contactMethodOptions,
                                          dense: "",
                                          outlined: "",
                                          "hide-details": "",
                                        },
                                        on: {
                                          change: (v) =>
                                            _vm.onContactMethodChange(
                                              "primary",
                                              v
                                            ),
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                  _c(
                                    "v-col",
                                    { attrs: { cols: "8" } },
                                    [
                                      _vm.isPhoneMethod(
                                        _vm.contactDraft.primaryMethod
                                      )
                                        ? _c("v-text-field", {
                                            staticClass: "contact-phone-field",
                                            attrs: {
                                              label: _vm.contactValueLabel(
                                                _vm.contactDraft.primaryMethod
                                              ),
                                              dense: "",
                                              outlined: "",
                                              "hide-details": "",
                                            },
                                            scopedSlots: _vm._u(
                                              [
                                                {
                                                  key: "prepend-inner",
                                                  fn: function () {
                                                    return [
                                                      _c(
                                                        "vue-tel-input-vuetify",
                                                        {
                                                          attrs: {
                                                            "only-countries":
                                                              _vm.phoneAvailableCountries,
                                                            "default-country":
                                                              "CA",
                                                            "append-icon":
                                                              "mdi-chevron-down",
                                                            dense: "",
                                                            "disabled-fetching-country":
                                                              "",
                                                            "select-classes":
                                                              "select-phone",
                                                            "text-field-classes":
                                                              "input-phone",
                                                          },
                                                          on: {
                                                            input: (_, obj) =>
                                                              _vm.onContactPhoneInput(
                                                                "primary",
                                                                obj
                                                              ),
                                                          },
                                                          model: {
                                                            value:
                                                              _vm.contactDraft
                                                                .primaryValue,
                                                            callback: function (
                                                              $$v
                                                            ) {
                                                              _vm.$set(
                                                                _vm.contactDraft,
                                                                "primaryValue",
                                                                $$v
                                                              )
                                                            },
                                                            expression:
                                                              "contactDraft.primaryValue",
                                                          },
                                                        }
                                                      ),
                                                    ]
                                                  },
                                                  proxy: true,
                                                },
                                              ],
                                              null,
                                              false,
                                              4009378785
                                            ),
                                            model: {
                                              value:
                                                _vm.contactDraft.primaryValue,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.contactDraft,
                                                  "primaryValue",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "contactDraft.primaryValue",
                                            },
                                          })
                                        : _c("v-text-field", {
                                            attrs: {
                                              label: _vm.contactValueLabel(
                                                _vm.contactDraft.primaryMethod
                                              ),
                                              dense: "",
                                              outlined: "",
                                              "hide-details": "",
                                            },
                                            model: {
                                              value:
                                                _vm.contactDraft.primaryValue,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.contactDraft,
                                                  "primaryValue",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "contactDraft.primaryValue",
                                            },
                                          }),
                                    ],
                                    1
                                  ),
                                  _vm.contactDraft.primaryMethod === "call"
                                    ? _c(
                                        "v-col",
                                        { attrs: { cols: "12" } },
                                        [
                                          _c("v-text-field", {
                                            attrs: {
                                              label: _vm.$t(
                                                "ticketing.contacts.extension"
                                              ),
                                              dense: "",
                                              outlined: "",
                                              "hide-details": "",
                                            },
                                            model: {
                                              value:
                                                _vm.contactDraft
                                                  .primaryExtension,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.contactDraft,
                                                  "primaryExtension",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "contactDraft.primaryExtension",
                                            },
                                          }),
                                        ],
                                        1
                                      )
                                    : _vm._e(),
                                ],
                                1
                              ),
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "text-caption font-weight-medium mb-1 mt-5",
                                },
                                [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm.$t(
                                          "ticketing.contacts.secondary-method"
                                        )
                                      ) +
                                      " "
                                  ),
                                ]
                              ),
                              _c(
                                "v-row",
                                { attrs: { dense: "" } },
                                [
                                  _c(
                                    "v-col",
                                    { attrs: { cols: "4" } },
                                    [
                                      _c("v-select", {
                                        attrs: {
                                          value:
                                            _vm.contactDraft.secondaryMethod,
                                          items:
                                            _vm.contactMethodOptionsWithNone,
                                          dense: "",
                                          outlined: "",
                                          "hide-details": "",
                                          clearable: "",
                                        },
                                        on: {
                                          change: (v) =>
                                            _vm.onContactMethodChange(
                                              "secondary",
                                              v
                                            ),
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                  _c(
                                    "v-col",
                                    { attrs: { cols: "8" } },
                                    [
                                      _vm.isPhoneMethod(
                                        _vm.contactDraft.secondaryMethod
                                      )
                                        ? _c("v-text-field", {
                                            staticClass: "contact-phone-field",
                                            attrs: {
                                              label: _vm.contactValueLabel(
                                                _vm.contactDraft.secondaryMethod
                                              ),
                                              dense: "",
                                              outlined: "",
                                              "hide-details": "",
                                            },
                                            scopedSlots: _vm._u(
                                              [
                                                {
                                                  key: "prepend-inner",
                                                  fn: function () {
                                                    return [
                                                      _c(
                                                        "vue-tel-input-vuetify",
                                                        {
                                                          attrs: {
                                                            "only-countries":
                                                              _vm.phoneAvailableCountries,
                                                            "default-country":
                                                              "CA",
                                                            "append-icon":
                                                              "mdi-chevron-down",
                                                            dense: "",
                                                            "disabled-fetching-country":
                                                              "",
                                                            "select-classes":
                                                              "select-phone",
                                                            "text-field-classes":
                                                              "input-phone",
                                                          },
                                                          on: {
                                                            input: (_, obj) =>
                                                              _vm.onContactPhoneInput(
                                                                "secondary",
                                                                obj
                                                              ),
                                                          },
                                                          model: {
                                                            value:
                                                              _vm.contactDraft
                                                                .secondaryValue,
                                                            callback: function (
                                                              $$v
                                                            ) {
                                                              _vm.$set(
                                                                _vm.contactDraft,
                                                                "secondaryValue",
                                                                $$v
                                                              )
                                                            },
                                                            expression:
                                                              "contactDraft.secondaryValue",
                                                          },
                                                        }
                                                      ),
                                                    ]
                                                  },
                                                  proxy: true,
                                                },
                                              ],
                                              null,
                                              false,
                                              277936929
                                            ),
                                            model: {
                                              value:
                                                _vm.contactDraft.secondaryValue,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.contactDraft,
                                                  "secondaryValue",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "contactDraft.secondaryValue",
                                            },
                                          })
                                        : _c("v-text-field", {
                                            attrs: {
                                              label: _vm.contactValueLabel(
                                                _vm.contactDraft.secondaryMethod
                                              ),
                                              disabled:
                                                !_vm.contactDraft
                                                  .secondaryMethod,
                                              dense: "",
                                              outlined: "",
                                              "hide-details": "",
                                            },
                                            model: {
                                              value:
                                                _vm.contactDraft.secondaryValue,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.contactDraft,
                                                  "secondaryValue",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "contactDraft.secondaryValue",
                                            },
                                          }),
                                    ],
                                    1
                                  ),
                                  _vm.contactDraft.secondaryMethod === "call"
                                    ? _c(
                                        "v-col",
                                        { attrs: { cols: "12" } },
                                        [
                                          _c("v-text-field", {
                                            attrs: {
                                              label: _vm.$t(
                                                "ticketing.contacts.extension"
                                              ),
                                              dense: "",
                                              outlined: "",
                                              "hide-details": "",
                                            },
                                            model: {
                                              value:
                                                _vm.contactDraft
                                                  .secondaryExtension,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.contactDraft,
                                                  "secondaryExtension",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "contactDraft.secondaryExtension",
                                            },
                                          }),
                                        ],
                                        1
                                      )
                                    : _vm._e(),
                                ],
                                1
                              ),
                              _vm.contactDraftKind === "tech"
                                ? _c("v-select", {
                                    staticClass: "mt-3",
                                    attrs: {
                                      items: _vm.consentOptions,
                                      label: _vm.$t(
                                        "ticketing.contacts.consent"
                                      ),
                                      dense: "",
                                      outlined: "",
                                      "hide-details": "",
                                    },
                                    model: {
                                      value: _vm.contactDraft.consent,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.contactDraft,
                                          "consent",
                                          $$v
                                        )
                                      },
                                      expression: "contactDraft.consent",
                                    },
                                  })
                                : _vm._e(),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "v-card-actions",
                        [
                          _c("v-spacer"),
                          _c(
                            "v-btn",
                            {
                              attrs: { text: "" },
                              on: {
                                click: function ($event) {
                                  _vm.contactDialog = false
                                },
                              },
                            },
                            [
                              _vm._v(
                                " " + _vm._s(_vm.$t("ticketing.cancel")) + " "
                              ),
                            ]
                          ),
                          _c(
                            "v-btn",
                            {
                              attrs: {
                                color: "primary",
                                disabled: !_vm.contactFormValid,
                                loading: _vm.contactSaving,
                              },
                              on: { click: _vm.saveContactDraft },
                            },
                            [_vm._v(" " + _vm._s(_vm.$t("save")) + " ")]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
            ],
            1
          ),
          _c(
            "v-dialog",
            {
              attrs: { "max-width": "420" },
              model: {
                value: _vm.contactDeleteConfirm,
                callback: function ($$v) {
                  _vm.contactDeleteConfirm = $$v
                },
                expression: "contactDeleteConfirm",
              },
            },
            [
              _c(
                "v-card",
                [
                  _c("v-card-title", { staticClass: "text-h6" }, [
                    _vm._v(
                      " " +
                        _vm._s(_vm.$t("ticketing.contacts.delete-confirm")) +
                        " "
                    ),
                  ]),
                  _c(
                    "v-card-actions",
                    [
                      _c("v-spacer"),
                      _c(
                        "v-btn",
                        {
                          attrs: { text: "" },
                          on: {
                            click: function ($event) {
                              _vm.contactDeleteConfirm = false
                            },
                          },
                        },
                        [_vm._v(" " + _vm._s(_vm.$t("ticketing.cancel")) + " ")]
                      ),
                      _c(
                        "v-btn",
                        {
                          attrs: {
                            color: "red",
                            dark: "",
                            loading: _vm.contactSaving,
                          },
                          on: { click: _vm.deleteContactConfirmed },
                        },
                        [_vm._v(" " + _vm._s(_vm.$t("delete")) + " ")]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        2
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }